import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any; }
  /** A field whose value is a hex color code: https://en.wikipedia.org/wiki/Web_colors. */
  HexColorCode: { input: any; output: any; }
  /** The locale in the format of a BCP 47 (RFC 5646) standard string */
  Locale: { input: any; output: any; }
};

export type Activity = {
  __typename?: 'Activity';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  targets?: Maybe<Array<ActivityTarget>>;
  topic: ActivityTopic;
  user: User;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type ActivityArgsFilter = {
  target?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  topics?: InputMaybe<Array<ActivityTopic>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type ActivityArgsSorter = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type ActivityOverviewEntry = {
  __typename?: 'ActivityOverviewEntry';
  connections: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
  documentViews: Scalars['Int']['output'];
  questions: Scalars['Int']['output'];
};

export enum ActivityStatus {
  Idle = 'Idle',
  Offline = 'Offline',
  Online = 'Online'
}

export type ActivityTarget = Group | Question | Resource | User | Workspace;

export enum ActivityTopic {
  GroupCreate = 'Group_Create',
  ResourceBulkDownload = 'Resource_BulkDownload',
  ResourceCopy = 'Resource_Copy',
  ResourceCreate = 'Resource_Create',
  ResourceDelete = 'Resource_Delete',
  ResourceDownload = 'Resource_Download',
  ResourceMove = 'Resource_Move',
  ResourceRedact = 'Resource_Redact',
  ResourceRename = 'Resource_Rename',
  ResourceView = 'Resource_View',
  SupportAnswer = 'Support_Answer',
  SupportAnswerDeleted = 'Support_Answer_Deleted',
  SupportAnswerEdit = 'Support_Answer_Edit',
  SupportAnswerView = 'Support_Answer_View',
  SupportAttachment = 'Support_Attachment',
  SupportDeleted = 'Support_Deleted',
  SupportEdit = 'Support_Edit',
  SupportFollowUpAnswer = 'Support_Follow_Up_Answer',
  SupportQuestion = 'Support_Question',
  SupportQuestionView = 'Support_Question_View',
  SupportResolved = 'Support_Resolved',
  SupportUnresolved = 'Support_Unresolved',
  UserLogin = 'User_Login',
  WorkspaceLive = 'Workspace_Live',
  WorkspaceOffline = 'Workspace_Offline',
  WorkspaceSupportEditable = 'Workspace_Support_Editable',
  WorkspaceSupportReadonly = 'Workspace_Support_Readonly',
  WorkspaceVisit = 'Workspace_Visit'
}

export type AddUserToWorkspaceInput = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  userEmail: Scalars['EmailAddress']['input'];
};

export type Analytic = {
  __typename?: 'Analytic';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  totalDownloads: Scalars['Int']['output'];
  totalFiles: Scalars['Int']['output'];
  totalFilesAdded: Scalars['Int']['output'];
  totalGroups: Scalars['Int']['output'];
  totalGroupsAdded: Scalars['Int']['output'];
  totalUploads: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  totalUsersAdded: Scalars['Int']['output'];
  totalViews: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
};

export type Answer = {
  __typename?: 'Answer';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  isFollowUp: Scalars['Boolean']['output'];
  parentQuestionId: Scalars['String']['output'];
  readReceipts: Array<AnswerReadReceipt>;
  resources: Array<Resource>;
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
};

export type AnswerReadReceipt = {
  __typename?: 'AnswerReadReceipt';
  readAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export type ApplyRenameSuggestionsInput = {
  suggestions: Array<SuggestionInput>;
  workspaceId: Scalars['ID']['input'];
};

export type AssignOwnerInput = {
  isSelectAll?: InputMaybe<Scalars['Boolean']['input']>;
  questionIds: Array<Scalars['ID']['input']>;
  scope?: InputMaybe<QuestionStatus>;
  shouldRetainOldOwners: Scalars['Boolean']['input'];
  userIds: Array<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type AssistantMessage = {
  __typename?: 'AssistantMessage';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  role: AssistantMessageRole;
  sources?: Maybe<Array<AssistantSourceType>>;
  thinkingSteps?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
  vote?: Maybe<AssistantMessageVote>;
};

export type AssistantMessageArgsFilter = {
  threadId: Scalars['ID']['input'];
};

export type AssistantMessageArgsSorter = {
  createdAt?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export enum AssistantMessageRole {
  Assistant = 'Assistant',
  User = 'User'
}

export enum AssistantMessageVote {
  Down = 'Down',
  Up = 'Up'
}

export type AssistantSourceExcerptType = {
  __typename?: 'AssistantSourceExcerptType';
  chunkIndex?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
};

export type AssistantSourceType = {
  __typename?: 'AssistantSourceType';
  excerpts: Array<AssistantSourceExcerptType>;
  resourceId: Scalars['String']['output'];
  resourceMimeType?: Maybe<Scalars['String']['output']>;
  resourceName: Scalars['String']['output'];
};

export type AssistantThread = {
  __typename?: 'AssistantThread';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  resource?: Maybe<Resource>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AssistantThreadArgsFilter = {
  workspaceId: Scalars['ID']['input'];
};

export type AssistantThreadArgsSorter = {
  createdAt?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type BulkUpdateStatusInput = {
  folderIds: Array<Scalars['ID']['input']>;
  status: RequestListStatus;
  workspaceId: Scalars['ID']['input'];
};

export enum ClassificationStatus {
  Pending = 'Pending',
  Reclassified = 'Reclassified',
  Unclassified = 'Unclassified',
  Validated = 'Validated'
}

export type CompanyDetails = {
  __typename?: 'CompanyDetails';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type ConfirmAnswerInput = {
  isSelectAll?: InputMaybe<Scalars['Boolean']['input']>;
  questionIds: Array<Scalars['ID']['input']>;
  scope?: InputMaybe<QuestionStatus>;
  workspaceId: Scalars['ID']['input'];
};

export type ConnectionsByGroupEntry = {
  __typename?: 'ConnectionsByGroupEntry';
  connections: Scalars['Int']['output'];
  group: Group;
};

export type CopyGroupPermissionsInput = {
  sourceGroupId: Scalars['ID']['input'];
  targetGroupId: Scalars['ID']['input'];
};

export type CopyInput = {
  parentId?: InputMaybe<Scalars['ID']['input']>;
  resourceIds: Array<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateCheckoutSessionInput = {
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  isPaymentOutsideOfStripe: Scalars['Boolean']['input'];
  recurringPrice?: InputMaybe<Scalars['Float']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type CreateDealInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoicedAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status: DealStatusEnum;
  totalGains?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateGroupFolderInput = {
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateGroupInput = {
  color: Scalars['HexColorCode']['input'];
  folderId?: InputMaybe<Scalars['ID']['input']>;
  groupWithAccessToClone?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreateQuestionInput = {
  questionsInput: Array<QuestionInput>;
  workspaceId: Scalars['String']['input'];
};

export type CreateReferralInput = {
  commission?: InputMaybe<Scalars['Float']['input']>;
  dealIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  link?: InputMaybe<Scalars['String']['input']>;
  referralCode: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateRequestListFolderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateResourcesInput = {
  parentId?: InputMaybe<Scalars['ID']['input']>;
  resources: Array<ResourceInput>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateRoleInput = {
  name: Scalars['String']['input'];
  summaryFrequency?: InputMaybe<SummarySettingFrequency>;
  workspaceId: Scalars['ID']['input'];
};

export type CreateTenantInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  isSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  ownerEmails?: InputMaybe<Array<Scalars['EmailAddress']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTopicInput = {
  name: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type CreateUserInput = {
  auth0Id: Scalars['String']['input'];
  email: Scalars['EmailAddress']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  pictureURL?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWorkspaceInput = {
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<WorkspaceModulesInput>;
  name: Scalars['String']['input'];
  tenant: Scalars['ID']['input'];
  users?: InputMaybe<Array<CreateWorkspaceUserInput>>;
};

export type CreateWorkspaceUserInput = {
  roleName?: InputMaybe<Scalars['String']['input']>;
  userEmail: Scalars['EmailAddress']['input'];
};

export type CustomerAgreementMetadataType = {
  __typename?: 'CustomerAgreementMetadataType';
  changeOfControl?: Maybe<Scalars['String']['output']>;
  contractValue?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  earlyTerminationIndemnity?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  exclusivity?: Maybe<Scalars['String']['output']>;
  limitationOfLiability?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  terminationClause?: Maybe<Scalars['String']['output']>;
};

export type CustomerAgreementRow = {
  __typename?: 'CustomerAgreementRow';
  changeOfControl?: Maybe<Scalars['String']['output']>;
  contractValue?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  earlyTerminationIndemnity?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  exclusivity?: Maybe<Scalars['String']['output']>;
  limitationOfLiability?: Maybe<Scalars['String']['output']>;
  resourceId: Scalars['ID']['output'];
  resourceName: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  terminationClause?: Maybe<Scalars['String']['output']>;
};

export type CustomerAgreementsFilter = {
  customer?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type CustomerAgreementsOutput = {
  __typename?: 'CustomerAgreementsOutput';
  rows: Array<CustomerAgreementRow>;
};

export type DatadumpConfig = {
  __typename?: 'DatadumpConfig';
  createdAt: Scalars['DateTime']['output'];
  datadumpFolderId?: Maybe<Scalars['ID']['output']>;
  dataroomFolderId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Deal = {
  __typename?: 'Deal';
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoicedAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  paidAmount?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: DealStatusEnum;
  totalGains?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum DealStatusEnum {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type DealsArgsFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DealsArgsSorter = {
  createdAt?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export enum DeleteAction {
  Archive = 'Archive',
  Remove = 'Remove'
}

export type DeleteAnswersInput = {
  answerIds: Array<Scalars['ID']['input']>;
  isSelectAll?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<QuestionStatus>;
  workspaceId: Scalars['ID']['input'];
};

export type DeleteQuestionsInput = {
  isSelectAll?: InputMaybe<Scalars['Boolean']['input']>;
  questionIds: Array<Scalars['ID']['input']>;
  scope?: InputMaybe<QuestionStatus>;
  workspaceId: Scalars['ID']['input'];
};

export type DocumentClassification = {
  __typename?: 'DocumentClassification';
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  reasoning?: Maybe<Scalars['String']['output']>;
  reclassifiedToFolderId?: Maybe<Scalars['ID']['output']>;
  resource: Resource;
  status: ClassificationStatus;
  suggestedFolderId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uploadSource: UploadSource;
  validatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DocumentMetadata = CustomerAgreementMetadataType | EmployeeAgreementMetadataType | GenericDocumentMetadataType | LeaseMetadataType;

export type EmployeeAgreementMetadataType = {
  __typename?: 'EmployeeAgreementMetadataType';
  baseSalary?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  employee?: Maybe<Scalars['String']['output']>;
  governingLaw?: Maybe<Scalars['String']['output']>;
  hiringDate?: Maybe<Scalars['String']['output']>;
  ipClause?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  nonCompete?: Maybe<Scalars['String']['output']>;
  nonSolicitation?: Maybe<Scalars['String']['output']>;
  ote?: Maybe<Scalars['String']['output']>;
};

export type EmployeeAgreementRow = {
  __typename?: 'EmployeeAgreementRow';
  baseSalary?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<Scalars['String']['output']>;
  governingLaw?: Maybe<Scalars['String']['output']>;
  hiringDate?: Maybe<Scalars['String']['output']>;
  ipClause?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  nonCompete?: Maybe<Scalars['String']['output']>;
  nonSolicitation?: Maybe<Scalars['String']['output']>;
  ote?: Maybe<Scalars['String']['output']>;
  resourceId: Scalars['ID']['output'];
  resourceName: Scalars['String']['output'];
};

export type EmployeeAgreementsFilter = {
  employee?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type EmployeeAgreementsOutput = {
  __typename?: 'EmployeeAgreementsOutput';
  rows: Array<EmployeeAgreementRow>;
};

export type ExpertResponseTimeEntry = {
  __typename?: 'ExpertResponseTimeEntry';
  avgHours: Scalars['Float']['output'];
  topic: Scalars['String']['output'];
};

export type ExportQuestionInput = {
  workspaceId: Scalars['ID']['input'];
};

export type ExportQuestionLink = {
  __typename?: 'ExportQuestionLink';
  downloadLink: Scalars['String']['output'];
};

export type FinalizeMultipartUploadInput = {
  fileKey: Scalars['String']['input'];
  parts: Array<MultipartUploadPart>;
  uploadId: Scalars['String']['input'];
};

export type FolderRequestMetadata = {
  __typename?: 'FolderRequestMetadata';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  resourceId: Scalars['ID']['output'];
  status: RequestListStatus;
  updatedAt: Scalars['DateTime']['output'];
  validatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GenerateAiDescriptionsInput = {
  folderIds: Array<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type GenerateThreadTitleInput = {
  question: Scalars['String']['input'];
  threadId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type GenericDocumentMetadataType = {
  __typename?: 'GenericDocumentMetadataType';
  documentType: Scalars['String']['output'];
};

export type Group = {
  __typename?: 'Group';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  color: Scalars['HexColorCode']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  folder?: Maybe<GroupFolder>;
  folderId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paginatedResourceAccess: PaginatedResourceAccess;
  resourceAccess: Array<ResourceAccess>;
  updatedAt: Scalars['DateTime']['output'];
  users: Array<User>;
};


export type GroupPaginatedResourceAccessArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupArgsFilter = {
  workspaceId: Scalars['ID']['input'];
};

export type GroupArgsSorter = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type GroupFolder = {
  __typename?: 'GroupFolder';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['ID']['output'];
};

export type HighInterestDocumentEntry = {
  __typename?: 'HighInterestDocumentEntry';
  downloadCount: Scalars['Int']['output'];
  parentFolder?: Maybe<Resource>;
  resource: Resource;
  totalViews: Scalars['Int']['output'];
  uniqueViewers: Scalars['Int']['output'];
};

export type ImportRequestListInput = {
  items: Array<ImportRequestListItemInput>;
  workspaceId: Scalars['ID']['input'];
};

export type ImportRequestListItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** References another item index to build hierarchy */
  parentIndex?: InputMaybe<Scalars['String']['input']>;
};

export type InitializeMultipartUploadOutput = {
  __typename?: 'InitializeMultipartUploadOutput';
  fileKey: Scalars['String']['output'];
  uploadId: Scalars['String']['output'];
};

export type ItemDescriptionGeneratedOutput = {
  __typename?: 'ItemDescriptionGeneratedOutput';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type LeaseMetadataType = {
  __typename?: 'LeaseMetadataType';
  address?: Maybe<Scalars['String']['output']>;
  annualRent?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  earlyTerminationAndRenewal?: Maybe<Scalars['String']['output']>;
  geoRisks?: Maybe<Scalars['String']['output']>;
  increaseAnnual?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
};

export type LeaseRow = {
  __typename?: 'LeaseRow';
  address?: Maybe<Scalars['String']['output']>;
  annualRent?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  earlyTerminationAndRenewal?: Maybe<Scalars['String']['output']>;
  geoRisks?: Maybe<Scalars['String']['output']>;
  increaseAnnual?: Maybe<Scalars['String']['output']>;
  resourceId: Scalars['ID']['output'];
  resourceName: Scalars['String']['output'];
  term?: Maybe<Scalars['String']['output']>;
};

export type LeasesFilter = {
  document?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type LeasesOutput = {
  __typename?: 'LeasesOutput';
  rows: Array<LeaseRow>;
};

export type ManualRedactInput = {
  rectangles: Array<RectangleInput>;
  resourceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type MarkAnswersAsReadInput = {
  answerIds: Array<Scalars['ID']['input']>;
  questionId: Scalars['ID']['input'];
};

export type MarkQuestionAsReadInput = {
  questionId: Scalars['ID']['input'];
};

export type MultipartUploadPart = {
  ETag: Scalars['String']['input'];
  PartNumber: Scalars['Int']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addUsersToGroup: Group;
  addUsersToWorkspace: Workspace;
  applyRenameSuggestions: Array<Resource>;
  archiveWorkspace: Scalars['Boolean']['output'];
  assignOwnerToQuestion: Array<Question>;
  bulkMoveResources: Array<Resource>;
  bulkRenameResources: Array<Resource>;
  bulkUpdateRequestListStatus: Array<Resource>;
  changeWorkspaceUserRole: WorkspaceUser;
  clearNotifications: Scalars['Boolean']['output'];
  confirmAnswer: Array<Answer>;
  copy: Array<Resource>;
  copyGroupPermissions: Group;
  createAssistantThread: AssistantThread;
  createCheckoutSession?: Maybe<StripeCheckoutSession>;
  createDeal: Deal;
  createDownloadActivity: Scalars['Boolean']['output'];
  createGroup: Group;
  createGroupFolder: GroupFolder;
  createLoginActivity: Scalars['Boolean']['output'];
  createQuestion: Array<Question>;
  createReferral: Referral;
  createRequestListFolder: Resource;
  createResources: Array<Resource>;
  createRole: Role;
  createTenant: Tenant;
  createTopic: Topic;
  createUser: User;
  createVisitActivity: Scalars['Boolean']['output'];
  createWorkspace: Workspace;
  deleteAnswers: Array<Answer>;
  deleteDeal: Scalars['Boolean']['output'];
  deleteGroupFolder: Scalars['Boolean']['output'];
  deleteQuestions: Array<Question>;
  deleteReferral: Scalars['Boolean']['output'];
  deleteRequestListFolders: Array<Scalars['ID']['output']>;
  deleteRole: Scalars['Boolean']['output'];
  deleteThread: Scalars['Boolean']['output'];
  deleteTopic: Scalars['Boolean']['output'];
  exportActivitiesJob: Scalars['Boolean']['output'];
  exportQuestions: ExportQuestionLink;
  exportResourceAccessJob: Scalars['Boolean']['output'];
  exportWorkspaceResourcesJob: Scalars['Boolean']['output'];
  finalizeMultipartUpload?: Maybe<Scalars['String']['output']>;
  generateAIDescriptions: Scalars['Boolean']['output'];
  generateThreadTitle: Scalars['String']['output'];
  importRequestList: Array<Resource>;
  initializeMultipartUpload: InitializeMultipartUploadOutput;
  manualRedact: Scalars['Boolean']['output'];
  markAnswersAsRead: Scalars['Boolean']['output'];
  markNotificationsAsRead: Array<Notification>;
  markQuestionAsRead: Scalars['Boolean']['output'];
  moveAndRankResources: Scalars['Boolean']['output'];
  reclassifyDocument: DocumentClassification;
  redactEntities: Scalars['Boolean']['output'];
  refreshOnlineStatus: Scalars['Boolean']['output'];
  regenerateWorkspaceMetadata: RegenerateWorkspaceMetadataOutput;
  reindexWorkspace: Scalars['Boolean']['output'];
  removeGroup: Group;
  removeRedactions: Array<Resource>;
  removeResources: Scalars['Boolean']['output'];
  removeTenant: Scalars['Boolean']['output'];
  removeUser: Scalars['Boolean']['output'];
  removeUsersFromGroup: Group;
  removeWorkspace: Scalars['Boolean']['output'];
  replyInThread: Answer;
  reprocessResources: Scalars['Int']['output'];
  restoreResources: Scalars['Boolean']['output'];
  sendSummaryMail: Scalars['Boolean']['output'];
  suggestRename: Scalars['String']['output'];
  testSendSummary: Scalars['Boolean']['output'];
  toggleResourceFavorite: User;
  toggleUserSuspended: Workspace;
  toggleWorkspaceStatus: Workspace;
  toggleWorkspaceSupportStatus: Workspace;
  trackSearch: Scalars['Boolean']['output'];
  unarchiveWorkspace: Scalars['Boolean']['output'];
  unconfirmAnswer: Array<Answer>;
  updateAnswer: Answer;
  updateDeal: Deal;
  updateFavoriteResources: Array<Resource>;
  updateGroup: Group;
  updateGroupFolder: GroupFolder;
  updateGroupResourceAccess: Array<ResourceAccessUpdatedResult>;
  updateGroups: User;
  updateQuestion: Question;
  updateQuestionGroups: Array<Question>;
  updateQuestionPriority: Array<Question>;
  updateQuestionResolutionStatus: Array<Question>;
  updateQuestionTopics: Array<Question>;
  updateRedactionStatus: Array<Redaction>;
  updateReferral: Referral;
  updateRequestListFolder: Resource;
  updateResource: Resource;
  updateRole: Role;
  updateTenant: Tenant;
  updateTopic: Topic;
  updateTopicUserAssignments: Array<Topic>;
  updateUser: User;
  updateWorkspace: Workspace;
  updatedWorkspaceSettings: WorkspaceSettings;
  uploadToRequestListFolder: Array<Resource>;
  validateAllClassifications: Scalars['Boolean']['output'];
  validateClassification: DocumentClassification;
  voteAssistantMessage: AssistantMessage;
  zipFilesAndSendByEmail: Scalars['Boolean']['output'];
};


export type MutationAddUsersToGroupArgs = {
  groupId: Scalars['ID']['input'];
  userEmails: Array<Scalars['EmailAddress']['input']>;
};


export type MutationAddUsersToWorkspaceArgs = {
  addUsersToWorkspaceInput: Array<AddUserToWorkspaceInput>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationApplyRenameSuggestionsArgs = {
  applyRenameSuggestionsInput: ApplyRenameSuggestionsInput;
};


export type MutationArchiveWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssignOwnerToQuestionArgs = {
  assignOwnerInput: AssignOwnerInput;
};


export type MutationBulkMoveResourcesArgs = {
  resourcesToMove: Array<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationBulkRenameResourcesArgs = {
  customValues?: InputMaybe<Array<Scalars['String']['input']>>;
  renameComponents: Array<ResourceBulkRenameComponentType>;
  renameOptions?: InputMaybe<Array<ResourceBulkRenameOptionType>>;
  resourcesToRename: Array<ResourceToRename>;
};


export type MutationBulkUpdateRequestListStatusArgs = {
  input: BulkUpdateStatusInput;
};


export type MutationChangeWorkspaceUserRoleArgs = {
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationClearNotificationsArgs = {
  notificationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationConfirmAnswerArgs = {
  confirmAnswerInput: ConfirmAnswerInput;
};


export type MutationCopyArgs = {
  copyInput: CopyInput;
};


export type MutationCopyGroupPermissionsArgs = {
  copyGroupPermissionsInput: CopyGroupPermissionsInput;
};


export type MutationCreateAssistantThreadArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type MutationCreateCheckoutSessionArgs = {
  createCheckoutSessionInput: CreateCheckoutSessionInput;
};


export type MutationCreateDealArgs = {
  createDealInput: CreateDealInput;
};


export type MutationCreateDownloadActivityArgs = {
  resourceId: Scalars['ID']['input'];
};


export type MutationCreateGroupArgs = {
  createGroupInput: CreateGroupInput;
};


export type MutationCreateGroupFolderArgs = {
  input: CreateGroupFolderInput;
};


export type MutationCreateQuestionArgs = {
  createQuestionInput: CreateQuestionInput;
};


export type MutationCreateReferralArgs = {
  createReferralInput: CreateReferralInput;
};


export type MutationCreateRequestListFolderArgs = {
  input: CreateRequestListFolderInput;
};


export type MutationCreateResourcesArgs = {
  createResourcesInput: CreateResourcesInput;
};


export type MutationCreateRoleArgs = {
  createRoleInput: CreateRoleInput;
};


export type MutationCreateTenantArgs = {
  createTenantInput: CreateTenantInput;
};


export type MutationCreateTopicArgs = {
  input: CreateTopicInput;
};


export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};


export type MutationCreateVisitActivityArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type MutationCreateWorkspaceArgs = {
  createWorkspaceInput: CreateWorkspaceInput;
};


export type MutationDeleteAnswersArgs = {
  deleteAnswersInput: DeleteAnswersInput;
};


export type MutationDeleteDealArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGroupFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQuestionsArgs = {
  deleteQuestionsInput: DeleteQuestionsInput;
};


export type MutationDeleteReferralArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRequestListFoldersArgs = {
  ids: Array<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationDeleteRoleArgs = {
  roleId: Scalars['ID']['input'];
};


export type MutationDeleteThreadArgs = {
  threadId: Scalars['ID']['input'];
};


export type MutationDeleteTopicArgs = {
  topicId: Scalars['ID']['input'];
};


export type MutationExportActivitiesJobArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type MutationExportQuestionsArgs = {
  exportQuestionInput: ExportQuestionInput;
};


export type MutationExportResourceAccessJobArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type MutationExportWorkspaceResourcesJobArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type MutationFinalizeMultipartUploadArgs = {
  finalizeMultipartUploadInput: FinalizeMultipartUploadInput;
};


export type MutationGenerateAiDescriptionsArgs = {
  input: GenerateAiDescriptionsInput;
};


export type MutationGenerateThreadTitleArgs = {
  generateThreadTitleInput: GenerateThreadTitleInput;
};


export type MutationImportRequestListArgs = {
  input: ImportRequestListInput;
};


export type MutationInitializeMultipartUploadArgs = {
  fileKey: Scalars['String']['input'];
};


export type MutationManualRedactArgs = {
  manualRedactInput: ManualRedactInput;
};


export type MutationMarkAnswersAsReadArgs = {
  markAnswersAsReadInput: MarkAnswersAsReadInput;
};


export type MutationMarkNotificationsAsReadArgs = {
  notificationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationMarkQuestionAsReadArgs = {
  markQuestionAsReadInput: MarkQuestionAsReadInput;
};


export type MutationMoveAndRankResourcesArgs = {
  parentId?: InputMaybe<Scalars['ID']['input']>;
  sourceId: Scalars['String']['input'];
  targetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationReclassifyDocumentArgs = {
  input: ReclassifyDocumentInput;
};


export type MutationRedactEntitiesArgs = {
  action: Scalars['String']['input'];
  exclude?: InputMaybe<Array<Scalars['String']['input']>>;
  filter: RedactionArgsFilter;
  include?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationRegenerateWorkspaceMetadataArgs = {
  input: RegenerateWorkspaceMetadataInput;
};


export type MutationReindexWorkspaceArgs = {
  folderId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationRemoveGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveRedactionsArgs = {
  redactionIds: Array<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationRemoveResourcesArgs = {
  deleteAction: DeleteAction;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  resourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectAll?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationRemoveTenantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveUsersFromGroupArgs = {
  groupId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationRemoveWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReplyInThreadArgs = {
  replyInThreadInput: ReplyInThreadInput;
};


export type MutationReprocessResourcesArgs = {
  resourceIds: Array<Scalars['ID']['input']>;
};


export type MutationRestoreResourcesArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  resourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectAll?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationSendSummaryMailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSuggestRenameArgs = {
  suggestRenameInput: SuggestRenameInput;
};


export type MutationTestSendSummaryArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type MutationToggleResourceFavoriteArgs = {
  resourceId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationToggleUserSuspendedArgs = {
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationToggleWorkspaceStatusArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type MutationToggleWorkspaceSupportStatusArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type MutationTrackSearchArgs = {
  input: TrackSearchInput;
};


export type MutationUnarchiveWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnconfirmAnswerArgs = {
  unconfirmAnswerInput: UnconfirmAnswerInput;
};


export type MutationUpdateAnswerArgs = {
  updateAnswerInput: UpdateAnswerInput;
};


export type MutationUpdateDealArgs = {
  updateDealInput: UpdateDealInput;
};


export type MutationUpdateFavoriteResourcesArgs = {
  updateFavoriteResourcesInput: UpdateFavoriteResourcesInput;
};


export type MutationUpdateGroupArgs = {
  id: Scalars['ID']['input'];
  updateGroupInput: UpdateGroupInput;
};


export type MutationUpdateGroupFolderArgs = {
  input: UpdateGroupFolderInput;
};


export type MutationUpdateGroupResourceAccessArgs = {
  updateGroupResourceAccessInput: UpdateGroupResourceAccessInput;
};


export type MutationUpdateGroupsArgs = {
  updateGroupsInput: UpdateUserGroupsInput;
};


export type MutationUpdateQuestionArgs = {
  updateQuestionInput: UpdateQuestionInput;
};


export type MutationUpdateQuestionGroupsArgs = {
  updateQuestionGroupsInput: UpdateQuestionGroupsInput;
};


export type MutationUpdateQuestionPriorityArgs = {
  updateQuestionPriorityInput: UpdateQuestionPriorityInput;
};


export type MutationUpdateQuestionResolutionStatusArgs = {
  updateQuestionResolutionStatusInput: UpdateQuestionResolutionStatusInput;
};


export type MutationUpdateQuestionTopicsArgs = {
  updateQuestionTopicsInput: UpdateQuestionTopicsInput;
};


export type MutationUpdateRedactionStatusArgs = {
  redactionIds: Array<Scalars['ID']['input']>;
  status: RedactionStatusType;
};


export type MutationUpdateReferralArgs = {
  updateReferralInput: UpdateReferralInput;
};


export type MutationUpdateRequestListFolderArgs = {
  input: UpdateRequestListFolderInput;
};


export type MutationUpdateResourceArgs = {
  updateResourceInput: UpdateResourceInput;
};


export type MutationUpdateRoleArgs = {
  updateRoleInput: UpdateRoleInput;
};


export type MutationUpdateTenantArgs = {
  updateTenantInput: UpdateTenantInput;
};


export type MutationUpdateTopicArgs = {
  input: UpdateTopicInput;
};


export type MutationUpdateTopicUserAssignmentsArgs = {
  input: UpdateTopicUserAssignmentsInput;
};


export type MutationUpdateUserArgs = {
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateWorkspaceArgs = {
  id: Scalars['ID']['input'];
  updateWorkspaceInput: UpdateWorkspaceInput;
};


export type MutationUpdatedWorkspaceSettingsArgs = {
  updateWorkspaceSettingsInput: UpdateWorkspaceSettingsInput;
};


export type MutationUploadToRequestListFolderArgs = {
  input: UploadToRequestListFolderInput;
};


export type MutationValidateAllClassificationsArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type MutationValidateClassificationArgs = {
  input: ValidateClassificationInput;
};


export type MutationVoteAssistantMessageArgs = {
  assistantMessageId: Scalars['ID']['input'];
  vote?: InputMaybe<AssistantMessageVote>;
};


export type MutationZipFilesAndSendByEmailArgs = {
  parentId?: InputMaybe<Scalars['ID']['input']>;
  permission?: InputMaybe<Permission>;
  resourceIds: Array<Scalars['ID']['input']>;
  selectAll?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type Notification = {
  __typename?: 'Notification';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  targets?: Maybe<Array<NotificationTarget>>;
  topic: NotificationTopic;
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
};

export type NotificationArgsFilter = {
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type NotificationArgsSorter = {
  createdAt?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type NotificationTarget = Question | Resource | Workspace;

export enum NotificationTopic {
  ResourceAdded = 'Resource_Added',
  ResourceRename = 'Resource_Rename',
  ResourcesRedacted = 'Resources_Redacted',
  SupportAnswer = 'Support_Answer',
  SupportAssigned = 'Support_Assigned',
  SupportDeleted = 'Support_Deleted',
  SupportFollowUpAnswer = 'Support_Follow_Up_Answer',
  SupportQuestion = 'Support_Question',
  SupportResolved = 'Support_Resolved',
  WorkspaceAdminAdded = 'Workspace_Admin_Added',
  WorkspaceReindexDone = 'Workspace_Reindex_Done'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  offset?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedActivity = {
  __typename?: 'PaginatedActivity';
  nodes?: Maybe<Array<Activity>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginatedAssistantMessage = {
  __typename?: 'PaginatedAssistantMessage';
  nodes?: Maybe<Array<AssistantMessage>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginatedAssistantThread = {
  __typename?: 'PaginatedAssistantThread';
  nodes?: Maybe<Array<AssistantThread>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginatedDeals = {
  __typename?: 'PaginatedDeals';
  nodes?: Maybe<Array<Deal>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginatedDocumentClassification = {
  __typename?: 'PaginatedDocumentClassification';
  nodes?: Maybe<Array<DocumentClassification>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginatedGroup = {
  __typename?: 'PaginatedGroup';
  nodes?: Maybe<Array<Group>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginatedNotification = {
  __typename?: 'PaginatedNotification';
  nodes?: Maybe<Array<Notification>>;
  pageInfo?: Maybe<PageInfo>;
  unreadCount: Scalars['Int']['output'];
};

export type PaginatedQuestions = {
  __typename?: 'PaginatedQuestions';
  nodes?: Maybe<Array<Question>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginatedRedaction = {
  __typename?: 'PaginatedRedaction';
  nodes?: Maybe<Array<Redaction>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginatedReferral = {
  __typename?: 'PaginatedReferral';
  nodes?: Maybe<Array<Referral>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginatedResource = {
  __typename?: 'PaginatedResource';
  nodes?: Maybe<Array<Resource>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginatedResourceAccess = {
  __typename?: 'PaginatedResourceAccess';
  nodes?: Maybe<Array<ResourceAccess>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginatedTenant = {
  __typename?: 'PaginatedTenant';
  nodes?: Maybe<Array<Tenant>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginatedThread = {
  __typename?: 'PaginatedThread';
  nodes?: Maybe<Array<Answer>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginatedUser = {
  __typename?: 'PaginatedUser';
  nodes?: Maybe<Array<User>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaginatedWorkspace = {
  __typename?: 'PaginatedWorkspace';
  nodes?: Maybe<Array<Workspace>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaymentInfo = {
  __typename?: 'PaymentInfo';
  createdAt: Scalars['DateTime']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPaymentOutsideOfStripe?: Maybe<Scalars['Boolean']['output']>;
  paymentLink?: Maybe<Scalars['String']['output']>;
  recurringPrice?: Maybe<Scalars['Float']['output']>;
  stripeSubscriptionStatus?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum Permission {
  ResourceAccessOriginal = 'Resource_AccessOriginal',
  ResourceAccessRedacted = 'Resource_AccessRedacted',
  ResourceDownload = 'Resource_Download'
}

export enum PermissionKey {
  CanAnswerQuestions = 'canAnswerQuestions',
  ManageResources = 'manageResources',
  ManageUsersAndPermissions = 'manageUsersAndPermissions'
}

export type QaReadReceiptsByGroupEntry = {
  __typename?: 'QaReadReceiptsByGroupEntry';
  group: Group;
  readRate: Scalars['Float']['output'];
  totalAnswers: Scalars['Int']['output'];
};

export type QaReadReceiptsOutput = {
  __typename?: 'QaReadReceiptsOutput';
  avgTimeToReadHours: Scalars['Float']['output'];
  byGroup: Array<QaReadReceiptsByGroupEntry>;
  readRate: Scalars['Float']['output'];
  totalAnswers: Scalars['Int']['output'];
};

export type QaResourceInput = {
  id: Scalars['ID']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  storagePath: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  activities: PaginatedActivity;
  activityOverview: Array<ActivityOverviewEntry>;
  analytics: Array<Analytic>;
  assistantMessages: PaginatedAssistantMessage;
  assistantThreadForResource?: Maybe<AssistantThread>;
  assistantThreads: PaginatedAssistantThread;
  connectionsByGroup: Array<ConnectionsByGroupEntry>;
  customerAgreements: CustomerAgreementsOutput;
  datadumpConfig?: Maybe<DatadumpConfig>;
  deals: PaginatedDeals;
  employeeAgreements: EmployeeAgreementsOutput;
  expertResponseTime: Array<ExpertResponseTimeEntry>;
  getGroupAppliedResourceAccessPermissions: Array<Permission>;
  getMultipartPreSignedUrls: Array<Scalars['String']['output']>;
  group?: Maybe<Group>;
  groupFolders: Array<GroupFolder>;
  groups: PaginatedGroup;
  highInterestDocuments: Array<HighInterestDocumentEntry>;
  leases: LeasesOutput;
  me: User;
  myNotifications: PaginatedNotification;
  nonDownloadableResources: Array<Resource>;
  qaReadReceipts: QaReadReceiptsOutput;
  question: Question;
  questions: PaginatedQuestions;
  questionsByGroup: Array<QuestionsByGroupEntry>;
  questionsByTheme: Array<QuestionsByThemeEntry>;
  realTimeAnalytics: RealTimeAnalyticOutput;
  recentClassifiedDocuments: PaginatedDocumentClassification;
  recentDirectUploadDocuments: PaginatedDocumentClassification;
  recentPendingValidationDocuments: PaginatedDocumentClassification;
  recentUnclassifiedDocuments: PaginatedDocumentClassification;
  redactSearchResults: Array<Redaction>;
  redactions: PaginatedRedaction;
  redactionsSummary: RedactedFiles;
  referrals: PaginatedReferral;
  requestListFolder?: Maybe<Resource>;
  requestListFolders: Array<Resource>;
  resendUserInvite: Scalars['Boolean']['output'];
  resource: Resource;
  resourceDownloadUrl?: Maybe<Scalars['String']['output']>;
  resourceRedactedUrl?: Maybe<Scalars['String']['output']>;
  resourceUploadSignedUrl: Scalars['String']['output'];
  resources: PaginatedResource;
  resourcesIndexView: Array<ResourceIndexView>;
  resourcesWithoutPagination: Array<Resource>;
  roles: Array<Role>;
  search: SearchDto;
  storageOverview: Array<StorageOverviewEntry>;
  tenant: Tenant;
  tenants: PaginatedTenant;
  thread: PaginatedThread;
  topSearchKeywords: Array<TopSearchKeywordEntry>;
  topics: Array<Topic>;
  translateContent?: Maybe<Scalars['String']['output']>;
  user: User;
  users: PaginatedUser;
  vdrPenetration: Array<VdrPenetrationEntry>;
  workspace: Workspace;
  workspaceSettings: WorkspaceSettings;
  workspaces: PaginatedWorkspace;
};


export type QueryActivitiesArgs = {
  filter: ActivityArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<ActivityArgsSorter>;
};


export type QueryActivityOverviewArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryAnalyticsArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryAssistantMessagesArgs = {
  filter: AssistantMessageArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<AssistantMessageArgsSorter>;
};


export type QueryAssistantThreadForResourceArgs = {
  resourceId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryAssistantThreadsArgs = {
  filter: AssistantThreadArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<AssistantThreadArgsSorter>;
};


export type QueryConnectionsByGroupArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryCustomerAgreementsArgs = {
  filter: CustomerAgreementsFilter;
};


export type QueryDatadumpConfigArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryDealsArgs = {
  filter?: InputMaybe<DealsArgsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<DealsArgsSorter>;
};


export type QueryEmployeeAgreementsArgs = {
  filter: EmployeeAgreementsFilter;
};


export type QueryExpertResponseTimeArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryGetGroupAppliedResourceAccessPermissionsArgs = {
  groupId: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMultipartPreSignedUrlsArgs = {
  fileKey: Scalars['String']['input'];
  parts: Scalars['Int']['input'];
  uploadId: Scalars['String']['input'];
};


export type QueryGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGroupFoldersArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryGroupsArgs = {
  filter: GroupArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<GroupArgsSorter>;
};


export type QueryHighInterestDocumentsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryLeasesArgs = {
  filter: LeasesFilter;
};


export type QueryMyNotificationsArgs = {
  filter?: InputMaybe<NotificationArgsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<NotificationArgsSorter>;
};


export type QueryNonDownloadableResourcesArgs = {
  resourceIds: Array<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryQaReadReceiptsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type QueryQuestionsArgs = {
  filter: QuestionArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<QuestionArgSorter>;
};


export type QueryQuestionsByGroupArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryQuestionsByThemeArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryRealTimeAnalyticsArgs = {
  endDate: Scalars['DateTime']['input'];
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['DateTime']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryRecentClassifiedDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryRecentDirectUploadDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryRecentPendingValidationDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryRecentUnclassifiedDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryRedactSearchResultsArgs = {
  entities?: InputMaybe<Array<RedactEntityArgs>>;
  files: Array<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryRedactionsArgs = {
  filter: RedactionArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<RedactionArgsSorter>;
};


export type QueryRedactionsSummaryArgs = {
  filter: RedactionArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<RedactionArgsSorter>;
};


export type QueryReferralsArgs = {
  filter?: InputMaybe<ReferralArgsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<ReferralArgsSorter>;
};


export type QueryRequestListFolderArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryRequestListFoldersArgs = {
  filter: RequestListArgsFilter;
  sorter?: InputMaybe<RequestListArgsSorter>;
};


export type QueryResendUserInviteArgs = {
  userToInviteId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryResourceArgs = {
  id: Scalars['ID']['input'];
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryResourceDownloadUrlArgs = {
  resourceId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryResourceRedactedUrlArgs = {
  resourceId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryResourceUploadSignedUrlArgs = {
  fileKey: Scalars['String']['input'];
};


export type QueryResourcesArgs = {
  filter: ResourceArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<ResourceArgsSorter>;
};


export type QueryResourcesIndexViewArgs = {
  filter: ResourceArgsFilter;
  sorter?: InputMaybe<ResourceArgsSorter>;
};


export type QueryResourcesWithoutPaginationArgs = {
  filter: ResourceArgsFilter;
  sorter?: InputMaybe<ResourceArgsSorter>;
};


export type QueryRolesArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QuerySearchArgs = {
  filter: SearchArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  sorter?: InputMaybe<SearchArgsSorter>;
};


export type QueryStorageOverviewArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryTenantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantsArgs = {
  filter?: InputMaybe<TenantArgsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<TenantArgsSorter>;
};


export type QueryThreadArgs = {
  filter: ThreadArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<ThreadArgsSorter>;
};


export type QueryTopSearchKeywordsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryTopicsArgs = {
  sorter?: InputMaybe<TopicSorter>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryTranslateContentArgs = {
  locale: Scalars['Locale']['input'];
  resourceId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserArgsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<UserArgsSorter>;
};


export type QueryVdrPenetrationArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};


export type QueryWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkspaceSettingsArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type QueryWorkspacesArgs = {
  filter?: InputMaybe<WorkspaceArgsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<WorkspaceArgsSorter>;
};

export type Question = {
  __typename?: 'Question';
  answersCount: Scalars['Float']['output'];
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  assignedTopics: Array<Topic>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  duplicateQuestionIds?: Maybe<Array<Scalars['String']['output']>>;
  duplicates: Array<Question>;
  groups: Array<Group>;
  hasConfirmedAnswer: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isAnswered: Scalars['Boolean']['output'];
  latestAnswer?: Maybe<Answer>;
  owners: Array<User>;
  priority: QuestionPriority;
  publicId: Scalars['String']['output'];
  resolutionStatus: QuestionResolutionStatus;
  resources: Array<Resource>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
};

export type QuestionArgSorter = {
  createdAt?: InputMaybe<SortDirection>;
  priority?: InputMaybe<SortDirection>;
  resolutionStatus?: InputMaybe<SortDirection>;
  title?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type QuestionArgsFilter = {
  hasFollowUp?: InputMaybe<Scalars['Boolean']['input']>;
  hasSeenAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  owners?: InputMaybe<Array<Scalars['ID']['input']>>;
  priority?: InputMaybe<Array<QuestionPriority>>;
  resolutionStatus?: InputMaybe<QuestionResolutionStatus>;
  resourceId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<QuestionStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  topicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type QuestionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupUserEmail?: InputMaybe<Scalars['String']['input']>;
  newResources?: InputMaybe<Array<QaResourceInput>>;
  priority: QuestionPriority;
  resolutionStatus?: InputMaybe<QuestionResolutionStatus>;
  resourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  topicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum QuestionPriority {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export enum QuestionResolutionStatus {
  Closed = 'Closed',
  Open = 'Open'
}

export type QuestionSearchArgsFilter = {
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QuestionSearchArgsSorter = {
  createdAt?: InputMaybe<SearchSortDirection>;
  updatedAt?: InputMaybe<SearchSortDirection>;
};

export type QuestionSearchDto = {
  __typename?: 'QuestionSearchDto';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  publicId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['ID']['output'];
};

export type QuestionSearchResult = {
  __typename?: 'QuestionSearchResult';
  items: Array<QuestionSearchDto>;
  totalCount: Scalars['Int']['output'];
};

export enum QuestionStatus {
  Answered = 'Answered',
  Confirmed = 'Confirmed',
  Unanswered = 'Unanswered'
}

export type QuestionsByGroupEntry = {
  __typename?: 'QuestionsByGroupEntry';
  group: Group;
  themes: Array<ThemeQuestionCount>;
};

export type QuestionsByThemeEntry = {
  __typename?: 'QuestionsByThemeEntry';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type RealTimeAnalyticOutput = {
  __typename?: 'RealTimeAnalyticOutput';
  qaReadRate: Scalars['Float']['output'];
  topKeywords: Array<TopSearchKeywordEntry>;
  totalConnections: Scalars['Int']['output'];
  totalFiles: Scalars['Int']['output'];
  totalGroups: Scalars['Int']['output'];
  totalQuestions: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  totalViews: Scalars['Int']['output'];
};

export type ReclassifyDocumentInput = {
  classificationId: Scalars['ID']['input'];
  targetFolderId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type RectangleInput = {
  height: Scalars['Float']['input'];
  pageNumber: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export enum RedactEntity {
  BankAccountNumber = 'bank_account_number',
  CompanyId = 'company_id',
  CreditCardNumber = 'credit_card_number',
  Date = 'date',
  EmailAddress = 'email_address',
  Keyword = 'keyword',
  Manual = 'manual',
  Organization = 'organization',
  People = 'people',
  PhoneNumber = 'phone_number',
  PostalAddress = 'postal_address',
  SocialSecurityNumber = 'social_security_number',
  Time = 'time',
  Url = 'url'
}

export type RedactEntityArgs = {
  entity: RedactEntity;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type RedactMatch = {
  __typename?: 'RedactMatch';
  id?: Maybe<Scalars['String']['output']>;
  isAnnotation?: Maybe<Scalars['Boolean']['output']>;
  pageIndex?: Maybe<Scalars['Int']['output']>;
  previewText?: Maybe<Scalars['String']['output']>;
  rangeInPreview?: Maybe<Array<Scalars['Int']['output']>>;
  rectsOnPage?: Maybe<Array<Array<Scalars['Float']['output']>>>;
};

export type RedactSearchOperationResult = {
  __typename?: 'RedactSearchOperationResult';
  matchData: Array<RedactMatch>;
  strategy: RedactStrategy;
  strategyQuery: Scalars['String']['output'];
};

export enum RedactStrategy {
  Preset = 'preset',
  Regex = 'regex',
  Text = 'text'
}

export type RedactedFiles = {
  __typename?: 'RedactedFiles';
  counts: RedactedFilesSummary;
};

export type RedactedFilesSingleKeywordCount = {
  __typename?: 'RedactedFilesSingleKeywordCount';
  count: Scalars['Int']['output'];
  keyword: Scalars['String']['output'];
};

export type RedactedFilesStatus = {
  __typename?: 'RedactedFilesStatus';
  failed: Scalars['Int']['output'];
  ignored: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  redacted: Scalars['Int']['output'];
};

export type RedactedFilesSummary = {
  __typename?: 'RedactedFilesSummary';
  keywords: Array<RedactedFilesSingleKeywordCount>;
  status: RedactedFilesStatus;
};

export type Redaction = {
  __typename?: 'Redaction';
  createdAt: Scalars['DateTime']['output'];
  entity: RedactEntity;
  id: Scalars['ID']['output'];
  matchData: Array<RedactMatch>;
  resource: Resource;
  resourceId: Scalars['String']['output'];
  status: RedactionStatusType;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RedactionArgsFilter = {
  entities?: InputMaybe<Array<RedactEntity>>;
  excludeMimeTypes?: InputMaybe<Array<ResourceMimeType>>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  onlyMimeTypes?: InputMaybe<Array<ResourceMimeType>>;
  resourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Array<RedactionStatusType>>;
  workspaceId: Scalars['ID']['input'];
};

export type RedactionArgsSorter = {
  createdAt?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type RedactionCoordinate = {
  __typename?: 'RedactionCoordinate';
  height: Scalars['Float']['output'];
  pageNumber: Scalars['Int']['output'];
  phrase?: Maybe<Scalars['String']['output']>;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export enum RedactionStatusType {
  Failed = 'failed',
  Ignored = 'ignored',
  Pending = 'pending',
  Redacted = 'redacted',
  Redacting = 'redacting',
  Unredacting = 'unredacting'
}

export type Referral = {
  __typename?: 'Referral';
  code: Scalars['String']['output'];
  commission: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  deals: Array<Deal>;
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type ReferralArgsFilter = {
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ReferralArgsSorter = {
  createdAt?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type RegenerateWorkspaceMetadataInput = {
  workspaceId: Scalars['ID']['input'];
};

export type RegenerateWorkspaceMetadataOutput = {
  __typename?: 'RegenerateWorkspaceMetadataOutput';
  resourceCount: Scalars['Int']['output'];
};

export type ReplyInThreadInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  newResources?: InputMaybe<Array<QaResourceInput>>;
  resourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  threadSourceId: Scalars['ID']['input'];
};

export type RequestListArgsFilter = {
  status?: InputMaybe<RequestListStatus>;
  workspaceId: Scalars['ID']['input'];
};

export type RequestListArgsSorter = {
  createdAt?: InputMaybe<SortDirection>;
  index?: InputMaybe<SortDirection>;
  rank?: InputMaybe<SortDirection>;
};

export enum RequestListStatus {
  Requested = 'Requested',
  Submitted = 'Submitted',
  Validated = 'Validated'
}

export type Resource = {
  __typename?: 'Resource';
  accesses: Array<ResourceAccess>;
  activities: Array<Activity>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  canDownload: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  descendantsAccesses: Array<ResourceAccess>;
  entitiesSearchMatches?: Maybe<Array<Redaction>>;
  id: Scalars['ID']['output'];
  ignoredRedactionSearch?: Maybe<Array<Redaction>>;
  index?: Maybe<Scalars['String']['output']>;
  inheritedAccesses: Array<ResourceAccess>;
  isFaulty: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isQaOnly: Scalars['Boolean']['output'];
  metadata?: Maybe<DocumentMetadata>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  path: Array<Resource>;
  pspdfKitId?: Maybe<Scalars['ID']['output']>;
  publicId: Scalars['String']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  redactions?: Maybe<Array<Redaction>>;
  requestFiles: Array<Resource>;
  requestMetadata?: Maybe<FolderRequestMetadata>;
  resourceAccess?: Maybe<Array<ResourceAccess>>;
  shouldRestoreAsArchived: Scalars['Boolean']['output'];
  size: Scalars['BigInt']['output'];
  storagePath?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  type: ResourceType;
  updatedAt: Scalars['DateTime']['output'];
  userPermissions: Array<Permission>;
  viewUrl?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type ResourceAccess = {
  __typename?: 'ResourceAccess';
  group?: Maybe<Group>;
  groupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permissions: Array<Permission>;
  resource?: Maybe<Resource>;
  resourceId?: Maybe<Scalars['String']['output']>;
};


export type ResourceAccessResourceArgs = {
  workspaceId: Scalars['ID']['input'];
};

export type ResourceAccessUpdateInput = {
  addedPermissions?: InputMaybe<Array<Permission>>;
  removedPermissions?: InputMaybe<Array<Permission>>;
  resourceId: Scalars['ID']['input'];
};

export type ResourceAccessUpdatedResult = {
  __typename?: 'ResourceAccessUpdatedResult';
  groupId: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  permissions: Array<Permission>;
  resourceId?: Maybe<Scalars['String']['output']>;
};

export type ResourceArgsFilter = {
  hasEntitySearchMatches?: InputMaybe<Scalars['Boolean']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isFaulty?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isIncorrectlyUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  isRecent?: InputMaybe<Scalars['Boolean']['input']>;
  isRedacted?: InputMaybe<Scalars['Boolean']['input']>;
  nameLike?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type ResourceArgsSorter = {
  archivedAt?: InputMaybe<SortDirection>;
  createdAt?: InputMaybe<SortDirection>;
  index?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  rank?: InputMaybe<SortDirection>;
  size?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export enum ResourceBulkRenameComponentType {
  CustomValue = 'customValue',
  Name = 'name',
  ParentName = 'parentName',
  UploadedAt = 'uploadedAt',
  UploaderName = 'uploaderName'
}

export enum ResourceBulkRenameOptionType {
  Slug = 'slug',
  UpperCamelCase = 'upperCamelCase',
  UpperFirst = 'upperFirst',
  Uppercase = 'uppercase'
}

export enum ResourceFileType {
  Document = 'document',
  Image = 'image',
  Pdf = 'pdf',
  Presentation = 'presentation',
  Spreadsheet = 'spreadsheet'
}

export type ResourceIndexView = {
  __typename?: 'ResourceIndexView';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  pspdfKitId?: Maybe<Scalars['ID']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  type: ResourceType;
  workspaceId: Scalars['String']['output'];
};

export enum ResourceIndexationMethod {
  Default = 'default',
  Sequential = 'sequential'
}

export type ResourceInput = {
  directoryPath?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  storagePath?: InputMaybe<Scalars['String']['input']>;
  type: ResourceType;
};

export enum ResourceMimeType {
  Arc = 'arc',
  Avi = 'avi',
  Bmp = 'bmp',
  Bz = 'bz',
  Bz2 = 'bz2',
  Csv = 'csv',
  Doc = 'doc',
  Docm = 'docm',
  Docx = 'docx',
  Dotm = 'dotm',
  Dotx = 'dotx',
  Eml = 'eml',
  Gif = 'gif',
  Ico = 'ico',
  Jpeg = 'jpeg',
  M4v = 'm4v',
  Md = 'md',
  Mov = 'mov',
  Mp4 = 'mp4',
  Mpeg = 'mpeg',
  Odp = 'odp',
  Ods = 'ods',
  Odt = 'odt',
  Ogg = 'ogg',
  Pdf = 'pdf',
  Png = 'png',
  Potx = 'potx',
  Ppsx = 'ppsx',
  Ppt = 'ppt',
  Pptm = 'pptm',
  Pptx = 'pptx',
  Rar = 'rar',
  Svg = 'svg',
  Txt = 'txt',
  Webm = 'webm',
  Webp = 'webp',
  Xls = 'xls',
  Xlsb = 'xlsb',
  Xlsm = 'xlsm',
  Xlsx = 'xlsx',
  Xltm = 'xltm',
  Xltx = 'xltx',
  Zip = 'zip'
}

export type ResourceSearchArgsFilter = {
  authorId?: InputMaybe<Scalars['ID']['input']>;
  fileTypes?: InputMaybe<Array<ResourceFileType>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ResourceType>;
};

export type ResourceSearchArgsSorter = {
  createdAt?: InputMaybe<SearchSortDirection>;
  updatedAt?: InputMaybe<SearchSortDirection>;
};

export type ResourceSearchDto = {
  __typename?: 'ResourceSearchDto';
  authorId: Scalars['ID']['output'];
  authorName: Scalars['String']['output'];
  authorPictureURL?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  publicId: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  type: ResourceType;
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['ID']['output'];
};

export type ResourceSearchResult = {
  __typename?: 'ResourceSearchResult';
  items: Array<ResourceSearchDto>;
  totalCount: Scalars['Int']['output'];
};

export type ResourceToRename = {
  resourceId: Scalars['ID']['input'];
};

export type ResourceToUpdateFavorite = {
  id: Scalars['ID']['input'];
  isFavorite: Scalars['Boolean']['input'];
};

export enum ResourceType {
  File = 'file',
  Folder = 'folder'
}

export type Role = {
  __typename?: 'Role';
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: WorkspacePermission;
  summaryFrequency?: Maybe<SummarySettingFrequency>;
  workspaceId: Scalars['String']['output'];
};

export type SearchArgsFilter = {
  entityTypes?: InputMaybe<Array<SearchEntityType>>;
  questionSearchFilter?: InputMaybe<QuestionSearchArgsFilter>;
  resourceSearchFilter?: InputMaybe<ResourceSearchArgsFilter>;
  workspaceId: Scalars['ID']['input'];
};

export type SearchArgsSorter = {
  questionSearchSorter?: InputMaybe<QuestionSearchArgsSorter>;
  resourceSearchSorter?: InputMaybe<ResourceSearchArgsSorter>;
};

export type SearchDto = {
  __typename?: 'SearchDto';
  questions: QuestionSearchResult;
  resources: ResourceSearchResult;
};

export enum SearchEntityType {
  Question = 'QUESTION',
  Resource = 'RESOURCE'
}

export enum SearchSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type SelectAllAccessUpdateInput = {
  addedPermissions?: InputMaybe<Array<Permission>>;
  removedPermissions?: InputMaybe<Array<Permission>>;
  scope?: InputMaybe<Scalars['ID']['input']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StorageOverviewEntry = {
  __typename?: 'StorageOverviewEntry';
  bytes: Scalars['BigInt']['output'];
  date: Scalars['DateTime']['output'];
};

export type StripeCheckoutSession = {
  __typename?: 'StripeCheckoutSession';
  paymentLink: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  itemDescriptionGenerated: ItemDescriptionGeneratedOutput;
  notifications: Notification;
  resourceUploadedToDocumentEngine: Resource;
  resourcesRedacted: Scalars['String']['output'];
  workspaceReindexed: Scalars['String']['output'];
};


export type SubscriptionItemDescriptionGeneratedArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type SubscriptionNotificationsArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type SubscriptionResourcesRedactedArgs = {
  workspaceId: Scalars['ID']['input'];
};


export type SubscriptionWorkspaceReindexedArgs = {
  workspaceId: Scalars['ID']['input'];
};

export type SuggestRenameInput = {
  resourceId: Scalars['ID']['input'];
  userPrompt?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type SuggestionInput = {
  newName: Scalars['String']['input'];
  resourceId: Scalars['ID']['input'];
};

export enum SummarySettingFrequency {
  Daily = 'daily',
  Hourly = 'hourly',
  Never = 'never'
}

export type Tenant = {
  __typename?: 'Tenant';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  companyDetails: CompanyDetails;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isSuspended: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  owners: Array<User>;
  updatedAt: Scalars['DateTime']['output'];
  workspaces: Array<Workspace>;
};

export type TenantArgsFilter = {
  isSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TenantArgsSorter = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type ThemeQuestionCount = {
  __typename?: 'ThemeQuestionCount';
  name?: Maybe<Scalars['String']['output']>;
  questionCount: Scalars['Int']['output'];
};

export type ThreadArgsFilter = {
  threadSourceId: Scalars['ID']['input'];
};

export type ThreadArgsSorter = {
  createdAt?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type TopSearchKeywordEntry = {
  __typename?: 'TopSearchKeywordEntry';
  count: Scalars['Int']['output'];
  keyword: Scalars['String']['output'];
};

export type Topic = {
  __typename?: 'Topic';
  assignedUsers?: Maybe<Array<User>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workspaceId: Scalars['String']['output'];
};

export type TopicSorter = {
  createdAt?: InputMaybe<SortDirection>;
};

export type TopicUserAssignmentInput = {
  topicId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type TrackSearchInput = {
  query: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type UnconfirmAnswerInput = {
  isSelectAll?: InputMaybe<Scalars['Boolean']['input']>;
  questionIds: Array<Scalars['ID']['input']>;
  scope?: InputMaybe<QuestionStatus>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateAnswerInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  newResources?: InputMaybe<Array<QaResourceInput>>;
  resourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateDealInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  invoicedAmount?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<DealStatusEnum>;
  totalGains?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateFavoriteResourcesInput = {
  resources: Array<ResourceToUpdateFavorite>;
};

export type UpdateGroupFolderInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** New parent folder ID, or null to move to root */
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateGroupInput = {
  color?: InputMaybe<Scalars['HexColorCode']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  groupWithAccessToClone?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupResourceAccessInput = {
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  resourceAccess: Array<ResourceAccessUpdateInput>;
  selectAllAccess?: InputMaybe<SelectAllAccessUpdateInput>;
};

export type UpdatePermissionsInput = {
  canAnswerQuestions?: InputMaybe<Scalars['Boolean']['input']>;
  manageResources?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateQuestionGroupsInput = {
  groupIds: Array<Scalars['ID']['input']>;
  isSelectAll?: InputMaybe<Scalars['Boolean']['input']>;
  questionIds: Array<Scalars['ID']['input']>;
  scope?: InputMaybe<QuestionStatus>;
  shouldRetainOldGroups: Scalars['Boolean']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type UpdateQuestionInput = {
  id: Scalars['ID']['input'];
  priority?: InputMaybe<QuestionPriority>;
  resolutionStatus?: InputMaybe<QuestionResolutionStatus>;
};

export type UpdateQuestionPriorityInput = {
  isSelectAll?: InputMaybe<Scalars['Boolean']['input']>;
  priority: QuestionPriority;
  questionIds: Array<Scalars['ID']['input']>;
  scope?: InputMaybe<QuestionStatus>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateQuestionResolutionStatusInput = {
  isSelectAll?: InputMaybe<Scalars['Boolean']['input']>;
  questionIds: Array<Scalars['ID']['input']>;
  resolutionStatus: QuestionResolutionStatus;
  scope?: InputMaybe<QuestionStatus>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateQuestionTopicsInput = {
  isSelectAll?: InputMaybe<Scalars['Boolean']['input']>;
  questionIds: Array<Scalars['ID']['input']>;
  scope?: InputMaybe<QuestionStatus>;
  topicIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateReferralInput = {
  commission?: InputMaybe<Scalars['Float']['input']>;
  dealIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRequestListFolderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<RequestListStatus>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateResourceInput = {
  id: Scalars['ID']['input'];
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateRoleInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<UpdatePermissionsInput>;
  roleId: Scalars['ID']['input'];
  summaryFrequency?: InputMaybe<SummarySettingFrequency>;
};

export type UpdateTenantInput = {
  addedOwners?: InputMaybe<Array<Scalars['ID']['input']>>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerEmails?: InputMaybe<Array<Scalars['EmailAddress']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  removedOwners?: InputMaybe<Array<Scalars['ID']['input']>>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTopicInput = {
  name: Scalars['String']['input'];
  topicId: Scalars['ID']['input'];
};

export type UpdateTopicUserAssignmentsInput = {
  assignments: Array<TopicUserAssignmentInput>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateUserGroupsInput = {
  addedGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  removedGroups?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetUserId: Scalars['ID']['input'];
};

export type UpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  pictureURL?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type UpdateWorkspaceInput = {
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkspaceSettingsInput = {
  adminContact?: InputMaybe<Scalars['String']['input']>;
  autoTopicAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  indexationMethod?: InputMaybe<ResourceIndexationMethod>;
  loginPageBackgroundUrl?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<WorkspaceModulesInput>;
  themeColor?: InputMaybe<Scalars['String']['input']>;
  watermarkForPermissions?: InputMaybe<Array<Permission>>;
  watermarkPresets?: InputMaybe<Array<WatermarkPreset>>;
  workspaceId: Scalars['ID']['input'];
};

export enum UploadSource {
  Datadump = 'Datadump',
  DirectRl = 'DirectRl'
}

export type UploadToRequestListFolderInput = {
  folderId: Scalars['ID']['input'];
  resources: Array<ResourceInput>;
  workspaceId: Scalars['ID']['input'];
};

export type User = {
  __typename?: 'User';
  activities?: Maybe<Array<Activity>>;
  activityStatus: ActivityStatus;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  auth0Id?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  favoriteResources: PaginatedResource;
  firstName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['DateTime']['output']>;
  managedTenant?: Maybe<Tenant>;
  pictureURL?: Maybe<Scalars['String']['output']>;
  referral?: Maybe<Referral>;
  updatedAt: Scalars['DateTime']['output'];
  workspaceUsers: Array<WorkspaceUser>;
};


export type UserFavoriteResourcesArgs = {
  filter: ResourceArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<ResourceArgsSorter>;
};


export type UserGroupsArgs = {
  workspaceId: Scalars['ID']['input'];
};

export type UserArgsFilter = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isSuspended?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  withPermission?: InputMaybe<PermissionKey>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserArgsSorter = {
  createdAt?: InputMaybe<SortDirection>;
  email?: InputMaybe<SortDirection>;
  firstName?: InputMaybe<SortDirection>;
  lastName?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type ValidateClassificationInput = {
  classificationId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type VdrPenetrationEntry = {
  __typename?: 'VdrPenetrationEntry';
  group: Group;
  penetrationRate: Scalars['Float']['output'];
  totalDocuments: Scalars['Int']['output'];
  viewedDocuments: Scalars['Int']['output'];
};

export enum WatermarkPreset {
  AuthorEmail = 'authorEmail',
  AuthorName = 'authorName',
  Date = 'date',
  DateTime = 'dateTime',
  WorkspaceName = 'workspaceName'
}

export type Workspace = {
  __typename?: 'Workspace';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isPaymentActive: Scalars['Boolean']['output'];
  isPaymentDetailsValidated: Scalars['Boolean']['output'];
  liveAt?: Maybe<Scalars['DateTime']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  paymentInfo?: Maybe<PaymentInfo>;
  processingStatus: WorkspaceProcessingStatusType;
  status: WorkspaceStatusType;
  supportStatus: WorkspaceSupportStatusType;
  tenant: Tenant;
  updatedAt: Scalars['DateTime']['output'];
  workspaceSettings: WorkspaceSettings;
  workspaceUsers?: Maybe<Array<WorkspaceUser>>;
};

export type WorkspaceArgsFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WorkspaceStatusFilterType>;
};

export type WorkspaceArgsSorter = {
  createdAt?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  updatedAt?: InputMaybe<SortDirection>;
};

export type WorkspaceModules = {
  __typename?: 'WorkspaceModules';
  analytics?: Maybe<Scalars['Boolean']['output']>;
  requestList?: Maybe<Scalars['Boolean']['output']>;
};

export type WorkspaceModulesInput = {
  analytics?: InputMaybe<Scalars['Boolean']['input']>;
  requestList?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkspacePermission = {
  __typename?: 'WorkspacePermission';
  canAnswerQuestions: Scalars['Boolean']['output'];
  manageResources: Scalars['Boolean']['output'];
  manageUsersAndPermissions: Scalars['Boolean']['output'];
};

export enum WorkspaceProcessingStatusType {
  Extract = 'extract',
  Idle = 'idle',
  Redact = 'redact'
}

export type WorkspaceSettings = {
  __typename?: 'WorkspaceSettings';
  adminContact?: Maybe<Scalars['String']['output']>;
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  autoTopicAssignment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  indexationMethod?: Maybe<ResourceIndexationMethod>;
  loginPageBackgroundUrl?: Maybe<Scalars['String']['output']>;
  modules: WorkspaceModules;
  themeColor?: Maybe<Scalars['HexColorCode']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  watermarkForPermissions?: Maybe<Array<Permission>>;
  watermarkPresets?: Maybe<Array<WatermarkPreset>>;
  workspaceId: Scalars['String']['output'];
};

export enum WorkspaceStatusFilterType {
  Archived = 'archived',
  Live = 'live',
  Offline = 'offline'
}

export enum WorkspaceStatusType {
  Live = 'live',
  Offline = 'offline'
}

export enum WorkspaceSupportStatusType {
  Editable = 'editable',
  Readonly = 'readonly'
}

export type WorkspaceUser = {
  __typename?: 'WorkspaceUser';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isSuspended: Scalars['Boolean']['output'];
  role: Role;
  user: User;
  workspace: Workspace;
};

export type ApplyRenameSuggestionsMutationVariables = Exact<{
  applyRenameSuggestionsInput: ApplyRenameSuggestionsInput;
}>;


export type ApplyRenameSuggestionsMutation = { __typename?: 'Mutation', applyRenameSuggestions: Array<{ __typename?: 'Resource', id: string, name: string }> };

export type CreateAssistantThreadMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type CreateAssistantThreadMutation = { __typename?: 'Mutation', createAssistantThread: { __typename?: 'AssistantThread', id: string, title: string, createdAt: any, updatedAt: any, resource?: { __typename?: 'Resource', id: string, name: string, type: ResourceType, index?: string | null, mimeType?: string | null } | null } };

export type DeleteThreadMutationVariables = Exact<{
  threadId: Scalars['ID']['input'];
}>;


export type DeleteThreadMutation = { __typename?: 'Mutation', deleteThread: boolean };

export type FetchResourceNameQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  resourceId: Scalars['ID']['input'];
}>;


export type FetchResourceNameQuery = { __typename?: 'Query', resource: { __typename?: 'Resource', id: string, name: string } };

export type GenerateThreadTitleMutationVariables = Exact<{
  generateThreadTitleInput: GenerateThreadTitleInput;
}>;


export type GenerateThreadTitleMutation = { __typename?: 'Mutation', generateThreadTitle: string };

export type GetAssistantMessagesQueryVariables = Exact<{
  filter: AssistantMessageArgsFilter;
  sorter?: InputMaybe<AssistantMessageArgsSorter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAssistantMessagesQuery = { __typename?: 'Query', assistantMessages: { __typename?: 'PaginatedAssistantMessage', nodes?: Array<{ __typename?: 'AssistantMessage', id: string, content: string, role: AssistantMessageRole, createdAt: any, vote?: AssistantMessageVote | null, thinkingSteps?: Array<string> | null, sources?: Array<{ __typename?: 'AssistantSourceType', resourceId: string, resourceName: string, resourceMimeType?: string | null, excerpts: Array<{ __typename?: 'AssistantSourceExcerptType', text: string, page?: number | null }> }> | null }> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, totalCount: number } | null } };

export type GetAssistantThreadForResourceQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  resourceId: Scalars['ID']['input'];
}>;


export type GetAssistantThreadForResourceQuery = { __typename?: 'Query', assistantThreadForResource?: { __typename?: 'AssistantThread', id: string } | null };

export type AssistantThreadFragment = { __typename?: 'AssistantThread', id: string, title: string, createdAt: any, updatedAt: any, resource?: { __typename?: 'Resource', id: string, name: string, type: ResourceType, index?: string | null, mimeType?: string | null } | null };

export type GetAssistantThreadsQueryVariables = Exact<{
  filter: AssistantThreadArgsFilter;
  sorter?: InputMaybe<AssistantThreadArgsSorter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAssistantThreadsQuery = { __typename?: 'Query', assistantThreads: { __typename?: 'PaginatedAssistantThread', nodes?: Array<{ __typename?: 'AssistantThread', id: string, title: string, createdAt: any, updatedAt: any, resource?: { __typename?: 'Resource', id: string, name: string, type: ResourceType, index?: string | null, mimeType?: string | null } | null }> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, totalCount: number } | null } };

export type VoteAssistantMessageMutationVariables = Exact<{
  assistantMessageId: Scalars['ID']['input'];
  vote?: InputMaybe<AssistantMessageVote>;
}>;


export type VoteAssistantMessageMutation = { __typename?: 'Mutation', voteAssistantMessage: { __typename?: 'AssistantMessage', id: string, vote?: AssistantMessageVote | null } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, auth0Id?: string | null, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null, activityStatus: ActivityStatus, workspaceUsers: Array<{ __typename?: 'WorkspaceUser', isSuspended: boolean, workspace: { __typename?: 'Workspace', id: string, name: string, status: WorkspaceStatusType, isPaymentActive: boolean }, role: { __typename?: 'Role', id: string, name: string, isAdmin: boolean, summaryFrequency?: SummarySettingFrequency | null, permissions: { __typename?: 'WorkspacePermission', manageResources: boolean, canAnswerQuestions: boolean, manageUsersAndPermissions: boolean } } }>, managedTenant?: { __typename?: 'Tenant', id: string, name: string, isSuspended: boolean, companyDetails: { __typename?: 'CompanyDetails', name?: string | null, website?: string | null, phone?: string | null, address?: string | null, country?: string | null, city?: string | null, zipCode?: string | null } } | null, referral?: { __typename?: 'Referral', id: string, code: string, commission: number, link?: string | null, deals: Array<{ __typename?: 'Deal', id: string, name: string, invoicedAmount?: number | null, paidAmount?: number | null, startDate?: any | null, endDate?: any | null, status: DealStatusEnum, totalGains?: number | null }> } | null } };

export type ToggleResourceFavoriteMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  resourceId: Scalars['ID']['input'];
}>;


export type ToggleResourceFavoriteMutation = { __typename?: 'Mutation', toggleResourceFavorite: { __typename?: 'User', updatedAt: any } };

export type ExportActivitiesJobMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type ExportActivitiesJobMutation = { __typename?: 'Mutation', exportActivitiesJob: boolean };

export type ActivityFragment = { __typename?: 'Activity', id: string, createdAt: any, topic: ActivityTopic, targets?: Array<
    | { __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null, createdAt: any }
    | { __typename?: 'Question', id: string, title: string, publicId: string }
    | { __typename?: 'Resource', id: string, name: string, index?: string | null, type: ResourceType, mimeType?: string | null, createdAt: any }
    | { __typename?: 'User' }
    | { __typename?: 'Workspace' }
  > | null, user: { __typename?: 'User', id: string, auth0Id?: string | null, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null, groups?: Array<{ __typename?: 'Group', id: string, name: string, color: any }> | null } };

export type GetActivitiesQueryVariables = Exact<{
  filter: ActivityArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<ActivityArgsSorter>;
  workspaceId: Scalars['ID']['input'];
}>;


export type GetActivitiesQuery = { __typename?: 'Query', activities: { __typename?: 'PaginatedActivity', nodes?: Array<{ __typename?: 'Activity', id: string, createdAt: any, topic: ActivityTopic, targets?: Array<
        | { __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null, createdAt: any }
        | { __typename?: 'Question', id: string, title: string, publicId: string }
        | { __typename?: 'Resource', id: string, name: string, index?: string | null, type: ResourceType, mimeType?: string | null, createdAt: any }
        | { __typename?: 'User' }
        | { __typename?: 'Workspace' }
      > | null, user: { __typename?: 'User', id: string, auth0Id?: string | null, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null, groups?: Array<{ __typename?: 'Group', id: string, name: string, color: any }> | null } }> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, totalCount: number } | null } };

export type GetActivityOverviewQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetActivityOverviewQuery = { __typename?: 'Query', activityOverview: Array<{ __typename?: 'ActivityOverviewEntry', date: any, connections: number, documentViews: number, questions: number }> };

export type GetConnectionsByGroupQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetConnectionsByGroupQuery = { __typename?: 'Query', connectionsByGroup: Array<{ __typename?: 'ConnectionsByGroupEntry', connections: number, group: { __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null } }> };

export type GetExpertResponseTimeQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetExpertResponseTimeQuery = { __typename?: 'Query', expertResponseTime: Array<{ __typename?: 'ExpertResponseTimeEntry', topic: string, avgHours: number }> };

export type GetHighInterestDocumentsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetHighInterestDocumentsQuery = { __typename?: 'Query', highInterestDocuments: Array<{ __typename?: 'HighInterestDocumentEntry', totalViews: number, uniqueViewers: number, downloadCount: number, resource: { __typename?: 'Resource', id: string, name: string }, parentFolder?: { __typename?: 'Resource', id: string, name: string } | null }> };

export type GetQaReadReceiptsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetQaReadReceiptsQuery = { __typename?: 'Query', qaReadReceipts: { __typename?: 'QaReadReceiptsOutput', totalAnswers: number, readRate: number, avgTimeToReadHours: number, byGroup: Array<{ __typename?: 'QaReadReceiptsByGroupEntry', readRate: number, totalAnswers: number, group: { __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null } }> } };

export type GetQuestionsByGroupQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetQuestionsByGroupQuery = { __typename?: 'Query', questionsByGroup: Array<{ __typename?: 'QuestionsByGroupEntry', group: { __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null }, themes: Array<{ __typename?: 'ThemeQuestionCount', name?: string | null, questionCount: number }> }> };

export type GetQuestionsByThemeQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetQuestionsByThemeQuery = { __typename?: 'Query', questionsByTheme: Array<{ __typename?: 'QuestionsByThemeEntry', name: string, count: number }> };

export type GetRealTimeAnalyticsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  groupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetRealTimeAnalyticsQuery = { __typename?: 'Query', realTimeAnalytics: { __typename?: 'RealTimeAnalyticOutput', totalConnections: number, totalViews: number, totalQuestions: number, totalFiles: number, totalUsers: number, totalGroups: number, qaReadRate: number, topKeywords: Array<{ __typename?: 'TopSearchKeywordEntry', keyword: string, count: number }> } };

export type GetStorageOverviewQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetStorageOverviewQuery = { __typename?: 'Query', storageOverview: Array<{ __typename?: 'StorageOverviewEntry', date: any, bytes: any }> };

export type GetTopSearchKeywordsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTopSearchKeywordsQuery = { __typename?: 'Query', topSearchKeywords: Array<{ __typename?: 'TopSearchKeywordEntry', keyword: string, count: number }> };

export type GetVdrPenetrationQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetVdrPenetrationQuery = { __typename?: 'Query', vdrPenetration: Array<{ __typename?: 'VdrPenetrationEntry', penetrationRate: number, totalDocuments: number, viewedDocuments: number, group: { __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null } }> };

export type GetCustomerAgreementsQueryVariables = Exact<{
  filter: CustomerAgreementsFilter;
}>;


export type GetCustomerAgreementsQuery = { __typename?: 'Query', customerAgreements: { __typename?: 'CustomerAgreementsOutput', rows: Array<{ __typename?: 'CustomerAgreementRow', resourceId: string, resourceName: string, customer?: string | null, startDate?: string | null, endDate?: string | null, terminationClause?: string | null, earlyTerminationIndemnity?: string | null, limitationOfLiability?: string | null, changeOfControl?: string | null, exclusivity?: string | null, contractValue?: string | null }> } };

export type GetEmployeeAgreementsQueryVariables = Exact<{
  filter: EmployeeAgreementsFilter;
}>;


export type GetEmployeeAgreementsQuery = { __typename?: 'Query', employeeAgreements: { __typename?: 'EmployeeAgreementsOutput', rows: Array<{ __typename?: 'EmployeeAgreementRow', resourceId: string, resourceName: string, employee?: string | null, jobTitle?: string | null, hiringDate?: string | null, baseSalary?: string | null, ote?: string | null, nonCompete?: string | null, nonSolicitation?: string | null, ipClause?: string | null, governingLaw?: string | null }> } };

export type GetLeasesQueryVariables = Exact<{
  filter: LeasesFilter;
}>;


export type GetLeasesQuery = { __typename?: 'Query', leases: { __typename?: 'LeasesOutput', rows: Array<{ __typename?: 'LeaseRow', resourceId: string, resourceName: string, document?: string | null, address?: string | null, term?: string | null, earlyTerminationAndRenewal?: string | null, annualRent?: string | null, increaseAnnual?: string | null, geoRisks?: string | null }> } };

export type RegenerateWorkspaceMetadataMutationVariables = Exact<{
  input: RegenerateWorkspaceMetadataInput;
}>;


export type RegenerateWorkspaceMetadataMutation = { __typename?: 'Mutation', regenerateWorkspaceMetadata: { __typename?: 'RegenerateWorkspaceMetadataOutput', resourceCount: number } };

export type AddUsersToGroupMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  userEmails: Array<Scalars['EmailAddress']['input']> | Scalars['EmailAddress']['input'];
}>;


export type AddUsersToGroupMutation = { __typename?: 'Mutation', addUsersToGroup: { __typename?: 'Group', id: string, name: string, color: any, users: Array<{ __typename?: 'User', id: string, auth0Id?: string | null, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null, activityStatus: ActivityStatus, updatedAt: any, createdAt: any }> } };

export type CopyGroupPermissionsMutationVariables = Exact<{
  copyGroupPermissionsInput: CopyGroupPermissionsInput;
}>;


export type CopyGroupPermissionsMutation = { __typename?: 'Mutation', copyGroupPermissions: { __typename: 'Group', id: string, name: string } };

export type CreateGroupMutationVariables = Exact<{
  createGroupInput: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'Group', id: string, updatedAt: any, name: string, color: any, createdAt: any, users: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, createdAt: any, pictureURL?: string | null, archivedAt?: any | null, auth0Id?: string | null }>, createdBy: { __typename?: 'User', id: string, firstName?: string | null, email: string, createdAt: any, archivedAt?: any | null, lastName?: string | null, updatedAt: any, pictureURL?: string | null } } };

export type CreateGroupFolderMutationVariables = Exact<{
  input: CreateGroupFolderInput;
}>;


export type CreateGroupFolderMutation = { __typename?: 'Mutation', createGroupFolder: { __typename?: 'GroupFolder', id: string, name: string, parentId?: string | null, workspaceId: string, createdAt: any, updatedAt: any } };

export type DeleteGroupFolderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGroupFolderMutation = { __typename?: 'Mutation', deleteGroupFolder: boolean };

export type ExportResourceAccessJobMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type ExportResourceAccessJobMutation = { __typename?: 'Mutation', exportResourceAccessJob: boolean };

export type GetGroupAppliedResourceAccessPermissionsQueryVariables = Exact<{
  groupId: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetGroupAppliedResourceAccessPermissionsQuery = { __typename?: 'Query', getGroupAppliedResourceAccessPermissions: Array<Permission> };

export type GetGroupFoldersQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetGroupFoldersQuery = { __typename?: 'Query', groupFolders: Array<{ __typename?: 'GroupFolder', id: string, name: string, parentId?: string | null, workspaceId: string, createdAt: any, updatedAt: any }> };

export type GetGroupsQueryVariables = Exact<{
  filter: GroupArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<GroupArgsSorter>;
}>;


export type GetGroupsQuery = { __typename?: 'Query', groups: { __typename?: 'PaginatedGroup', nodes?: Array<{ __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null, createdAt: any, updatedAt: any, users: Array<{ __typename?: 'User', id: string, auth0Id?: string | null, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null, activityStatus: ActivityStatus, updatedAt: any, createdAt: any }>, resourceAccess: Array<{ __typename?: 'ResourceAccess', id: string, resourceId?: string | null, permissions: Array<Permission> }>, createdBy: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null } }> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, totalCount: number } | null } };

export type OneGroupFragment = { __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null }, users: Array<{ __typename?: 'User', id: string, auth0Id?: string | null, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null, activityStatus: ActivityStatus, updatedAt: any, createdAt: any }> };

export type GetOneGroupQueryVariables = Exact<{
  groupId: Scalars['ID']['input'];
}>;


export type GetOneGroupQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null }, users: Array<{ __typename?: 'User', id: string, auth0Id?: string | null, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null, activityStatus: ActivityStatus, updatedAt: any, createdAt: any }> } | null };

export type ListGroupsQueryVariables = Exact<{
  filter: GroupArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<GroupArgsSorter>;
}>;


export type ListGroupsQuery = { __typename?: 'Query', groups: { __typename?: 'PaginatedGroup', nodes?: Array<{ __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null, createdAt: any, updatedAt: any }> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, totalCount: number } | null } };

export type NewGroupFragment = { __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null, createdAt: any, updatedAt: any };

export type RemoveGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveGroupMutation = { __typename?: 'Mutation', removeGroup: { __typename?: 'Group', name: string } };

export type RemoveUsersFromGroupMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveUsersFromGroupMutation = { __typename?: 'Mutation', removeUsersFromGroup: { __typename?: 'Group', id: string, name: string, color: any, users: Array<{ __typename?: 'User', id: string, auth0Id?: string | null, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null, activityStatus: ActivityStatus, updatedAt: any, createdAt: any }> } };

export type UpdateGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateGroupInput: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup: { __typename?: 'Group', color: any, id: string, name: string, folderId?: string | null, createdAt: any, updatedAt: any } };

export type UpdateGroupFolderMutationVariables = Exact<{
  input: UpdateGroupFolderInput;
}>;


export type UpdateGroupFolderMutation = { __typename?: 'Mutation', updateGroupFolder: { __typename?: 'GroupFolder', id: string, name: string, parentId?: string | null, workspaceId: string, createdAt: any, updatedAt: any } };

export type UpdateGroupsResourceAccessMutationVariables = Exact<{
  updateGroupResourceAccessInput: UpdateGroupResourceAccessInput;
}>;


export type UpdateGroupsResourceAccessMutation = { __typename?: 'Mutation', updateGroupResourceAccess: Array<{ __typename: 'ResourceAccessUpdatedResult', id?: string | null, permissions: Array<Permission>, resourceId?: string | null, groupId: string }> };

export type TranslateContentQueryVariables = Exact<{
  locale: Scalars['Locale']['input'];
  resourceId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type TranslateContentQuery = { __typename?: 'Query', translateContent?: string | null };

export type ClearNotificationsMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  notificationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ClearNotificationsMutation = { __typename?: 'Mutation', clearNotifications: boolean };

export type NotificationFragment = { __typename?: 'Notification', id: string, createdAt: any, readAt?: any | null, topic: NotificationTopic, workspaceId: string, targets?: Array<
    | { __typename?: 'Question', id: string, title: string }
    | { __typename?: 'Resource', id: string, name: string }
    | { __typename?: 'Workspace', id: string, name: string }
  > | null };

export type GetMyNotificationsQueryVariables = Exact<{
  filter?: InputMaybe<NotificationArgsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<NotificationArgsSorter>;
}>;


export type GetMyNotificationsQuery = { __typename?: 'Query', myNotifications: { __typename?: 'PaginatedNotification', unreadCount: number, nodes?: Array<{ __typename?: 'Notification', id: string, createdAt: any, readAt?: any | null, topic: NotificationTopic, workspaceId: string, targets?: Array<
        | { __typename?: 'Question', id: string, title: string }
        | { __typename?: 'Resource', id: string, name: string }
        | { __typename?: 'Workspace', id: string, name: string }
      > | null }> | null, pageInfo?: { __typename?: 'PageInfo', totalCount: number } | null } };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  notificationIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type MarkNotificationsAsReadMutation = { __typename?: 'Mutation', markNotificationsAsRead: Array<{ __typename?: 'Notification', id: string, readAt?: any | null }> };

export type NotificationsSubscriptionVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type NotificationsSubscription = { __typename?: 'Subscription', notifications: { __typename?: 'Notification', id: string, createdAt: any, readAt?: any | null, topic: NotificationTopic, workspaceId: string, targets?: Array<
      | { __typename?: 'Question', id: string, title: string }
      | { __typename?: 'Resource', id: string, name: string }
      | { __typename?: 'Workspace', id: string, name: string }
    > | null } };

export type ResourceForPermissionListItemFragment = { __typename?: 'Resource', id: string, index?: string | null, name: string, workspaceId: string, type: ResourceType, mimeType?: string | null, parentId?: string | null, accesses: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, resourceId?: string | null, groupId: string }>, inheritedAccesses: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, resourceId?: string | null, groupId: string }>, descendantsAccesses: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, resourceId?: string | null, groupId: string }> };

export type GetResourcesForPermissionsQueryVariables = Exact<{
  filter: ResourceArgsFilter;
  sorter?: InputMaybe<ResourceArgsSorter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetResourcesForPermissionsQuery = { __typename?: 'Query', resources: { __typename?: 'PaginatedResource', nodes?: Array<{ __typename?: 'Resource', id: string, index?: string | null, name: string, workspaceId: string, type: ResourceType, mimeType?: string | null, parentId?: string | null, accesses: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, resourceId?: string | null, groupId: string }>, inheritedAccesses: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, resourceId?: string | null, groupId: string }>, descendantsAccesses: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, resourceId?: string | null, groupId: string }> }> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, totalCount: number } | null } };

export type GetResourcesForPermissionsWithoutPaginationQueryVariables = Exact<{
  filter: ResourceArgsFilter;
  sorter?: InputMaybe<ResourceArgsSorter>;
}>;


export type GetResourcesForPermissionsWithoutPaginationQuery = { __typename?: 'Query', resourcesWithoutPagination: Array<{ __typename?: 'Resource', id: string, index?: string | null, name: string, workspaceId: string, type: ResourceType, mimeType?: string | null, parentId?: string | null, accesses: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, resourceId?: string | null, groupId: string }>, inheritedAccesses: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, resourceId?: string | null, groupId: string }>, descendantsAccesses: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, resourceId?: string | null, groupId: string }> }> };

export type RedactionFragment = { __typename?: 'Redaction', id: string, createdAt: any, updatedAt: any, status: RedactionStatusType, entity: RedactEntity, resourceId: string, text?: string | null, resource: { __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null, pspdfKitId?: string | null }, matchData: Array<{ __typename?: 'RedactMatch', id?: string | null, isAnnotation?: boolean | null, pageIndex?: number | null, previewText?: string | null, rangeInPreview?: Array<number> | null, rectsOnPage?: Array<Array<number>> | null }> };

export type GetRedactionsQueryVariables = Exact<{
  filter: RedactionArgsFilter;
  sorter?: InputMaybe<RedactionArgsSorter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRedactionsQuery = { __typename?: 'Query', redactions: { __typename?: 'PaginatedRedaction', pageInfo?: { __typename?: 'PageInfo', offset?: number | null, totalCount: number } | null, nodes?: Array<{ __typename?: 'Redaction', id: string, createdAt: any, updatedAt: any, status: RedactionStatusType, entity: RedactEntity, resourceId: string, text?: string | null, resource: { __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null, pspdfKitId?: string | null }, matchData: Array<{ __typename?: 'RedactMatch', id?: string | null, isAnnotation?: boolean | null, pageIndex?: number | null, previewText?: string | null, rangeInPreview?: Array<number> | null, rectsOnPage?: Array<Array<number>> | null }> }> | null } };

export type GetRedactionsSummaryQueryVariables = Exact<{
  filter: RedactionArgsFilter;
  sorter?: InputMaybe<RedactionArgsSorter>;
}>;


export type GetRedactionsSummaryQuery = { __typename?: 'Query', redactionsSummary: { __typename?: 'RedactedFiles', counts: { __typename?: 'RedactedFilesSummary', status: { __typename?: 'RedactedFilesStatus', redacted: number, ignored: number, pending: number, failed: number }, keywords: Array<{ __typename?: 'RedactedFilesSingleKeywordCount', keyword: string, count: number }> } } };

export type RedactEntitiesJobMutationVariables = Exact<{
  filter: RedactionArgsFilter;
  action: Scalars['String']['input'];
  include?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  exclude?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type RedactEntitiesJobMutation = { __typename?: 'Mutation', redactEntities: boolean };

export type RedactSearchQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  files: Array<Scalars['String']['input']> | Scalars['String']['input'];
  entities?: InputMaybe<Array<RedactEntityArgs> | RedactEntityArgs>;
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type RedactSearchQuery = { __typename?: 'Query', redactSearchResults: Array<{ __typename?: 'Redaction', id: string, text?: string | null, entity: RedactEntity, status: RedactionStatusType, matchData: Array<{ __typename?: 'RedactMatch', id?: string | null, pageIndex?: number | null, previewText?: string | null, rangeInPreview?: Array<number> | null, rectsOnPage?: Array<Array<number>> | null }> }> };

export type ResourcesRedactedSubscriptionVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type ResourcesRedactedSubscription = { __typename?: 'Subscription', resourcesRedacted: string };

export type DocumentClassificationFragmentFragment = { __typename?: 'DocumentClassification', id: string, suggestedFolderId?: string | null, confidence?: number | null, reasoning?: string | null, status: ClassificationStatus, reclassifiedToFolderId?: string | null, uploadSource: UploadSource, validatedAt?: any | null, createdAt: any, updatedAt: any, resource: { __typename?: 'Resource', id: string, name: string, summary?: string | null } };

export type RequestListFolderFragmentFragment = { __typename?: 'Resource', id: string, publicId: string, name: string, index?: string | null, rank?: number | null, parentId?: string | null, createdAt: any, updatedAt: any, requestMetadata?: { __typename?: 'FolderRequestMetadata', status: RequestListStatus, description?: string | null, receivedAt?: any | null, validatedAt?: any | null } | null, requestFiles: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }> };

export type BulkUpdateRequestListStatusMutationVariables = Exact<{
  input: BulkUpdateStatusInput;
}>;


export type BulkUpdateRequestListStatusMutation = { __typename?: 'Mutation', bulkUpdateRequestListStatus: Array<{ __typename?: 'Resource', id: string, publicId: string, name: string, index?: string | null, rank?: number | null, parentId?: string | null, createdAt: any, updatedAt: any, requestMetadata?: { __typename?: 'FolderRequestMetadata', status: RequestListStatus, description?: string | null, receivedAt?: any | null, validatedAt?: any | null } | null, requestFiles: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }> }> };

export type CreateRequestListFolderMutationVariables = Exact<{
  input: CreateRequestListFolderInput;
}>;


export type CreateRequestListFolderMutation = { __typename?: 'Mutation', createRequestListFolder: { __typename?: 'Resource', id: string, publicId: string, name: string, index?: string | null, rank?: number | null, parentId?: string | null, createdAt: any, updatedAt: any, requestMetadata?: { __typename?: 'FolderRequestMetadata', status: RequestListStatus, description?: string | null, receivedAt?: any | null, validatedAt?: any | null } | null, requestFiles: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }> } };

export type DeleteRequestListFoldersMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type DeleteRequestListFoldersMutation = { __typename?: 'Mutation', deleteRequestListFolders: Array<string> };

export type GenerateAiDescriptionsMutationVariables = Exact<{
  input: GenerateAiDescriptionsInput;
}>;


export type GenerateAiDescriptionsMutation = { __typename?: 'Mutation', generateAIDescriptions: boolean };

export type GetRequestListFolderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type GetRequestListFolderQuery = { __typename?: 'Query', requestListFolder?: { __typename?: 'Resource', id: string, publicId: string, name: string, index?: string | null, rank?: number | null, parentId?: string | null, createdAt: any, updatedAt: any, requestMetadata?: { __typename?: 'FolderRequestMetadata', status: RequestListStatus, description?: string | null, receivedAt?: any | null, validatedAt?: any | null } | null, requestFiles: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }> } | null };

export type ImportRequestListMutationVariables = Exact<{
  input: ImportRequestListInput;
}>;


export type ImportRequestListMutation = { __typename?: 'Mutation', importRequestList: Array<{ __typename?: 'Resource', id: string, publicId: string, name: string, index?: string | null, rank?: number | null, parentId?: string | null, createdAt: any, updatedAt: any, requestMetadata?: { __typename?: 'FolderRequestMetadata', status: RequestListStatus, description?: string | null, receivedAt?: any | null, validatedAt?: any | null } | null, requestFiles: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }> }> };

export type ItemDescriptionGeneratedSubscriptionVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type ItemDescriptionGeneratedSubscription = { __typename?: 'Subscription', itemDescriptionGenerated: { __typename?: 'ItemDescriptionGeneratedOutput', id: string, description: string } };

export type ListRequestListFoldersQueryVariables = Exact<{
  filter: RequestListArgsFilter;
  sorter?: InputMaybe<RequestListArgsSorter>;
}>;


export type ListRequestListFoldersQuery = { __typename?: 'Query', requestListFolders: Array<{ __typename?: 'Resource', id: string, publicId: string, name: string, index?: string | null, rank?: number | null, parentId?: string | null, createdAt: any, updatedAt: any, requestMetadata?: { __typename?: 'FolderRequestMetadata', status: RequestListStatus, description?: string | null, receivedAt?: any | null, validatedAt?: any | null } | null, requestFiles: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }> }> };

export type RecentClassifiedDocumentsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentClassifiedDocumentsQuery = { __typename?: 'Query', recentClassifiedDocuments: { __typename?: 'PaginatedDocumentClassification', nodes?: Array<{ __typename?: 'DocumentClassification', id: string, suggestedFolderId?: string | null, confidence?: number | null, reasoning?: string | null, status: ClassificationStatus, reclassifiedToFolderId?: string | null, uploadSource: UploadSource, validatedAt?: any | null, createdAt: any, updatedAt: any, resource: { __typename?: 'Resource', id: string, name: string, summary?: string | null } }> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, totalCount: number } | null } };

export type RecentDirectUploadDocumentsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentDirectUploadDocumentsQuery = { __typename?: 'Query', recentDirectUploadDocuments: { __typename?: 'PaginatedDocumentClassification', nodes?: Array<{ __typename?: 'DocumentClassification', id: string, suggestedFolderId?: string | null, confidence?: number | null, reasoning?: string | null, status: ClassificationStatus, reclassifiedToFolderId?: string | null, uploadSource: UploadSource, validatedAt?: any | null, createdAt: any, updatedAt: any, resource: { __typename?: 'Resource', id: string, name: string, summary?: string | null } }> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, totalCount: number } | null } };

export type RecentPendingValidationDocumentsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentPendingValidationDocumentsQuery = { __typename?: 'Query', recentPendingValidationDocuments: { __typename?: 'PaginatedDocumentClassification', nodes?: Array<{ __typename?: 'DocumentClassification', id: string, suggestedFolderId?: string | null, confidence?: number | null, reasoning?: string | null, status: ClassificationStatus, reclassifiedToFolderId?: string | null, uploadSource: UploadSource, validatedAt?: any | null, createdAt: any, updatedAt: any, resource: { __typename?: 'Resource', id: string, name: string, summary?: string | null } }> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, totalCount: number } | null } };

export type RecentUnclassifiedDocumentsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentUnclassifiedDocumentsQuery = { __typename?: 'Query', recentUnclassifiedDocuments: { __typename?: 'PaginatedDocumentClassification', nodes?: Array<{ __typename?: 'DocumentClassification', id: string, suggestedFolderId?: string | null, confidence?: number | null, reasoning?: string | null, status: ClassificationStatus, reclassifiedToFolderId?: string | null, uploadSource: UploadSource, validatedAt?: any | null, createdAt: any, updatedAt: any, resource: { __typename?: 'Resource', id: string, name: string, summary?: string | null } }> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, totalCount: number } | null } };

export type ReclassifyDocumentMutationVariables = Exact<{
  input: ReclassifyDocumentInput;
}>;


export type ReclassifyDocumentMutation = { __typename?: 'Mutation', reclassifyDocument: { __typename?: 'DocumentClassification', id: string, suggestedFolderId?: string | null, confidence?: number | null, reasoning?: string | null, status: ClassificationStatus, reclassifiedToFolderId?: string | null, uploadSource: UploadSource, validatedAt?: any | null, createdAt: any, updatedAt: any, resource: { __typename?: 'Resource', id: string, name: string, summary?: string | null } } };

export type UpdateRequestListFolderMutationVariables = Exact<{
  input: UpdateRequestListFolderInput;
}>;


export type UpdateRequestListFolderMutation = { __typename?: 'Mutation', updateRequestListFolder: { __typename?: 'Resource', id: string, publicId: string, name: string, index?: string | null, rank?: number | null, parentId?: string | null, createdAt: any, updatedAt: any, requestMetadata?: { __typename?: 'FolderRequestMetadata', status: RequestListStatus, description?: string | null, receivedAt?: any | null, validatedAt?: any | null } | null, requestFiles: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }> } };

export type UploadToRequestListFolderMutationVariables = Exact<{
  input: UploadToRequestListFolderInput;
}>;


export type UploadToRequestListFolderMutation = { __typename?: 'Mutation', uploadToRequestListFolder: Array<{ __typename?: 'Resource', id: string, index?: string | null, rank?: number | null, publicId: string, parentId?: string | null, workspaceId: string, name: string, type: ResourceType, canDownload: boolean, mimeType?: string | null, size: any, pspdfKitId?: string | null, isFavorite: boolean, createdAt: any, updatedAt: any, archivedAt?: any | null, createdBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null } }> };

export type ValidateAllClassificationsMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type ValidateAllClassificationsMutation = { __typename?: 'Mutation', validateAllClassifications: boolean };

export type ValidateClassificationMutationVariables = Exact<{
  input: ValidateClassificationInput;
}>;


export type ValidateClassificationMutation = { __typename?: 'Mutation', validateClassification: { __typename?: 'DocumentClassification', id: string, suggestedFolderId?: string | null, confidence?: number | null, reasoning?: string | null, status: ClassificationStatus, reclassifiedToFolderId?: string | null, uploadSource: UploadSource, validatedAt?: any | null, createdAt: any, updatedAt: any, resource: { __typename?: 'Resource', id: string, name: string, summary?: string | null } } };

export type ResourceRowFragmentFragment = { __typename?: 'Resource', id: string, index?: string | null, rank?: number | null, publicId: string, parentId?: string | null, workspaceId: string, name: string, type: ResourceType, canDownload: boolean, mimeType?: string | null, size: any, pspdfKitId?: string | null, isFavorite: boolean, createdAt: any, updatedAt: any, archivedAt?: any | null, createdBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null } };

export type BulkMoveResourcesMutationVariables = Exact<{
  resourcesToMove: Array<Scalars['String']['input']> | Scalars['String']['input'];
  to?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BulkMoveResourcesMutation = { __typename?: 'Mutation', bulkMoveResources: Array<{ __typename?: 'Resource', id: string, parentId?: string | null, workspaceId: string, name: string, type: ResourceType, mimeType?: string | null, size: any, pspdfKitId?: string | null, isFavorite: boolean, createdAt: any, updatedAt: any, archivedAt?: any | null, redactions?: Array<{ __typename?: 'Redaction', id: string, entity: RedactEntity, text?: string | null, matchData: Array<{ __typename?: 'RedactMatch', pageIndex?: number | null, previewText?: string | null, rangeInPreview?: Array<number> | null, rectsOnPage?: Array<Array<number>> | null }> }> | null, createdBy: { __typename?: 'User', id: string, auth0Id?: string | null, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null } }> };

export type BulkRenameResourcesMutationVariables = Exact<{
  renameComponents: Array<ResourceBulkRenameComponentType> | ResourceBulkRenameComponentType;
  resourcesToRename: Array<ResourceToRename> | ResourceToRename;
  renameOptions?: InputMaybe<Array<ResourceBulkRenameOptionType> | ResourceBulkRenameOptionType>;
  customValues?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type BulkRenameResourcesMutation = { __typename?: 'Mutation', bulkRenameResources: Array<{ __typename?: 'Resource', id: string, name: string, updatedAt: any }> };

export type CopyResourcesMutationVariables = Exact<{
  copyInput: CopyInput;
}>;


export type CopyResourcesMutation = { __typename?: 'Mutation', copy: Array<{ __typename?: 'Resource', id: string }> };

export type CreateDownloadActivityMutationVariables = Exact<{
  resourceId: Scalars['ID']['input'];
}>;


export type CreateDownloadActivityMutation = { __typename?: 'Mutation', createDownloadActivity: boolean };

export type CreateResourcesMutationVariables = Exact<{
  createResourcesInput: CreateResourcesInput;
}>;


export type CreateResourcesMutation = { __typename?: 'Mutation', createResources: Array<{ __typename?: 'Resource', id: string, index?: string | null, rank?: number | null, publicId: string, parentId?: string | null, workspaceId: string, name: string, type: ResourceType, canDownload: boolean, mimeType?: string | null, size: any, pspdfKitId?: string | null, isFavorite: boolean, createdAt: any, updatedAt: any, archivedAt?: any | null, createdBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null } }> };

export type ExportWorkspaceResourcesJobMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type ExportWorkspaceResourcesJobMutation = { __typename?: 'Mutation', exportWorkspaceResourcesJob: boolean };

export type FinalizeMultipartUploadMutationVariables = Exact<{
  finalizeMultipartUploadInput: FinalizeMultipartUploadInput;
}>;


export type FinalizeMultipartUploadMutation = { __typename?: 'Mutation', finalizeMultipartUpload?: string | null };

export type GetDatadumpConfigQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetDatadumpConfigQuery = { __typename?: 'Query', datadumpConfig?: { __typename?: 'DatadumpConfig', id: string, dataroomFolderId?: string | null, datadumpFolderId?: string | null } | null };

export type GetMultipartPreSignedUrlsQueryVariables = Exact<{
  fileKey: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
  parts: Scalars['Int']['input'];
}>;


export type GetMultipartPreSignedUrlsQuery = { __typename?: 'Query', getMultipartPreSignedUrls: Array<string> };

export type GetNonDownloadableResourcesQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  resourceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetNonDownloadableResourcesQuery = { __typename?: 'Query', nonDownloadableResources: Array<{ __typename?: 'Resource', id: string, name: string }> };

export type GetOneResourceQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  resourceId: Scalars['ID']['input'];
  isViewed?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOneResourceQuery = { __typename?: 'Query', resource: { __typename?: 'Resource', id: string, index?: string | null, rank?: number | null, publicId: string, parentId?: string | null, workspaceId: string, name: string, type: ResourceType, canDownload: boolean, viewUrl?: string | null, mimeType?: string | null, size: any, summary?: string | null, pspdfKitId?: string | null, isFavorite: boolean, isFaulty: boolean, isQaOnly: boolean, createdAt: any, updatedAt: any, accesses: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, resourceId?: string | null, groupId: string }>, inheritedAccesses: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, resourceId?: string | null, groupId: string }>, descendantsAccesses: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, resourceId?: string | null, groupId: string }>, redactions?: Array<{ __typename?: 'Redaction', id: string, status: RedactionStatusType, entity: RedactEntity, text?: string | null, matchData: Array<{ __typename?: 'RedactMatch', id?: string | null, pageIndex?: number | null, previewText?: string | null, rangeInPreview?: Array<number> | null, rectsOnPage?: Array<Array<number>> | null, isAnnotation?: boolean | null }> }> | null, activities: Array<{ __typename?: 'Activity', id: string, topic: ActivityTopic, createdAt: any }>, createdBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null }, metadata?:
      | { __typename?: 'CustomerAgreementMetadataType', documentType: string, customer?: string | null, startDate?: string | null, endDate?: string | null, terminationClause?: string | null, earlyTerminationIndemnity?: string | null, limitationOfLiability?: string | null, changeOfControl?: string | null, exclusivity?: string | null, contractValue?: string | null }
      | { __typename?: 'EmployeeAgreementMetadataType', documentType: string, employee?: string | null, jobTitle?: string | null, hiringDate?: string | null, baseSalary?: string | null, ote?: string | null, nonCompete?: string | null, nonSolicitation?: string | null, ipClause?: string | null, governingLaw?: string | null }
      | { __typename?: 'GenericDocumentMetadataType', documentType: string }
      | { __typename?: 'LeaseMetadataType', documentType: string, document?: string | null, address?: string | null, term?: string | null, earlyTerminationAndRenewal?: string | null, annualRent?: string | null, increaseAnnual?: string | null, geoRisks?: string | null }
     | null } };

export type GetParentPermissionsQueryVariables = Exact<{
  filter: ResourceArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetParentPermissionsQuery = { __typename?: 'Query', resources: { __typename?: 'PaginatedResource', nodes?: Array<{ __typename?: 'Resource', id: string, name: string, accesses: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, groupId: string, group?: { __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null } | null }>, inheritedAccesses: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, groupId: string, group?: { __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null } | null }> }> | null } };

export type GetResourceDownloadUrlQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  resourceId: Scalars['ID']['input'];
}>;


export type GetResourceDownloadUrlQuery = { __typename?: 'Query', resourceDownloadUrl?: string | null };

export type GetResourcePathQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  resourceId: Scalars['ID']['input'];
}>;


export type GetResourcePathQuery = { __typename?: 'Query', resource: { __typename?: 'Resource', id: string, name: string, path: Array<{ __typename?: 'Resource', id: string, name: string }> } };

export type GetResourceRedactedUrlQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  resourceId: Scalars['ID']['input'];
}>;


export type GetResourceRedactedUrlQuery = { __typename?: 'Query', resourceRedactedUrl?: string | null };

export type GetResourcesAccessQueryVariables = Exact<{
  filter: ResourceArgsFilter;
  sorter?: InputMaybe<ResourceArgsSorter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetResourcesAccessQuery = { __typename?: 'Query', resources: { __typename?: 'PaginatedResource', nodes?: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, resourceAccess?: Array<{ __typename?: 'ResourceAccess', id: string, permissions: Array<Permission>, groupId: string, resourceId?: string | null }> | null }> | null } };

export type ResourceSearchItemFragment = { __typename?: 'Resource', id: string, index?: string | null, name: string, workspaceId: string, type: ResourceType, mimeType?: string | null, size: any, publicId: string, isFavorite: boolean, pspdfKitId?: string | null, createdAt: any, createdBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null } };

export type GetResourcesSearchQueryVariables = Exact<{
  filter: ResourceArgsFilter;
  sorter?: InputMaybe<ResourceArgsSorter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetResourcesSearchQuery = { __typename?: 'Query', resources: { __typename?: 'PaginatedResource', nodes?: Array<{ __typename?: 'Resource', id: string, index?: string | null, name: string, workspaceId: string, type: ResourceType, mimeType?: string | null, size: any, publicId: string, isFavorite: boolean, pspdfKitId?: string | null, createdAt: any, createdBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null } }> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, totalCount: number } | null } };

export type GetUploadSignedUrlQueryVariables = Exact<{
  fileKey: Scalars['String']['input'];
}>;


export type GetUploadSignedUrlQuery = { __typename?: 'Query', resourceUploadSignedUrl: string };

export type InitializeMultipartUploadMutationVariables = Exact<{
  fileKey: Scalars['String']['input'];
}>;


export type InitializeMultipartUploadMutation = { __typename?: 'Mutation', initializeMultipartUpload: { __typename?: 'InitializeMultipartUploadOutput', uploadId: string, fileKey: string } };

export type ListResourceQuestionsQueryVariables = Exact<{
  filter: QuestionArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<QuestionArgSorter>;
}>;


export type ListResourceQuestionsQuery = { __typename?: 'Query', questions: { __typename?: 'PaginatedQuestions', nodes?: Array<{ __typename?: 'Question', id: string, title: string, priority: QuestionPriority, createdAt: any, archivedAt?: any | null, createdBy: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null } }> | null } };

export type ListResourcesQueryVariables = Exact<{
  filter: ResourceArgsFilter;
  sorter?: InputMaybe<ResourceArgsSorter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListResourcesQuery = { __typename?: 'Query', resources: { __typename?: 'PaginatedResource', nodes?: Array<{ __typename?: 'Resource', id: string, index?: string | null, rank?: number | null, publicId: string, parentId?: string | null, workspaceId: string, name: string, type: ResourceType, canDownload: boolean, mimeType?: string | null, size: any, pspdfKitId?: string | null, isFavorite: boolean, createdAt: any, updatedAt: any, archivedAt?: any | null, createdBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null } }> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, totalCount: number } | null } };

export type ManualRedactMutationVariables = Exact<{
  manualRedactInput: ManualRedactInput;
}>;


export type ManualRedactMutation = { __typename?: 'Mutation', manualRedact: boolean };

export type NewResourceFragment = { __typename?: 'Resource', id: string, name: string, parentId?: string | null, workspaceId: string, type: ResourceType, mimeType?: string | null };

export type RemoveRedactionsMutationVariables = Exact<{
  redactionIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type RemoveRedactionsMutation = { __typename?: 'Mutation', removeRedactions: Array<{ __typename?: 'Resource', id: string, redactions?: Array<{ __typename?: 'Redaction', id: string, status: RedactionStatusType }> | null }> };

export type RemoveResourcesMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  resourceIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  deleteAction: DeleteAction;
  selectAll?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RemoveResourcesMutation = { __typename?: 'Mutation', removeResources: boolean };

export type ReprocessResourcesMutationVariables = Exact<{
  resourceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReprocessResourcesMutation = { __typename?: 'Mutation', reprocessResources: number };

export type ResourcesIndexViewQueryVariables = Exact<{
  filter: ResourceArgsFilter;
  sorter?: InputMaybe<ResourceArgsSorter>;
}>;


export type ResourcesIndexViewQuery = { __typename?: 'Query', resourcesIndexView: Array<{ __typename?: 'ResourceIndexView', id: string, name: string, index?: string | null, rank?: number | null, size?: number | null, type: ResourceType, pspdfKitId?: string | null, parentId?: string | null, mimeType?: string | null, createdAt: any, workspaceId: string }> };

export type RestoreResourcesMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  resourceIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  selectAll?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type RestoreResourcesMutation = { __typename?: 'Mutation', restoreResources: boolean };

export type SuggestRenameMutationVariables = Exact<{
  suggestRenameInput: SuggestRenameInput;
}>;


export type SuggestRenameMutation = { __typename?: 'Mutation', suggestRename: string };

export type UpdateFavoriteResourcesMutationVariables = Exact<{
  updateFavoriteResourcesInput: UpdateFavoriteResourcesInput;
}>;


export type UpdateFavoriteResourcesMutation = { __typename?: 'Mutation', updateFavoriteResources: Array<{ __typename?: 'Resource', id: string, name: string, isFavorite: boolean, updatedAt: any }> };

export type UpdateResourceMutationVariables = Exact<{
  updateResourceInput: UpdateResourceInput;
}>;


export type UpdateResourceMutation = { __typename?: 'Mutation', updateResource: { __typename?: 'Resource', id: string, name: string, isFavorite: boolean, updatedAt: any } };

export type ZipFilesAndSendByEmailMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  resourceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  selectAll?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  permission?: InputMaybe<Permission>;
}>;


export type ZipFilesAndSendByEmailMutation = { __typename?: 'Mutation', zipFilesAndSendByEmail: boolean };

export type CreateRoleMutationVariables = Exact<{
  createRoleInput: CreateRoleInput;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole: { __typename?: 'Role', id: string, name: string, isAdmin: boolean, summaryFrequency?: SummarySettingFrequency | null, permissions: { __typename?: 'WorkspacePermission', manageResources: boolean, canAnswerQuestions: boolean, manageUsersAndPermissions: boolean } } };

export type DeleteRoleMutationVariables = Exact<{
  roleId: Scalars['ID']['input'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole: boolean };

export type RoleFragment = { __typename?: 'Role', id: string, name: string, isAdmin: boolean, summaryFrequency?: SummarySettingFrequency | null, permissions: { __typename?: 'WorkspacePermission', manageResources: boolean, canAnswerQuestions: boolean, manageUsersAndPermissions: boolean } };

export type GetRolesQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetRolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, name: string, isAdmin: boolean, summaryFrequency?: SummarySettingFrequency | null, permissions: { __typename?: 'WorkspacePermission', manageResources: boolean, canAnswerQuestions: boolean, manageUsersAndPermissions: boolean } }> };

export type UpdateRoleMutationVariables = Exact<{
  updateRoleInput: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'Role', id: string, name: string, isAdmin: boolean, summaryFrequency?: SummarySettingFrequency | null, permissions: { __typename?: 'WorkspacePermission', manageResources: boolean, canAnswerQuestions: boolean, manageUsersAndPermissions: boolean } } };

export type QuestionSearchResultFragment = { __typename?: 'QuestionSearchDto', id: string, title: string, publicId: string };

export type SearchResultFragment = { __typename?: 'SearchDto', resources: { __typename?: 'ResourceSearchResult', totalCount: number, items: Array<{ __typename?: 'ResourceSearchDto', id: string, index?: string | null, mimeType?: string | null, name: string, type: ResourceType }> }, questions: { __typename?: 'QuestionSearchResult', totalCount: number, items: Array<{ __typename?: 'QuestionSearchDto', id: string, title: string, publicId: string }> } };

export type SearchQueryVariables = Exact<{
  filter: SearchArgsFilter;
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchQuery = { __typename?: 'Query', search: { __typename?: 'SearchDto', resources: { __typename?: 'ResourceSearchResult', totalCount: number, items: Array<{ __typename?: 'ResourceSearchDto', id: string, index?: string | null, mimeType?: string | null, name: string, type: ResourceType }> }, questions: { __typename?: 'QuestionSearchResult', totalCount: number, items: Array<{ __typename?: 'QuestionSearchDto', id: string, title: string, publicId: string }> } } };

export type TrackSearchMutationVariables = Exact<{
  input: TrackSearchInput;
}>;


export type TrackSearchMutation = { __typename?: 'Mutation', trackSearch: boolean };

export type AssignOwnerToQuestionMutationVariables = Exact<{
  assignOwnerInput: AssignOwnerInput;
}>;


export type AssignOwnerToQuestionMutation = { __typename?: 'Mutation', assignOwnerToQuestion: Array<{ __typename?: 'Question', id: string, owners: Array<{ __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null }> }> };

export type ConfirmAnswerMutationVariables = Exact<{
  confirmAnswerInput: ConfirmAnswerInput;
}>;


export type ConfirmAnswerMutation = { __typename?: 'Mutation', confirmAnswer: Array<{ __typename?: 'Answer', id: string }> };

export type CreateQuestionMutationVariables = Exact<{
  createQuestionInput: CreateQuestionInput;
}>;


export type CreateQuestionMutation = { __typename?: 'Mutation', createQuestion: Array<{ __typename?: 'Question', id: string, publicId: string, title: string, priority: QuestionPriority, resolutionStatus: QuestionResolutionStatus, isAnswered: boolean, answersCount: number, createdAt: any, updatedAt: any, archivedAt?: any | null, resources: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }>, createdBy: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null }, owners: Array<{ __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, color: any }>, latestAnswer?: { __typename?: 'Answer', id: string, description?: string | null } | null }> };

export type CreateTopicMutationVariables = Exact<{
  input: CreateTopicInput;
}>;


export type CreateTopicMutation = { __typename?: 'Mutation', createTopic: { __typename?: 'Topic', id: string, name: string } };

export type DeleteAnswersMutationVariables = Exact<{
  deleteAnswersInput: DeleteAnswersInput;
}>;


export type DeleteAnswersMutation = { __typename?: 'Mutation', deleteAnswers: Array<{ __typename?: 'Answer', id: string }> };

export type DeleteQuestionsMutationVariables = Exact<{
  deleteQuestionsInput: DeleteQuestionsInput;
}>;


export type DeleteQuestionsMutation = { __typename?: 'Mutation', deleteQuestions: Array<{ __typename?: 'Question', id: string }> };

export type DeleteTopicMutationVariables = Exact<{
  topicId: Scalars['ID']['input'];
}>;


export type DeleteTopicMutation = { __typename?: 'Mutation', deleteTopic: boolean };

export type ExportQuestionsMutationVariables = Exact<{
  exportQuestionInput: ExportQuestionInput;
}>;


export type ExportQuestionsMutation = { __typename?: 'Mutation', exportQuestions: { __typename?: 'ExportQuestionLink', downloadLink: string } };

export type GetOneQuestionQueryVariables = Exact<{
  questionId: Scalars['ID']['input'];
}>;


export type GetOneQuestionQuery = { __typename?: 'Query', question: { __typename?: 'Question', id: string, publicId: string, title: string, priority: QuestionPriority, resolutionStatus: QuestionResolutionStatus, description?: string | null, isAnswered: boolean, answersCount: number, createdAt: any, updatedAt: any, hasConfirmedAnswer: boolean, duplicateQuestionIds?: Array<string> | null, assignedTopics: Array<{ __typename?: 'Topic', id: string, name: string }>, createdBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null }, resources: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }>, owners: Array<{ __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, color: any }>, duplicates: Array<{ __typename?: 'Question', id: string, publicId: string, title: string, answersCount: number, createdAt: any, latestAnswer?: { __typename?: 'Answer', id: string, description?: string | null, resources: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }> } | null }> } };

export type GetThreadQueryVariables = Exact<{
  filter: ThreadArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<ThreadArgsSorter>;
}>;


export type GetThreadQuery = { __typename?: 'Query', thread: { __typename?: 'PaginatedThread', nodes?: Array<{ __typename?: 'Answer', id: string, description?: string | null, parentQuestionId: string, isConfirmed: boolean, isFollowUp: boolean, editedAt?: any | null, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null }, resources: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }>, readReceipts: Array<{ __typename?: 'AnswerReadReceipt', readAt?: any | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null } }> }> | null } };

export type TopicsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  sorter?: InputMaybe<TopicSorter>;
}>;


export type TopicsQuery = { __typename?: 'Query', topics: Array<{ __typename?: 'Topic', id: string, name: string, createdAt: any, assignedUsers?: Array<{ __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null, activityStatus: ActivityStatus }> | null }> };

export type QuestionListItemFragment = { __typename?: 'Question', id: string, publicId: string, title: string, priority: QuestionPriority, resolutionStatus: QuestionResolutionStatus, isAnswered: boolean, answersCount: number, hasConfirmedAnswer: boolean, duplicateQuestionIds?: Array<string> | null, createdAt: any, updatedAt: any, archivedAt?: any | null, assignedTopics: Array<{ __typename?: 'Topic', id: string, name: string }>, resources: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }>, createdBy: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null }, owners: Array<{ __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, color: any }>, latestAnswer?: { __typename?: 'Answer', id: string, description?: string | null, isFollowUp: boolean } | null };

export type ListQuestionsQueryVariables = Exact<{
  filter: QuestionArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<QuestionArgSorter>;
}>;


export type ListQuestionsQuery = { __typename?: 'Query', questions: { __typename?: 'PaginatedQuestions', pageInfo?: { __typename?: 'PageInfo', totalCount: number, offset?: number | null } | null, nodes?: Array<{ __typename?: 'Question', id: string, publicId: string, title: string, priority: QuestionPriority, resolutionStatus: QuestionResolutionStatus, isAnswered: boolean, answersCount: number, hasConfirmedAnswer: boolean, duplicateQuestionIds?: Array<string> | null, createdAt: any, updatedAt: any, archivedAt?: any | null, assignedTopics: Array<{ __typename?: 'Topic', id: string, name: string }>, resources: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }>, createdBy: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null }, owners: Array<{ __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, color: any }>, latestAnswer?: { __typename?: 'Answer', id: string, description?: string | null, isFollowUp: boolean } | null }> | null } };

export type MarkAnswersAsReadMutationVariables = Exact<{
  markAnswersAsReadInput: MarkAnswersAsReadInput;
}>;


export type MarkAnswersAsReadMutation = { __typename?: 'Mutation', markAnswersAsRead: boolean };

export type MarkQuestionAsReadMutationVariables = Exact<{
  markQuestionAsReadInput: MarkQuestionAsReadInput;
}>;


export type MarkQuestionAsReadMutation = { __typename?: 'Mutation', markQuestionAsRead: boolean };

export type ReplyInThreadMutationVariables = Exact<{
  replyInThreadInput: ReplyInThreadInput;
}>;


export type ReplyInThreadMutation = { __typename?: 'Mutation', replyInThread: { __typename?: 'Answer', id: string, description?: string | null, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null }, resources: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }> } };

export type ToggleWorkspaceSupportStatusMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type ToggleWorkspaceSupportStatusMutation = { __typename?: 'Mutation', toggleWorkspaceSupportStatus: { __typename?: 'Workspace', id: string, name: string, supportStatus: WorkspaceSupportStatusType } };

export type UnconfirmAnswerMutationVariables = Exact<{
  unconfirmAnswerInput: UnconfirmAnswerInput;
}>;


export type UnconfirmAnswerMutation = { __typename?: 'Mutation', unconfirmAnswer: Array<{ __typename?: 'Answer', id: string }> };

export type UpdateAnswerMutationVariables = Exact<{
  updateAnswerInput: UpdateAnswerInput;
}>;


export type UpdateAnswerMutation = { __typename?: 'Mutation', updateAnswer: { __typename?: 'Answer', id: string, description?: string | null, parentQuestionId: string, createdAt: any, updatedAt: any, createdBy: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null } } };

export type UpdateQuestionMutationVariables = Exact<{
  updateQuestionInput: UpdateQuestionInput;
}>;


export type UpdateQuestionMutation = { __typename?: 'Mutation', updateQuestion: { __typename?: 'Question', id: string, publicId: string, title: string, priority: QuestionPriority, resolutionStatus: QuestionResolutionStatus, description?: string | null, isAnswered: boolean, answersCount: number, createdAt: any, updatedAt: any, resources: Array<{ __typename?: 'Resource', id: string, name: string, type: ResourceType, mimeType?: string | null }>, createdBy: { __typename?: 'User', firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null }, owners: Array<{ __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null }>, groups: Array<{ __typename?: 'Group', id: string, name: string, color: any }>, latestAnswer?: { __typename?: 'Answer', id: string, description?: string | null, isFollowUp: boolean } | null } };

export type UpdateQuestionGroupsMutationVariables = Exact<{
  updateQuestionGroupsInput: UpdateQuestionGroupsInput;
}>;


export type UpdateQuestionGroupsMutation = { __typename?: 'Mutation', updateQuestionGroups: Array<{ __typename?: 'Question', id: string, groups: Array<{ __typename?: 'Group', id: string, name: string, color: any }> }> };

export type UpdateQuestionPriorityMutationVariables = Exact<{
  updateQuestionPriorityInput: UpdateQuestionPriorityInput;
}>;


export type UpdateQuestionPriorityMutation = { __typename?: 'Mutation', updateQuestionPriority: Array<{ __typename?: 'Question', id: string, priority: QuestionPriority }> };

export type UpdateQuestionResolutionStatusMutationVariables = Exact<{
  updateQuestionResolutionStatusInput: UpdateQuestionResolutionStatusInput;
}>;


export type UpdateQuestionResolutionStatusMutation = { __typename?: 'Mutation', updateQuestionResolutionStatus: Array<{ __typename?: 'Question', id: string, resolutionStatus: QuestionResolutionStatus }> };

export type UpdateQuestionTopicsMutationVariables = Exact<{
  updateQuestionTopicsInput: UpdateQuestionTopicsInput;
}>;


export type UpdateQuestionTopicsMutation = { __typename?: 'Mutation', updateQuestionTopics: Array<{ __typename?: 'Question', id: string }> };

export type UpdateTopicMutationVariables = Exact<{
  input: UpdateTopicInput;
}>;


export type UpdateTopicMutation = { __typename?: 'Mutation', updateTopic: { __typename?: 'Topic', id: string, name: string } };

export type UpdateTopicUserAssignmentsMutationVariables = Exact<{
  input: UpdateTopicUserAssignmentsInput;
}>;


export type UpdateTopicUserAssignmentsMutation = { __typename?: 'Mutation', updateTopicUserAssignments: Array<{ __typename?: 'Topic', id: string, name: string, assignedUsers?: Array<{ __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, pictureURL?: string | null, activityStatus: ActivityStatus }> | null }> };

export type GetOneUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type GetOneUserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, auth0Id?: string | null, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null, createdAt: any, groups?: Array<{ __typename?: 'Group', id: string, name: string, color: any }> | null } };

export type UserListItemFragment = { __typename?: 'User', id: string, auth0Id?: string | null, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null, activityStatus: ActivityStatus, createdAt: any, groups?: Array<{ __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null }> | null, workspaceUsers: Array<{ __typename?: 'WorkspaceUser', id: string, isSuspended: boolean, role: { __typename?: 'Role', id: string, name: string, isAdmin: boolean, summaryFrequency?: SummarySettingFrequency | null, permissions: { __typename?: 'WorkspacePermission', manageResources: boolean, canAnswerQuestions: boolean, manageUsersAndPermissions: boolean } }, user: { __typename?: 'User', id: string }, workspace: { __typename?: 'Workspace', id: string } }> };

export type GetUsersQueryVariables = Exact<{
  filter: UserArgsFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sorter?: InputMaybe<UserArgsSorter>;
  workspaceId: Scalars['ID']['input'];
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'PaginatedUser', nodes?: Array<{ __typename?: 'User', id: string, auth0Id?: string | null, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null, activityStatus: ActivityStatus, createdAt: any, groups?: Array<{ __typename?: 'Group', id: string, name: string, color: any, folderId?: string | null }> | null, workspaceUsers: Array<{ __typename?: 'WorkspaceUser', id: string, isSuspended: boolean, role: { __typename?: 'Role', id: string, name: string, isAdmin: boolean, summaryFrequency?: SummarySettingFrequency | null, permissions: { __typename?: 'WorkspacePermission', manageResources: boolean, canAnswerQuestions: boolean, manageUsersAndPermissions: boolean } }, user: { __typename?: 'User', id: string }, workspace: { __typename?: 'Workspace', id: string } }> }> | null, pageInfo?: { __typename?: 'PageInfo', offset?: number | null, totalCount: number } | null } };

export type NewUserFragment = { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null, activityStatus: ActivityStatus };

export type RefreshOnlineStatusMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshOnlineStatusMutation = { __typename?: 'Mutation', refreshOnlineStatus: boolean };

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null } };

export type UpdateUserGroupsMutationVariables = Exact<{
  updateGroupsInput: UpdateUserGroupsInput;
}>;


export type UpdateUserGroupsMutation = { __typename?: 'Mutation', updateGroups: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string, pictureURL?: string | null } };

export type AddUsersToWorkspaceMutationVariables = Exact<{
  addUsersToWorkspaceInput: Array<AddUserToWorkspaceInput> | AddUserToWorkspaceInput;
  workspaceId: Scalars['ID']['input'];
}>;


export type AddUsersToWorkspaceMutation = { __typename?: 'Mutation', addUsersToWorkspace: { __typename?: 'Workspace', id: string } };

export type ArchiveWorkspaceMutationVariables = Exact<{
  archiveWorkspaceId: Scalars['ID']['input'];
}>;


export type ArchiveWorkspaceMutation = { __typename?: 'Mutation', archiveWorkspace: boolean };

export type ChangeWorkspaceUserRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
}>;


export type ChangeWorkspaceUserRoleMutation = { __typename?: 'Mutation', changeWorkspaceUserRole: { __typename?: 'WorkspaceUser', id: string, role: { __typename?: 'Role', id: string, name: string, isAdmin: boolean, summaryFrequency?: SummarySettingFrequency | null, permissions: { __typename?: 'WorkspacePermission', manageResources: boolean, canAnswerQuestions: boolean, manageUsersAndPermissions: boolean } } } };

export type CreateVisitActivityMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type CreateVisitActivityMutation = { __typename?: 'Mutation', createVisitActivity: boolean };

export type GetCurrentWorkspaceQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetCurrentWorkspaceQuery = { __typename?: 'Query', workspace: { __typename?: 'Workspace', id: string, name: string, status: WorkspaceStatusType, isPaymentActive: boolean, isPaymentDetailsValidated: boolean, processingStatus: WorkspaceProcessingStatusType, supportStatus: WorkspaceSupportStatusType, tenant: { __typename?: 'Tenant', id: string, name: string }, workspaceSettings: { __typename?: 'WorkspaceSettings', modules: { __typename?: 'WorkspaceModules', analytics?: boolean | null, requestList?: boolean | null } } } };

export type GetWorkspaceSettingsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetWorkspaceSettingsQuery = { __typename?: 'Query', workspaceSettings: { __typename?: 'WorkspaceSettings', id: string, adminContact?: string | null, loginPageBackgroundUrl?: string | null, themeColor?: any | null, indexationMethod?: ResourceIndexationMethod | null, watermarkForPermissions?: Array<Permission> | null, watermarkPresets?: Array<WatermarkPreset> | null, updatedAt: any, autoTopicAssignment: boolean } };

export type MoveAndRankResourcesMutationVariables = Exact<{
  sourceId: Scalars['String']['input'];
  targetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MoveAndRankResourcesMutation = { __typename?: 'Mutation', moveAndRankResources: boolean };

export type ReindexWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  folderId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ReindexWorkspaceMutation = { __typename?: 'Mutation', reindexWorkspace: boolean };

export type ResendUserInviteQueryVariables = Exact<{
  userToInviteId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type ResendUserInviteQuery = { __typename?: 'Query', resendUserInvite: boolean };

export type SendSummaryMailMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type SendSummaryMailMutation = { __typename?: 'Mutation', sendSummaryMail: boolean };

export type ToggleUserSuspendedMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type ToggleUserSuspendedMutation = { __typename?: 'Mutation', toggleUserSuspended: { __typename?: 'Workspace', workspaceUsers?: Array<{ __typename?: 'WorkspaceUser', isSuspended: boolean, user: { __typename?: 'User', id: string, email: string, lastName?: string | null, firstName?: string | null } }> | null } };

export type ToggleWorkspaceStatusMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type ToggleWorkspaceStatusMutation = { __typename?: 'Mutation', toggleWorkspaceStatus: { __typename?: 'Workspace', id: string, name: string, status: WorkspaceStatusType } };

export type UpdateWorkspaceMutationVariables = Exact<{
  updateWorkspaceId: Scalars['ID']['input'];
  updateWorkspaceInput: UpdateWorkspaceInput;
}>;


export type UpdateWorkspaceMutation = { __typename?: 'Mutation', updateWorkspace: { __typename?: 'Workspace', id: string, name: string, logoUrl?: string | null } };

export type UpdatedWorkspaceSettingsMutationVariables = Exact<{
  updateWorkspaceSettingsInput: UpdateWorkspaceSettingsInput;
}>;


export type UpdatedWorkspaceSettingsMutation = { __typename?: 'Mutation', updatedWorkspaceSettings: { __typename?: 'WorkspaceSettings', id: string, adminContact?: string | null, loginPageBackgroundUrl?: string | null, themeColor?: any | null, indexationMethod?: ResourceIndexationMethod | null, watermarkForPermissions?: Array<Permission> | null, watermarkPresets?: Array<WatermarkPreset> | null, updatedAt: any, autoTopicAssignment: boolean } };

export type WorkspaceReindexedSubscriptionVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type WorkspaceReindexedSubscription = { __typename?: 'Subscription', workspaceReindexed: string };

export const AssistantThreadFragmentDoc = gql`
    fragment AssistantThread on AssistantThread {
  id
  title
  createdAt
  updatedAt
  resource {
    id
    name
    type
    index
    mimeType
  }
}
    `;
export const ActivityFragmentDoc = gql`
    fragment Activity on Activity {
  id
  createdAt
  topic
  targets {
    ... on Group {
      id
      name
      color
      folderId
      createdAt
    }
    ... on Resource {
      id
      name
      index
      type
      mimeType
      createdAt
    }
    ... on Question {
      id
      title
      publicId
    }
  }
  user {
    id
    auth0Id
    email
    firstName
    lastName
    pictureURL
    groups(workspaceId: $workspaceId) {
      id
      name
      color
    }
  }
}
    `;
export const OneGroupFragmentDoc = gql`
    fragment OneGroup on Group {
  id
  name
  color
  folderId
  createdAt
  updatedAt
  createdBy {
    id
    email
    firstName
    lastName
    pictureURL
  }
  users {
    id
    auth0Id
    firstName
    lastName
    email
    pictureURL
    activityStatus
    updatedAt
    createdAt
  }
}
    `;
export const NewGroupFragmentDoc = gql`
    fragment NewGroup on Group {
  id
  name
  color
  folderId
  createdAt
  updatedAt
}
    `;
export const NotificationFragmentDoc = gql`
    fragment Notification on Notification {
  id
  createdAt
  readAt
  topic
  workspaceId
  targets {
    ... on Resource {
      id
      name
    }
    ... on Workspace {
      id
      name
    }
    ... on Question {
      id
      title
    }
  }
}
    `;
export const ResourceForPermissionListItemFragmentDoc = gql`
    fragment ResourceForPermissionListItem on Resource {
  id
  index
  name
  workspaceId
  type
  mimeType
  parentId
  accesses {
    id
    permissions
    resourceId
    groupId
  }
  inheritedAccesses {
    id
    permissions
    resourceId
    groupId
  }
  descendantsAccesses {
    id
    permissions
    resourceId
    groupId
  }
}
    `;
export const RedactionFragmentDoc = gql`
    fragment Redaction on Redaction {
  id
  createdAt
  updatedAt
  status
  entity
  resourceId
  resource {
    id
    name
    type
    mimeType
    pspdfKitId
  }
  text
  matchData {
    id
    isAnnotation
    pageIndex
    previewText
    rangeInPreview
    rectsOnPage
  }
}
    `;
export const DocumentClassificationFragmentFragmentDoc = gql`
    fragment DocumentClassificationFragment on DocumentClassification {
  id
  resource {
    id
    name
    summary
  }
  suggestedFolderId
  confidence
  reasoning
  status
  reclassifiedToFolderId
  uploadSource
  validatedAt
  createdAt
  updatedAt
}
    `;
export const RequestListFolderFragmentFragmentDoc = gql`
    fragment RequestListFolderFragment on Resource {
  id
  publicId
  name
  index
  rank
  parentId
  createdAt
  updatedAt
  requestMetadata {
    status
    description
    receivedAt
    validatedAt
  }
  requestFiles {
    id
    name
    type
    mimeType
  }
}
    `;
export const ResourceRowFragmentFragmentDoc = gql`
    fragment ResourceRowFragment on Resource {
  id
  index
  rank
  publicId
  parentId
  workspaceId
  name
  type
  canDownload
  mimeType
  size
  pspdfKitId
  isFavorite
  createdBy {
    id
    firstName
    lastName
    email
    pictureURL
  }
  createdAt
  updatedAt
  archivedAt
}
    `;
export const ResourceSearchItemFragmentDoc = gql`
    fragment ResourceSearchItem on Resource {
  id
  index
  name
  workspaceId
  type
  mimeType
  size
  publicId
  isFavorite
  pspdfKitId
  createdBy {
    id
    firstName
    lastName
    email
    pictureURL
  }
  createdAt
}
    `;
export const NewResourceFragmentDoc = gql`
    fragment NewResource on Resource {
  id
  name
  parentId
  workspaceId
  type
  mimeType
}
    `;
export const QuestionSearchResultFragmentDoc = gql`
    fragment QuestionSearchResult on QuestionSearchDto {
  id
  title
  publicId
}
    `;
export const SearchResultFragmentDoc = gql`
    fragment SearchResult on SearchDto {
  resources {
    totalCount
    items {
      id
      index
      mimeType
      name
      type
    }
  }
  questions {
    totalCount
    items {
      ...QuestionSearchResult
    }
  }
}
    ${QuestionSearchResultFragmentDoc}`;
export const QuestionListItemFragmentDoc = gql`
    fragment QuestionListItem on Question {
  id
  publicId
  title
  priority
  resolutionStatus
  assignedTopics {
    id
    name
  }
  isAnswered
  answersCount
  resources {
    id
    name
    type
    mimeType
  }
  createdBy {
    id
    email
    firstName
    lastName
    pictureURL
  }
  owners {
    id
    email
    firstName
    lastName
    pictureURL
  }
  groups {
    id
    name
    color
  }
  hasConfirmedAnswer
  duplicateQuestionIds
  latestAnswer {
    id
    description
    isFollowUp
  }
  createdAt
  updatedAt
  archivedAt
}
    `;
export const RoleFragmentDoc = gql`
    fragment Role on Role {
  id
  name
  isAdmin
  summaryFrequency
  permissions {
    manageResources
    canAnswerQuestions
    manageUsersAndPermissions
  }
}
    `;
export const UserListItemFragmentDoc = gql`
    fragment UserListItem on User {
  id
  auth0Id
  firstName
  lastName
  email
  pictureURL
  activityStatus
  createdAt
  groups(workspaceId: $workspaceId) {
    id
    name
    color
    folderId
  }
  workspaceUsers {
    id
    role {
      ...Role
    }
    isSuspended
    user {
      id
    }
    workspace {
      id
    }
  }
}
    ${RoleFragmentDoc}`;
export const NewUserFragmentDoc = gql`
    fragment NewUser on User {
  id
  firstName
  lastName
  email
  pictureURL
  activityStatus
}
    `;
export const ApplyRenameSuggestionsDocument = gql`
    mutation ApplyRenameSuggestions($applyRenameSuggestionsInput: ApplyRenameSuggestionsInput!) {
  applyRenameSuggestions(
    applyRenameSuggestionsInput: $applyRenameSuggestionsInput
  ) {
    id
    name
  }
}
    `;
export type ApplyRenameSuggestionsMutationFn = Apollo.MutationFunction<ApplyRenameSuggestionsMutation, ApplyRenameSuggestionsMutationVariables>;

/**
 * __useApplyRenameSuggestionsMutation__
 *
 * To run a mutation, you first call `useApplyRenameSuggestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyRenameSuggestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyRenameSuggestionsMutation, { data, loading, error }] = useApplyRenameSuggestionsMutation({
 *   variables: {
 *      applyRenameSuggestionsInput: // value for 'applyRenameSuggestionsInput'
 *   },
 * });
 */
export function useApplyRenameSuggestionsMutation(baseOptions?: Apollo.MutationHookOptions<ApplyRenameSuggestionsMutation, ApplyRenameSuggestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyRenameSuggestionsMutation, ApplyRenameSuggestionsMutationVariables>(ApplyRenameSuggestionsDocument, options);
      }
export type ApplyRenameSuggestionsMutationHookResult = ReturnType<typeof useApplyRenameSuggestionsMutation>;
export type ApplyRenameSuggestionsMutationResult = Apollo.MutationResult<ApplyRenameSuggestionsMutation>;
export type ApplyRenameSuggestionsMutationOptions = Apollo.BaseMutationOptions<ApplyRenameSuggestionsMutation, ApplyRenameSuggestionsMutationVariables>;
export const CreateAssistantThreadDocument = gql`
    mutation CreateAssistantThread($workspaceId: ID!) {
  createAssistantThread(workspaceId: $workspaceId) {
    ...AssistantThread
  }
}
    ${AssistantThreadFragmentDoc}`;
export type CreateAssistantThreadMutationFn = Apollo.MutationFunction<CreateAssistantThreadMutation, CreateAssistantThreadMutationVariables>;

/**
 * __useCreateAssistantThreadMutation__
 *
 * To run a mutation, you first call `useCreateAssistantThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssistantThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssistantThreadMutation, { data, loading, error }] = useCreateAssistantThreadMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCreateAssistantThreadMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssistantThreadMutation, CreateAssistantThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssistantThreadMutation, CreateAssistantThreadMutationVariables>(CreateAssistantThreadDocument, options);
      }
export type CreateAssistantThreadMutationHookResult = ReturnType<typeof useCreateAssistantThreadMutation>;
export type CreateAssistantThreadMutationResult = Apollo.MutationResult<CreateAssistantThreadMutation>;
export type CreateAssistantThreadMutationOptions = Apollo.BaseMutationOptions<CreateAssistantThreadMutation, CreateAssistantThreadMutationVariables>;
export const DeleteThreadDocument = gql`
    mutation DeleteThread($threadId: ID!) {
  deleteThread(threadId: $threadId)
}
    `;
export type DeleteThreadMutationFn = Apollo.MutationFunction<DeleteThreadMutation, DeleteThreadMutationVariables>;

/**
 * __useDeleteThreadMutation__
 *
 * To run a mutation, you first call `useDeleteThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThreadMutation, { data, loading, error }] = useDeleteThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useDeleteThreadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThreadMutation, DeleteThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThreadMutation, DeleteThreadMutationVariables>(DeleteThreadDocument, options);
      }
export type DeleteThreadMutationHookResult = ReturnType<typeof useDeleteThreadMutation>;
export type DeleteThreadMutationResult = Apollo.MutationResult<DeleteThreadMutation>;
export type DeleteThreadMutationOptions = Apollo.BaseMutationOptions<DeleteThreadMutation, DeleteThreadMutationVariables>;
export const FetchResourceNameDocument = gql`
    query FetchResourceName($workspaceId: ID!, $resourceId: ID!) {
  resource(workspaceId: $workspaceId, id: $resourceId) {
    id
    name
  }
}
    `;

/**
 * __useFetchResourceNameQuery__
 *
 * To run a query within a React component, call `useFetchResourceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchResourceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchResourceNameQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useFetchResourceNameQuery(baseOptions: Apollo.QueryHookOptions<FetchResourceNameQuery, FetchResourceNameQueryVariables> & ({ variables: FetchResourceNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchResourceNameQuery, FetchResourceNameQueryVariables>(FetchResourceNameDocument, options);
      }
export function useFetchResourceNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchResourceNameQuery, FetchResourceNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchResourceNameQuery, FetchResourceNameQueryVariables>(FetchResourceNameDocument, options);
        }
// @ts-ignore
export function useFetchResourceNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchResourceNameQuery, FetchResourceNameQueryVariables>): Apollo.UseSuspenseQueryResult<FetchResourceNameQuery, FetchResourceNameQueryVariables>;
export function useFetchResourceNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchResourceNameQuery, FetchResourceNameQueryVariables>): Apollo.UseSuspenseQueryResult<FetchResourceNameQuery | undefined, FetchResourceNameQueryVariables>;
export function useFetchResourceNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchResourceNameQuery, FetchResourceNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchResourceNameQuery, FetchResourceNameQueryVariables>(FetchResourceNameDocument, options);
        }
export type FetchResourceNameQueryHookResult = ReturnType<typeof useFetchResourceNameQuery>;
export type FetchResourceNameLazyQueryHookResult = ReturnType<typeof useFetchResourceNameLazyQuery>;
export type FetchResourceNameSuspenseQueryHookResult = ReturnType<typeof useFetchResourceNameSuspenseQuery>;
export type FetchResourceNameQueryResult = Apollo.QueryResult<FetchResourceNameQuery, FetchResourceNameQueryVariables>;
export const GenerateThreadTitleDocument = gql`
    mutation GenerateThreadTitle($generateThreadTitleInput: GenerateThreadTitleInput!) {
  generateThreadTitle(generateThreadTitleInput: $generateThreadTitleInput)
}
    `;
export type GenerateThreadTitleMutationFn = Apollo.MutationFunction<GenerateThreadTitleMutation, GenerateThreadTitleMutationVariables>;

/**
 * __useGenerateThreadTitleMutation__
 *
 * To run a mutation, you first call `useGenerateThreadTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateThreadTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateThreadTitleMutation, { data, loading, error }] = useGenerateThreadTitleMutation({
 *   variables: {
 *      generateThreadTitleInput: // value for 'generateThreadTitleInput'
 *   },
 * });
 */
export function useGenerateThreadTitleMutation(baseOptions?: Apollo.MutationHookOptions<GenerateThreadTitleMutation, GenerateThreadTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateThreadTitleMutation, GenerateThreadTitleMutationVariables>(GenerateThreadTitleDocument, options);
      }
export type GenerateThreadTitleMutationHookResult = ReturnType<typeof useGenerateThreadTitleMutation>;
export type GenerateThreadTitleMutationResult = Apollo.MutationResult<GenerateThreadTitleMutation>;
export type GenerateThreadTitleMutationOptions = Apollo.BaseMutationOptions<GenerateThreadTitleMutation, GenerateThreadTitleMutationVariables>;
export const GetAssistantMessagesDocument = gql`
    query GetAssistantMessages($filter: AssistantMessageArgsFilter!, $sorter: AssistantMessageArgsSorter, $limit: Int, $offset: Int) {
  assistantMessages(
    filter: $filter
    sorter: $sorter
    limit: $limit
    offset: $offset
  ) {
    nodes {
      id
      content
      role
      createdAt
      vote
      thinkingSteps
      sources {
        resourceId
        resourceName
        resourceMimeType
        excerpts {
          text
          page
        }
      }
    }
    pageInfo {
      offset
      totalCount
    }
  }
}
    `;

/**
 * __useGetAssistantMessagesQuery__
 *
 * To run a query within a React component, call `useGetAssistantMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssistantMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssistantMessagesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAssistantMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetAssistantMessagesQuery, GetAssistantMessagesQueryVariables> & ({ variables: GetAssistantMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssistantMessagesQuery, GetAssistantMessagesQueryVariables>(GetAssistantMessagesDocument, options);
      }
export function useGetAssistantMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssistantMessagesQuery, GetAssistantMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssistantMessagesQuery, GetAssistantMessagesQueryVariables>(GetAssistantMessagesDocument, options);
        }
// @ts-ignore
export function useGetAssistantMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssistantMessagesQuery, GetAssistantMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssistantMessagesQuery, GetAssistantMessagesQueryVariables>;
export function useGetAssistantMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssistantMessagesQuery, GetAssistantMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssistantMessagesQuery | undefined, GetAssistantMessagesQueryVariables>;
export function useGetAssistantMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssistantMessagesQuery, GetAssistantMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssistantMessagesQuery, GetAssistantMessagesQueryVariables>(GetAssistantMessagesDocument, options);
        }
export type GetAssistantMessagesQueryHookResult = ReturnType<typeof useGetAssistantMessagesQuery>;
export type GetAssistantMessagesLazyQueryHookResult = ReturnType<typeof useGetAssistantMessagesLazyQuery>;
export type GetAssistantMessagesSuspenseQueryHookResult = ReturnType<typeof useGetAssistantMessagesSuspenseQuery>;
export type GetAssistantMessagesQueryResult = Apollo.QueryResult<GetAssistantMessagesQuery, GetAssistantMessagesQueryVariables>;
export const GetAssistantThreadForResourceDocument = gql`
    query GetAssistantThreadForResource($workspaceId: ID!, $resourceId: ID!) {
  assistantThreadForResource(workspaceId: $workspaceId, resourceId: $resourceId) {
    id
  }
}
    `;

/**
 * __useGetAssistantThreadForResourceQuery__
 *
 * To run a query within a React component, call `useGetAssistantThreadForResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssistantThreadForResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssistantThreadForResourceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useGetAssistantThreadForResourceQuery(baseOptions: Apollo.QueryHookOptions<GetAssistantThreadForResourceQuery, GetAssistantThreadForResourceQueryVariables> & ({ variables: GetAssistantThreadForResourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssistantThreadForResourceQuery, GetAssistantThreadForResourceQueryVariables>(GetAssistantThreadForResourceDocument, options);
      }
export function useGetAssistantThreadForResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssistantThreadForResourceQuery, GetAssistantThreadForResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssistantThreadForResourceQuery, GetAssistantThreadForResourceQueryVariables>(GetAssistantThreadForResourceDocument, options);
        }
// @ts-ignore
export function useGetAssistantThreadForResourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssistantThreadForResourceQuery, GetAssistantThreadForResourceQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssistantThreadForResourceQuery, GetAssistantThreadForResourceQueryVariables>;
export function useGetAssistantThreadForResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssistantThreadForResourceQuery, GetAssistantThreadForResourceQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssistantThreadForResourceQuery | undefined, GetAssistantThreadForResourceQueryVariables>;
export function useGetAssistantThreadForResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssistantThreadForResourceQuery, GetAssistantThreadForResourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssistantThreadForResourceQuery, GetAssistantThreadForResourceQueryVariables>(GetAssistantThreadForResourceDocument, options);
        }
export type GetAssistantThreadForResourceQueryHookResult = ReturnType<typeof useGetAssistantThreadForResourceQuery>;
export type GetAssistantThreadForResourceLazyQueryHookResult = ReturnType<typeof useGetAssistantThreadForResourceLazyQuery>;
export type GetAssistantThreadForResourceSuspenseQueryHookResult = ReturnType<typeof useGetAssistantThreadForResourceSuspenseQuery>;
export type GetAssistantThreadForResourceQueryResult = Apollo.QueryResult<GetAssistantThreadForResourceQuery, GetAssistantThreadForResourceQueryVariables>;
export const GetAssistantThreadsDocument = gql`
    query GetAssistantThreads($filter: AssistantThreadArgsFilter!, $sorter: AssistantThreadArgsSorter, $limit: Int, $offset: Int) {
  assistantThreads(
    filter: $filter
    sorter: $sorter
    limit: $limit
    offset: $offset
  ) {
    nodes {
      ...AssistantThread
    }
    pageInfo {
      offset
      totalCount
    }
  }
}
    ${AssistantThreadFragmentDoc}`;

/**
 * __useGetAssistantThreadsQuery__
 *
 * To run a query within a React component, call `useGetAssistantThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssistantThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssistantThreadsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAssistantThreadsQuery(baseOptions: Apollo.QueryHookOptions<GetAssistantThreadsQuery, GetAssistantThreadsQueryVariables> & ({ variables: GetAssistantThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssistantThreadsQuery, GetAssistantThreadsQueryVariables>(GetAssistantThreadsDocument, options);
      }
export function useGetAssistantThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssistantThreadsQuery, GetAssistantThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssistantThreadsQuery, GetAssistantThreadsQueryVariables>(GetAssistantThreadsDocument, options);
        }
// @ts-ignore
export function useGetAssistantThreadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAssistantThreadsQuery, GetAssistantThreadsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssistantThreadsQuery, GetAssistantThreadsQueryVariables>;
export function useGetAssistantThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssistantThreadsQuery, GetAssistantThreadsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAssistantThreadsQuery | undefined, GetAssistantThreadsQueryVariables>;
export function useGetAssistantThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssistantThreadsQuery, GetAssistantThreadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssistantThreadsQuery, GetAssistantThreadsQueryVariables>(GetAssistantThreadsDocument, options);
        }
export type GetAssistantThreadsQueryHookResult = ReturnType<typeof useGetAssistantThreadsQuery>;
export type GetAssistantThreadsLazyQueryHookResult = ReturnType<typeof useGetAssistantThreadsLazyQuery>;
export type GetAssistantThreadsSuspenseQueryHookResult = ReturnType<typeof useGetAssistantThreadsSuspenseQuery>;
export type GetAssistantThreadsQueryResult = Apollo.QueryResult<GetAssistantThreadsQuery, GetAssistantThreadsQueryVariables>;
export const VoteAssistantMessageDocument = gql`
    mutation VoteAssistantMessage($assistantMessageId: ID!, $vote: AssistantMessageVote) {
  voteAssistantMessage(assistantMessageId: $assistantMessageId, vote: $vote) {
    id
    vote
  }
}
    `;
export type VoteAssistantMessageMutationFn = Apollo.MutationFunction<VoteAssistantMessageMutation, VoteAssistantMessageMutationVariables>;

/**
 * __useVoteAssistantMessageMutation__
 *
 * To run a mutation, you first call `useVoteAssistantMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoteAssistantMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voteAssistantMessageMutation, { data, loading, error }] = useVoteAssistantMessageMutation({
 *   variables: {
 *      assistantMessageId: // value for 'assistantMessageId'
 *      vote: // value for 'vote'
 *   },
 * });
 */
export function useVoteAssistantMessageMutation(baseOptions?: Apollo.MutationHookOptions<VoteAssistantMessageMutation, VoteAssistantMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoteAssistantMessageMutation, VoteAssistantMessageMutationVariables>(VoteAssistantMessageDocument, options);
      }
export type VoteAssistantMessageMutationHookResult = ReturnType<typeof useVoteAssistantMessageMutation>;
export type VoteAssistantMessageMutationResult = Apollo.MutationResult<VoteAssistantMessageMutation>;
export type VoteAssistantMessageMutationOptions = Apollo.BaseMutationOptions<VoteAssistantMessageMutation, VoteAssistantMessageMutationVariables>;
export const GetMeDocument = gql`
    query GetMe {
  me {
    id
    auth0Id
    firstName
    lastName
    email
    pictureURL
    activityStatus
    workspaceUsers {
      workspace {
        id
        name
        status
        isPaymentActive
      }
      role {
        ...Role
      }
      isSuspended
    }
    managedTenant {
      id
      name
      isSuspended
      companyDetails {
        name
        website
        phone
        address
        country
        city
        zipCode
      }
    }
    referral {
      id
      code
      commission
      link
      deals {
        id
        name
        invoicedAmount
        paidAmount
        startDate
        endDate
        status
        totalGains
      }
    }
  }
}
    ${RoleFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
// @ts-ignore
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>): Apollo.UseSuspenseQueryResult<GetMeQuery, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>): Apollo.UseSuspenseQueryResult<GetMeQuery | undefined, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<typeof useGetMeSuspenseQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const ToggleResourceFavoriteDocument = gql`
    mutation ToggleResourceFavorite($workspaceId: ID!, $resourceId: ID!) {
  toggleResourceFavorite(workspaceId: $workspaceId, resourceId: $resourceId) {
    updatedAt
  }
}
    `;
export type ToggleResourceFavoriteMutationFn = Apollo.MutationFunction<ToggleResourceFavoriteMutation, ToggleResourceFavoriteMutationVariables>;

/**
 * __useToggleResourceFavoriteMutation__
 *
 * To run a mutation, you first call `useToggleResourceFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleResourceFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleResourceFavoriteMutation, { data, loading, error }] = useToggleResourceFavoriteMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useToggleResourceFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<ToggleResourceFavoriteMutation, ToggleResourceFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleResourceFavoriteMutation, ToggleResourceFavoriteMutationVariables>(ToggleResourceFavoriteDocument, options);
      }
export type ToggleResourceFavoriteMutationHookResult = ReturnType<typeof useToggleResourceFavoriteMutation>;
export type ToggleResourceFavoriteMutationResult = Apollo.MutationResult<ToggleResourceFavoriteMutation>;
export type ToggleResourceFavoriteMutationOptions = Apollo.BaseMutationOptions<ToggleResourceFavoriteMutation, ToggleResourceFavoriteMutationVariables>;
export const ExportActivitiesJobDocument = gql`
    mutation ExportActivitiesJob($workspaceId: ID!) {
  exportActivitiesJob(workspaceId: $workspaceId)
}
    `;
export type ExportActivitiesJobMutationFn = Apollo.MutationFunction<ExportActivitiesJobMutation, ExportActivitiesJobMutationVariables>;

/**
 * __useExportActivitiesJobMutation__
 *
 * To run a mutation, you first call `useExportActivitiesJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportActivitiesJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportActivitiesJobMutation, { data, loading, error }] = useExportActivitiesJobMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useExportActivitiesJobMutation(baseOptions?: Apollo.MutationHookOptions<ExportActivitiesJobMutation, ExportActivitiesJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportActivitiesJobMutation, ExportActivitiesJobMutationVariables>(ExportActivitiesJobDocument, options);
      }
export type ExportActivitiesJobMutationHookResult = ReturnType<typeof useExportActivitiesJobMutation>;
export type ExportActivitiesJobMutationResult = Apollo.MutationResult<ExportActivitiesJobMutation>;
export type ExportActivitiesJobMutationOptions = Apollo.BaseMutationOptions<ExportActivitiesJobMutation, ExportActivitiesJobMutationVariables>;
export const GetActivitiesDocument = gql`
    query GetActivities($filter: ActivityArgsFilter!, $limit: Int, $offset: Int, $sorter: ActivityArgsSorter, $workspaceId: ID!) {
  activities(filter: $filter, limit: $limit, offset: $offset, sorter: $sorter) {
    nodes {
      ...Activity
    }
    pageInfo {
      offset
      totalCount
    }
  }
}
    ${ActivityFragmentDoc}`;

/**
 * __useGetActivitiesQuery__
 *
 * To run a query within a React component, call `useGetActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivitiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables> & ({ variables: GetActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, options);
      }
export function useGetActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, options);
        }
// @ts-ignore
export function useGetActivitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetActivitiesQuery, GetActivitiesQueryVariables>;
export function useGetActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetActivitiesQuery | undefined, GetActivitiesQueryVariables>;
export function useGetActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivitiesQuery, GetActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivitiesQuery, GetActivitiesQueryVariables>(GetActivitiesDocument, options);
        }
export type GetActivitiesQueryHookResult = ReturnType<typeof useGetActivitiesQuery>;
export type GetActivitiesLazyQueryHookResult = ReturnType<typeof useGetActivitiesLazyQuery>;
export type GetActivitiesSuspenseQueryHookResult = ReturnType<typeof useGetActivitiesSuspenseQuery>;
export type GetActivitiesQueryResult = Apollo.QueryResult<GetActivitiesQuery, GetActivitiesQueryVariables>;
export const GetActivityOverviewDocument = gql`
    query GetActivityOverview($workspaceId: ID!, $startDate: DateTime, $endDate: DateTime, $groupIds: [ID!], $userIds: [ID!]) {
  activityOverview(
    workspaceId: $workspaceId
    startDate: $startDate
    endDate: $endDate
    groupIds: $groupIds
    userIds: $userIds
  ) {
    date
    connections
    documentViews
    questions
  }
}
    `;

/**
 * __useGetActivityOverviewQuery__
 *
 * To run a query within a React component, call `useGetActivityOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityOverviewQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      groupIds: // value for 'groupIds'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetActivityOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetActivityOverviewQuery, GetActivityOverviewQueryVariables> & ({ variables: GetActivityOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityOverviewQuery, GetActivityOverviewQueryVariables>(GetActivityOverviewDocument, options);
      }
export function useGetActivityOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityOverviewQuery, GetActivityOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityOverviewQuery, GetActivityOverviewQueryVariables>(GetActivityOverviewDocument, options);
        }
// @ts-ignore
export function useGetActivityOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetActivityOverviewQuery, GetActivityOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetActivityOverviewQuery, GetActivityOverviewQueryVariables>;
export function useGetActivityOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityOverviewQuery, GetActivityOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetActivityOverviewQuery | undefined, GetActivityOverviewQueryVariables>;
export function useGetActivityOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityOverviewQuery, GetActivityOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityOverviewQuery, GetActivityOverviewQueryVariables>(GetActivityOverviewDocument, options);
        }
export type GetActivityOverviewQueryHookResult = ReturnType<typeof useGetActivityOverviewQuery>;
export type GetActivityOverviewLazyQueryHookResult = ReturnType<typeof useGetActivityOverviewLazyQuery>;
export type GetActivityOverviewSuspenseQueryHookResult = ReturnType<typeof useGetActivityOverviewSuspenseQuery>;
export type GetActivityOverviewQueryResult = Apollo.QueryResult<GetActivityOverviewQuery, GetActivityOverviewQueryVariables>;
export const GetConnectionsByGroupDocument = gql`
    query GetConnectionsByGroup($workspaceId: ID!, $startDate: DateTime, $endDate: DateTime, $groupIds: [ID!], $userIds: [ID!]) {
  connectionsByGroup(
    workspaceId: $workspaceId
    startDate: $startDate
    endDate: $endDate
    groupIds: $groupIds
    userIds: $userIds
  ) {
    group {
      id
      name
      color
      folderId
    }
    connections
  }
}
    `;

/**
 * __useGetConnectionsByGroupQuery__
 *
 * To run a query within a React component, call `useGetConnectionsByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionsByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectionsByGroupQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      groupIds: // value for 'groupIds'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetConnectionsByGroupQuery(baseOptions: Apollo.QueryHookOptions<GetConnectionsByGroupQuery, GetConnectionsByGroupQueryVariables> & ({ variables: GetConnectionsByGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectionsByGroupQuery, GetConnectionsByGroupQueryVariables>(GetConnectionsByGroupDocument, options);
      }
export function useGetConnectionsByGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectionsByGroupQuery, GetConnectionsByGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectionsByGroupQuery, GetConnectionsByGroupQueryVariables>(GetConnectionsByGroupDocument, options);
        }
// @ts-ignore
export function useGetConnectionsByGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConnectionsByGroupQuery, GetConnectionsByGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GetConnectionsByGroupQuery, GetConnectionsByGroupQueryVariables>;
export function useGetConnectionsByGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectionsByGroupQuery, GetConnectionsByGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GetConnectionsByGroupQuery | undefined, GetConnectionsByGroupQueryVariables>;
export function useGetConnectionsByGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectionsByGroupQuery, GetConnectionsByGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectionsByGroupQuery, GetConnectionsByGroupQueryVariables>(GetConnectionsByGroupDocument, options);
        }
export type GetConnectionsByGroupQueryHookResult = ReturnType<typeof useGetConnectionsByGroupQuery>;
export type GetConnectionsByGroupLazyQueryHookResult = ReturnType<typeof useGetConnectionsByGroupLazyQuery>;
export type GetConnectionsByGroupSuspenseQueryHookResult = ReturnType<typeof useGetConnectionsByGroupSuspenseQuery>;
export type GetConnectionsByGroupQueryResult = Apollo.QueryResult<GetConnectionsByGroupQuery, GetConnectionsByGroupQueryVariables>;
export const GetExpertResponseTimeDocument = gql`
    query GetExpertResponseTime($workspaceId: ID!, $startDate: DateTime, $endDate: DateTime, $groupIds: [ID!], $userIds: [ID!]) {
  expertResponseTime(
    workspaceId: $workspaceId
    startDate: $startDate
    endDate: $endDate
    groupIds: $groupIds
    userIds: $userIds
  ) {
    topic
    avgHours
  }
}
    `;

/**
 * __useGetExpertResponseTimeQuery__
 *
 * To run a query within a React component, call `useGetExpertResponseTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpertResponseTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpertResponseTimeQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      groupIds: // value for 'groupIds'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetExpertResponseTimeQuery(baseOptions: Apollo.QueryHookOptions<GetExpertResponseTimeQuery, GetExpertResponseTimeQueryVariables> & ({ variables: GetExpertResponseTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpertResponseTimeQuery, GetExpertResponseTimeQueryVariables>(GetExpertResponseTimeDocument, options);
      }
export function useGetExpertResponseTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpertResponseTimeQuery, GetExpertResponseTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpertResponseTimeQuery, GetExpertResponseTimeQueryVariables>(GetExpertResponseTimeDocument, options);
        }
// @ts-ignore
export function useGetExpertResponseTimeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExpertResponseTimeQuery, GetExpertResponseTimeQueryVariables>): Apollo.UseSuspenseQueryResult<GetExpertResponseTimeQuery, GetExpertResponseTimeQueryVariables>;
export function useGetExpertResponseTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExpertResponseTimeQuery, GetExpertResponseTimeQueryVariables>): Apollo.UseSuspenseQueryResult<GetExpertResponseTimeQuery | undefined, GetExpertResponseTimeQueryVariables>;
export function useGetExpertResponseTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExpertResponseTimeQuery, GetExpertResponseTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExpertResponseTimeQuery, GetExpertResponseTimeQueryVariables>(GetExpertResponseTimeDocument, options);
        }
export type GetExpertResponseTimeQueryHookResult = ReturnType<typeof useGetExpertResponseTimeQuery>;
export type GetExpertResponseTimeLazyQueryHookResult = ReturnType<typeof useGetExpertResponseTimeLazyQuery>;
export type GetExpertResponseTimeSuspenseQueryHookResult = ReturnType<typeof useGetExpertResponseTimeSuspenseQuery>;
export type GetExpertResponseTimeQueryResult = Apollo.QueryResult<GetExpertResponseTimeQuery, GetExpertResponseTimeQueryVariables>;
export const GetHighInterestDocumentsDocument = gql`
    query GetHighInterestDocuments($workspaceId: ID!, $startDate: DateTime, $endDate: DateTime, $groupIds: [ID!], $userIds: [ID!], $limit: Int) {
  highInterestDocuments(
    workspaceId: $workspaceId
    startDate: $startDate
    endDate: $endDate
    groupIds: $groupIds
    userIds: $userIds
    limit: $limit
  ) {
    resource {
      id
      name
    }
    parentFolder {
      id
      name
    }
    totalViews
    uniqueViewers
    downloadCount
  }
}
    `;

/**
 * __useGetHighInterestDocumentsQuery__
 *
 * To run a query within a React component, call `useGetHighInterestDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHighInterestDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHighInterestDocumentsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      groupIds: // value for 'groupIds'
 *      userIds: // value for 'userIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetHighInterestDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetHighInterestDocumentsQuery, GetHighInterestDocumentsQueryVariables> & ({ variables: GetHighInterestDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHighInterestDocumentsQuery, GetHighInterestDocumentsQueryVariables>(GetHighInterestDocumentsDocument, options);
      }
export function useGetHighInterestDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHighInterestDocumentsQuery, GetHighInterestDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHighInterestDocumentsQuery, GetHighInterestDocumentsQueryVariables>(GetHighInterestDocumentsDocument, options);
        }
// @ts-ignore
export function useGetHighInterestDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHighInterestDocumentsQuery, GetHighInterestDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetHighInterestDocumentsQuery, GetHighInterestDocumentsQueryVariables>;
export function useGetHighInterestDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHighInterestDocumentsQuery, GetHighInterestDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetHighInterestDocumentsQuery | undefined, GetHighInterestDocumentsQueryVariables>;
export function useGetHighInterestDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHighInterestDocumentsQuery, GetHighInterestDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHighInterestDocumentsQuery, GetHighInterestDocumentsQueryVariables>(GetHighInterestDocumentsDocument, options);
        }
export type GetHighInterestDocumentsQueryHookResult = ReturnType<typeof useGetHighInterestDocumentsQuery>;
export type GetHighInterestDocumentsLazyQueryHookResult = ReturnType<typeof useGetHighInterestDocumentsLazyQuery>;
export type GetHighInterestDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetHighInterestDocumentsSuspenseQuery>;
export type GetHighInterestDocumentsQueryResult = Apollo.QueryResult<GetHighInterestDocumentsQuery, GetHighInterestDocumentsQueryVariables>;
export const GetQaReadReceiptsDocument = gql`
    query GetQaReadReceipts($workspaceId: ID!, $startDate: DateTime, $endDate: DateTime, $groupIds: [ID!], $userIds: [ID!]) {
  qaReadReceipts(
    workspaceId: $workspaceId
    startDate: $startDate
    endDate: $endDate
    groupIds: $groupIds
    userIds: $userIds
  ) {
    totalAnswers
    readRate
    avgTimeToReadHours
    byGroup {
      group {
        id
        name
        color
        folderId
      }
      readRate
      totalAnswers
    }
  }
}
    `;

/**
 * __useGetQaReadReceiptsQuery__
 *
 * To run a query within a React component, call `useGetQaReadReceiptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQaReadReceiptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQaReadReceiptsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      groupIds: // value for 'groupIds'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetQaReadReceiptsQuery(baseOptions: Apollo.QueryHookOptions<GetQaReadReceiptsQuery, GetQaReadReceiptsQueryVariables> & ({ variables: GetQaReadReceiptsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQaReadReceiptsQuery, GetQaReadReceiptsQueryVariables>(GetQaReadReceiptsDocument, options);
      }
export function useGetQaReadReceiptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQaReadReceiptsQuery, GetQaReadReceiptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQaReadReceiptsQuery, GetQaReadReceiptsQueryVariables>(GetQaReadReceiptsDocument, options);
        }
// @ts-ignore
export function useGetQaReadReceiptsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQaReadReceiptsQuery, GetQaReadReceiptsQueryVariables>): Apollo.UseSuspenseQueryResult<GetQaReadReceiptsQuery, GetQaReadReceiptsQueryVariables>;
export function useGetQaReadReceiptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQaReadReceiptsQuery, GetQaReadReceiptsQueryVariables>): Apollo.UseSuspenseQueryResult<GetQaReadReceiptsQuery | undefined, GetQaReadReceiptsQueryVariables>;
export function useGetQaReadReceiptsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQaReadReceiptsQuery, GetQaReadReceiptsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQaReadReceiptsQuery, GetQaReadReceiptsQueryVariables>(GetQaReadReceiptsDocument, options);
        }
export type GetQaReadReceiptsQueryHookResult = ReturnType<typeof useGetQaReadReceiptsQuery>;
export type GetQaReadReceiptsLazyQueryHookResult = ReturnType<typeof useGetQaReadReceiptsLazyQuery>;
export type GetQaReadReceiptsSuspenseQueryHookResult = ReturnType<typeof useGetQaReadReceiptsSuspenseQuery>;
export type GetQaReadReceiptsQueryResult = Apollo.QueryResult<GetQaReadReceiptsQuery, GetQaReadReceiptsQueryVariables>;
export const GetQuestionsByGroupDocument = gql`
    query GetQuestionsByGroup($workspaceId: ID!, $startDate: DateTime, $endDate: DateTime, $groupIds: [ID!], $userIds: [ID!]) {
  questionsByGroup(
    workspaceId: $workspaceId
    startDate: $startDate
    endDate: $endDate
    groupIds: $groupIds
    userIds: $userIds
  ) {
    group {
      id
      name
      color
      folderId
    }
    themes {
      name
      questionCount
    }
  }
}
    `;

/**
 * __useGetQuestionsByGroupQuery__
 *
 * To run a query within a React component, call `useGetQuestionsByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsByGroupQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      groupIds: // value for 'groupIds'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetQuestionsByGroupQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionsByGroupQuery, GetQuestionsByGroupQueryVariables> & ({ variables: GetQuestionsByGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionsByGroupQuery, GetQuestionsByGroupQueryVariables>(GetQuestionsByGroupDocument, options);
      }
export function useGetQuestionsByGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionsByGroupQuery, GetQuestionsByGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionsByGroupQuery, GetQuestionsByGroupQueryVariables>(GetQuestionsByGroupDocument, options);
        }
// @ts-ignore
export function useGetQuestionsByGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionsByGroupQuery, GetQuestionsByGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionsByGroupQuery, GetQuestionsByGroupQueryVariables>;
export function useGetQuestionsByGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionsByGroupQuery, GetQuestionsByGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionsByGroupQuery | undefined, GetQuestionsByGroupQueryVariables>;
export function useGetQuestionsByGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionsByGroupQuery, GetQuestionsByGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionsByGroupQuery, GetQuestionsByGroupQueryVariables>(GetQuestionsByGroupDocument, options);
        }
export type GetQuestionsByGroupQueryHookResult = ReturnType<typeof useGetQuestionsByGroupQuery>;
export type GetQuestionsByGroupLazyQueryHookResult = ReturnType<typeof useGetQuestionsByGroupLazyQuery>;
export type GetQuestionsByGroupSuspenseQueryHookResult = ReturnType<typeof useGetQuestionsByGroupSuspenseQuery>;
export type GetQuestionsByGroupQueryResult = Apollo.QueryResult<GetQuestionsByGroupQuery, GetQuestionsByGroupQueryVariables>;
export const GetQuestionsByThemeDocument = gql`
    query GetQuestionsByTheme($workspaceId: ID!, $startDate: DateTime, $endDate: DateTime, $groupIds: [ID!], $userIds: [ID!], $limit: Int) {
  questionsByTheme(
    workspaceId: $workspaceId
    startDate: $startDate
    endDate: $endDate
    groupIds: $groupIds
    userIds: $userIds
    limit: $limit
  ) {
    name
    count
  }
}
    `;

/**
 * __useGetQuestionsByThemeQuery__
 *
 * To run a query within a React component, call `useGetQuestionsByThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsByThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsByThemeQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      groupIds: // value for 'groupIds'
 *      userIds: // value for 'userIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetQuestionsByThemeQuery(baseOptions: Apollo.QueryHookOptions<GetQuestionsByThemeQuery, GetQuestionsByThemeQueryVariables> & ({ variables: GetQuestionsByThemeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionsByThemeQuery, GetQuestionsByThemeQueryVariables>(GetQuestionsByThemeDocument, options);
      }
export function useGetQuestionsByThemeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionsByThemeQuery, GetQuestionsByThemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionsByThemeQuery, GetQuestionsByThemeQueryVariables>(GetQuestionsByThemeDocument, options);
        }
// @ts-ignore
export function useGetQuestionsByThemeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuestionsByThemeQuery, GetQuestionsByThemeQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionsByThemeQuery, GetQuestionsByThemeQueryVariables>;
export function useGetQuestionsByThemeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionsByThemeQuery, GetQuestionsByThemeQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuestionsByThemeQuery | undefined, GetQuestionsByThemeQueryVariables>;
export function useGetQuestionsByThemeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuestionsByThemeQuery, GetQuestionsByThemeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuestionsByThemeQuery, GetQuestionsByThemeQueryVariables>(GetQuestionsByThemeDocument, options);
        }
export type GetQuestionsByThemeQueryHookResult = ReturnType<typeof useGetQuestionsByThemeQuery>;
export type GetQuestionsByThemeLazyQueryHookResult = ReturnType<typeof useGetQuestionsByThemeLazyQuery>;
export type GetQuestionsByThemeSuspenseQueryHookResult = ReturnType<typeof useGetQuestionsByThemeSuspenseQuery>;
export type GetQuestionsByThemeQueryResult = Apollo.QueryResult<GetQuestionsByThemeQuery, GetQuestionsByThemeQueryVariables>;
export const GetRealTimeAnalyticsDocument = gql`
    query GetRealTimeAnalytics($workspaceId: ID!, $startDate: DateTime!, $endDate: DateTime!, $groupIds: [ID!], $userIds: [ID!]) {
  realTimeAnalytics(
    workspaceId: $workspaceId
    startDate: $startDate
    endDate: $endDate
    groupIds: $groupIds
    userIds: $userIds
  ) {
    totalConnections
    totalViews
    totalQuestions
    totalFiles
    totalUsers
    totalGroups
    qaReadRate
    topKeywords {
      keyword
      count
    }
  }
}
    `;

/**
 * __useGetRealTimeAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetRealTimeAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRealTimeAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRealTimeAnalyticsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      groupIds: // value for 'groupIds'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetRealTimeAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetRealTimeAnalyticsQuery, GetRealTimeAnalyticsQueryVariables> & ({ variables: GetRealTimeAnalyticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRealTimeAnalyticsQuery, GetRealTimeAnalyticsQueryVariables>(GetRealTimeAnalyticsDocument, options);
      }
export function useGetRealTimeAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRealTimeAnalyticsQuery, GetRealTimeAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRealTimeAnalyticsQuery, GetRealTimeAnalyticsQueryVariables>(GetRealTimeAnalyticsDocument, options);
        }
// @ts-ignore
export function useGetRealTimeAnalyticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRealTimeAnalyticsQuery, GetRealTimeAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRealTimeAnalyticsQuery, GetRealTimeAnalyticsQueryVariables>;
export function useGetRealTimeAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRealTimeAnalyticsQuery, GetRealTimeAnalyticsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRealTimeAnalyticsQuery | undefined, GetRealTimeAnalyticsQueryVariables>;
export function useGetRealTimeAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRealTimeAnalyticsQuery, GetRealTimeAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRealTimeAnalyticsQuery, GetRealTimeAnalyticsQueryVariables>(GetRealTimeAnalyticsDocument, options);
        }
export type GetRealTimeAnalyticsQueryHookResult = ReturnType<typeof useGetRealTimeAnalyticsQuery>;
export type GetRealTimeAnalyticsLazyQueryHookResult = ReturnType<typeof useGetRealTimeAnalyticsLazyQuery>;
export type GetRealTimeAnalyticsSuspenseQueryHookResult = ReturnType<typeof useGetRealTimeAnalyticsSuspenseQuery>;
export type GetRealTimeAnalyticsQueryResult = Apollo.QueryResult<GetRealTimeAnalyticsQuery, GetRealTimeAnalyticsQueryVariables>;
export const GetStorageOverviewDocument = gql`
    query GetStorageOverview($workspaceId: ID!, $startDate: DateTime, $endDate: DateTime) {
  storageOverview(
    workspaceId: $workspaceId
    startDate: $startDate
    endDate: $endDate
  ) {
    date
    bytes
  }
}
    `;

/**
 * __useGetStorageOverviewQuery__
 *
 * To run a query within a React component, call `useGetStorageOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStorageOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorageOverviewQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetStorageOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetStorageOverviewQuery, GetStorageOverviewQueryVariables> & ({ variables: GetStorageOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStorageOverviewQuery, GetStorageOverviewQueryVariables>(GetStorageOverviewDocument, options);
      }
export function useGetStorageOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStorageOverviewQuery, GetStorageOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStorageOverviewQuery, GetStorageOverviewQueryVariables>(GetStorageOverviewDocument, options);
        }
// @ts-ignore
export function useGetStorageOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStorageOverviewQuery, GetStorageOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetStorageOverviewQuery, GetStorageOverviewQueryVariables>;
export function useGetStorageOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStorageOverviewQuery, GetStorageOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetStorageOverviewQuery | undefined, GetStorageOverviewQueryVariables>;
export function useGetStorageOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStorageOverviewQuery, GetStorageOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStorageOverviewQuery, GetStorageOverviewQueryVariables>(GetStorageOverviewDocument, options);
        }
export type GetStorageOverviewQueryHookResult = ReturnType<typeof useGetStorageOverviewQuery>;
export type GetStorageOverviewLazyQueryHookResult = ReturnType<typeof useGetStorageOverviewLazyQuery>;
export type GetStorageOverviewSuspenseQueryHookResult = ReturnType<typeof useGetStorageOverviewSuspenseQuery>;
export type GetStorageOverviewQueryResult = Apollo.QueryResult<GetStorageOverviewQuery, GetStorageOverviewQueryVariables>;
export const GetTopSearchKeywordsDocument = gql`
    query GetTopSearchKeywords($workspaceId: ID!, $startDate: DateTime, $endDate: DateTime, $groupIds: [ID!], $userIds: [ID!], $limit: Int) {
  topSearchKeywords(
    workspaceId: $workspaceId
    startDate: $startDate
    endDate: $endDate
    groupIds: $groupIds
    userIds: $userIds
    limit: $limit
  ) {
    keyword
    count
  }
}
    `;

/**
 * __useGetTopSearchKeywordsQuery__
 *
 * To run a query within a React component, call `useGetTopSearchKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopSearchKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopSearchKeywordsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      groupIds: // value for 'groupIds'
 *      userIds: // value for 'userIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTopSearchKeywordsQuery(baseOptions: Apollo.QueryHookOptions<GetTopSearchKeywordsQuery, GetTopSearchKeywordsQueryVariables> & ({ variables: GetTopSearchKeywordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopSearchKeywordsQuery, GetTopSearchKeywordsQueryVariables>(GetTopSearchKeywordsDocument, options);
      }
export function useGetTopSearchKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopSearchKeywordsQuery, GetTopSearchKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopSearchKeywordsQuery, GetTopSearchKeywordsQueryVariables>(GetTopSearchKeywordsDocument, options);
        }
// @ts-ignore
export function useGetTopSearchKeywordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTopSearchKeywordsQuery, GetTopSearchKeywordsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTopSearchKeywordsQuery, GetTopSearchKeywordsQueryVariables>;
export function useGetTopSearchKeywordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopSearchKeywordsQuery, GetTopSearchKeywordsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTopSearchKeywordsQuery | undefined, GetTopSearchKeywordsQueryVariables>;
export function useGetTopSearchKeywordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopSearchKeywordsQuery, GetTopSearchKeywordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTopSearchKeywordsQuery, GetTopSearchKeywordsQueryVariables>(GetTopSearchKeywordsDocument, options);
        }
export type GetTopSearchKeywordsQueryHookResult = ReturnType<typeof useGetTopSearchKeywordsQuery>;
export type GetTopSearchKeywordsLazyQueryHookResult = ReturnType<typeof useGetTopSearchKeywordsLazyQuery>;
export type GetTopSearchKeywordsSuspenseQueryHookResult = ReturnType<typeof useGetTopSearchKeywordsSuspenseQuery>;
export type GetTopSearchKeywordsQueryResult = Apollo.QueryResult<GetTopSearchKeywordsQuery, GetTopSearchKeywordsQueryVariables>;
export const GetVdrPenetrationDocument = gql`
    query GetVdrPenetration($workspaceId: ID!, $startDate: DateTime, $endDate: DateTime, $groupIds: [ID!], $userIds: [ID!]) {
  vdrPenetration(
    workspaceId: $workspaceId
    startDate: $startDate
    endDate: $endDate
    groupIds: $groupIds
    userIds: $userIds
  ) {
    group {
      id
      name
      color
      folderId
    }
    penetrationRate
    totalDocuments
    viewedDocuments
  }
}
    `;

/**
 * __useGetVdrPenetrationQuery__
 *
 * To run a query within a React component, call `useGetVdrPenetrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVdrPenetrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVdrPenetrationQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      groupIds: // value for 'groupIds'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetVdrPenetrationQuery(baseOptions: Apollo.QueryHookOptions<GetVdrPenetrationQuery, GetVdrPenetrationQueryVariables> & ({ variables: GetVdrPenetrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVdrPenetrationQuery, GetVdrPenetrationQueryVariables>(GetVdrPenetrationDocument, options);
      }
export function useGetVdrPenetrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVdrPenetrationQuery, GetVdrPenetrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVdrPenetrationQuery, GetVdrPenetrationQueryVariables>(GetVdrPenetrationDocument, options);
        }
// @ts-ignore
export function useGetVdrPenetrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVdrPenetrationQuery, GetVdrPenetrationQueryVariables>): Apollo.UseSuspenseQueryResult<GetVdrPenetrationQuery, GetVdrPenetrationQueryVariables>;
export function useGetVdrPenetrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVdrPenetrationQuery, GetVdrPenetrationQueryVariables>): Apollo.UseSuspenseQueryResult<GetVdrPenetrationQuery | undefined, GetVdrPenetrationQueryVariables>;
export function useGetVdrPenetrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVdrPenetrationQuery, GetVdrPenetrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVdrPenetrationQuery, GetVdrPenetrationQueryVariables>(GetVdrPenetrationDocument, options);
        }
export type GetVdrPenetrationQueryHookResult = ReturnType<typeof useGetVdrPenetrationQuery>;
export type GetVdrPenetrationLazyQueryHookResult = ReturnType<typeof useGetVdrPenetrationLazyQuery>;
export type GetVdrPenetrationSuspenseQueryHookResult = ReturnType<typeof useGetVdrPenetrationSuspenseQuery>;
export type GetVdrPenetrationQueryResult = Apollo.QueryResult<GetVdrPenetrationQuery, GetVdrPenetrationQueryVariables>;
export const GetCustomerAgreementsDocument = gql`
    query GetCustomerAgreements($filter: CustomerAgreementsFilter!) {
  customerAgreements(filter: $filter) {
    rows {
      resourceId
      resourceName
      customer
      startDate
      endDate
      terminationClause
      earlyTerminationIndemnity
      limitationOfLiability
      changeOfControl
      exclusivity
      contractValue
    }
  }
}
    `;

/**
 * __useGetCustomerAgreementsQuery__
 *
 * To run a query within a React component, call `useGetCustomerAgreementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAgreementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAgreementsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCustomerAgreementsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerAgreementsQuery, GetCustomerAgreementsQueryVariables> & ({ variables: GetCustomerAgreementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerAgreementsQuery, GetCustomerAgreementsQueryVariables>(GetCustomerAgreementsDocument, options);
      }
export function useGetCustomerAgreementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerAgreementsQuery, GetCustomerAgreementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerAgreementsQuery, GetCustomerAgreementsQueryVariables>(GetCustomerAgreementsDocument, options);
        }
// @ts-ignore
export function useGetCustomerAgreementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerAgreementsQuery, GetCustomerAgreementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerAgreementsQuery, GetCustomerAgreementsQueryVariables>;
export function useGetCustomerAgreementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerAgreementsQuery, GetCustomerAgreementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerAgreementsQuery | undefined, GetCustomerAgreementsQueryVariables>;
export function useGetCustomerAgreementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerAgreementsQuery, GetCustomerAgreementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerAgreementsQuery, GetCustomerAgreementsQueryVariables>(GetCustomerAgreementsDocument, options);
        }
export type GetCustomerAgreementsQueryHookResult = ReturnType<typeof useGetCustomerAgreementsQuery>;
export type GetCustomerAgreementsLazyQueryHookResult = ReturnType<typeof useGetCustomerAgreementsLazyQuery>;
export type GetCustomerAgreementsSuspenseQueryHookResult = ReturnType<typeof useGetCustomerAgreementsSuspenseQuery>;
export type GetCustomerAgreementsQueryResult = Apollo.QueryResult<GetCustomerAgreementsQuery, GetCustomerAgreementsQueryVariables>;
export const GetEmployeeAgreementsDocument = gql`
    query GetEmployeeAgreements($filter: EmployeeAgreementsFilter!) {
  employeeAgreements(filter: $filter) {
    rows {
      resourceId
      resourceName
      employee
      jobTitle
      hiringDate
      baseSalary
      ote
      nonCompete
      nonSolicitation
      ipClause
      governingLaw
    }
  }
}
    `;

/**
 * __useGetEmployeeAgreementsQuery__
 *
 * To run a query within a React component, call `useGetEmployeeAgreementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeAgreementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeAgreementsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetEmployeeAgreementsQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeAgreementsQuery, GetEmployeeAgreementsQueryVariables> & ({ variables: GetEmployeeAgreementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeAgreementsQuery, GetEmployeeAgreementsQueryVariables>(GetEmployeeAgreementsDocument, options);
      }
export function useGetEmployeeAgreementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeAgreementsQuery, GetEmployeeAgreementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeAgreementsQuery, GetEmployeeAgreementsQueryVariables>(GetEmployeeAgreementsDocument, options);
        }
// @ts-ignore
export function useGetEmployeeAgreementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmployeeAgreementsQuery, GetEmployeeAgreementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmployeeAgreementsQuery, GetEmployeeAgreementsQueryVariables>;
export function useGetEmployeeAgreementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeeAgreementsQuery, GetEmployeeAgreementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmployeeAgreementsQuery | undefined, GetEmployeeAgreementsQueryVariables>;
export function useGetEmployeeAgreementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeeAgreementsQuery, GetEmployeeAgreementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeeAgreementsQuery, GetEmployeeAgreementsQueryVariables>(GetEmployeeAgreementsDocument, options);
        }
export type GetEmployeeAgreementsQueryHookResult = ReturnType<typeof useGetEmployeeAgreementsQuery>;
export type GetEmployeeAgreementsLazyQueryHookResult = ReturnType<typeof useGetEmployeeAgreementsLazyQuery>;
export type GetEmployeeAgreementsSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeAgreementsSuspenseQuery>;
export type GetEmployeeAgreementsQueryResult = Apollo.QueryResult<GetEmployeeAgreementsQuery, GetEmployeeAgreementsQueryVariables>;
export const GetLeasesDocument = gql`
    query GetLeases($filter: LeasesFilter!) {
  leases(filter: $filter) {
    rows {
      resourceId
      resourceName
      document
      address
      term
      earlyTerminationAndRenewal
      annualRent
      increaseAnnual
      geoRisks
    }
  }
}
    `;

/**
 * __useGetLeasesQuery__
 *
 * To run a query within a React component, call `useGetLeasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeasesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetLeasesQuery(baseOptions: Apollo.QueryHookOptions<GetLeasesQuery, GetLeasesQueryVariables> & ({ variables: GetLeasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeasesQuery, GetLeasesQueryVariables>(GetLeasesDocument, options);
      }
export function useGetLeasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeasesQuery, GetLeasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeasesQuery, GetLeasesQueryVariables>(GetLeasesDocument, options);
        }
// @ts-ignore
export function useGetLeasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLeasesQuery, GetLeasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeasesQuery, GetLeasesQueryVariables>;
export function useGetLeasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeasesQuery, GetLeasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLeasesQuery | undefined, GetLeasesQueryVariables>;
export function useGetLeasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeasesQuery, GetLeasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeasesQuery, GetLeasesQueryVariables>(GetLeasesDocument, options);
        }
export type GetLeasesQueryHookResult = ReturnType<typeof useGetLeasesQuery>;
export type GetLeasesLazyQueryHookResult = ReturnType<typeof useGetLeasesLazyQuery>;
export type GetLeasesSuspenseQueryHookResult = ReturnType<typeof useGetLeasesSuspenseQuery>;
export type GetLeasesQueryResult = Apollo.QueryResult<GetLeasesQuery, GetLeasesQueryVariables>;
export const RegenerateWorkspaceMetadataDocument = gql`
    mutation RegenerateWorkspaceMetadata($input: RegenerateWorkspaceMetadataInput!) {
  regenerateWorkspaceMetadata(input: $input) {
    resourceCount
  }
}
    `;
export type RegenerateWorkspaceMetadataMutationFn = Apollo.MutationFunction<RegenerateWorkspaceMetadataMutation, RegenerateWorkspaceMetadataMutationVariables>;

/**
 * __useRegenerateWorkspaceMetadataMutation__
 *
 * To run a mutation, you first call `useRegenerateWorkspaceMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateWorkspaceMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateWorkspaceMetadataMutation, { data, loading, error }] = useRegenerateWorkspaceMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegenerateWorkspaceMetadataMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateWorkspaceMetadataMutation, RegenerateWorkspaceMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateWorkspaceMetadataMutation, RegenerateWorkspaceMetadataMutationVariables>(RegenerateWorkspaceMetadataDocument, options);
      }
export type RegenerateWorkspaceMetadataMutationHookResult = ReturnType<typeof useRegenerateWorkspaceMetadataMutation>;
export type RegenerateWorkspaceMetadataMutationResult = Apollo.MutationResult<RegenerateWorkspaceMetadataMutation>;
export type RegenerateWorkspaceMetadataMutationOptions = Apollo.BaseMutationOptions<RegenerateWorkspaceMetadataMutation, RegenerateWorkspaceMetadataMutationVariables>;
export const AddUsersToGroupDocument = gql`
    mutation AddUsersToGroup($groupId: ID!, $userEmails: [EmailAddress!]!) {
  addUsersToGroup(groupId: $groupId, userEmails: $userEmails) {
    id
    name
    color
    users {
      id
      auth0Id
      firstName
      lastName
      email
      pictureURL
      activityStatus
      updatedAt
      createdAt
    }
  }
}
    `;
export type AddUsersToGroupMutationFn = Apollo.MutationFunction<AddUsersToGroupMutation, AddUsersToGroupMutationVariables>;

/**
 * __useAddUsersToGroupMutation__
 *
 * To run a mutation, you first call `useAddUsersToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUsersToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUsersToGroupMutation, { data, loading, error }] = useAddUsersToGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userEmails: // value for 'userEmails'
 *   },
 * });
 */
export function useAddUsersToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddUsersToGroupMutation, AddUsersToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUsersToGroupMutation, AddUsersToGroupMutationVariables>(AddUsersToGroupDocument, options);
      }
export type AddUsersToGroupMutationHookResult = ReturnType<typeof useAddUsersToGroupMutation>;
export type AddUsersToGroupMutationResult = Apollo.MutationResult<AddUsersToGroupMutation>;
export type AddUsersToGroupMutationOptions = Apollo.BaseMutationOptions<AddUsersToGroupMutation, AddUsersToGroupMutationVariables>;
export const CopyGroupPermissionsDocument = gql`
    mutation CopyGroupPermissions($copyGroupPermissionsInput: CopyGroupPermissionsInput!) {
  copyGroupPermissions(copyGroupPermissionsInput: $copyGroupPermissionsInput) {
    __typename
    id
    name
  }
}
    `;
export type CopyGroupPermissionsMutationFn = Apollo.MutationFunction<CopyGroupPermissionsMutation, CopyGroupPermissionsMutationVariables>;

/**
 * __useCopyGroupPermissionsMutation__
 *
 * To run a mutation, you first call `useCopyGroupPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyGroupPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyGroupPermissionsMutation, { data, loading, error }] = useCopyGroupPermissionsMutation({
 *   variables: {
 *      copyGroupPermissionsInput: // value for 'copyGroupPermissionsInput'
 *   },
 * });
 */
export function useCopyGroupPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<CopyGroupPermissionsMutation, CopyGroupPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyGroupPermissionsMutation, CopyGroupPermissionsMutationVariables>(CopyGroupPermissionsDocument, options);
      }
export type CopyGroupPermissionsMutationHookResult = ReturnType<typeof useCopyGroupPermissionsMutation>;
export type CopyGroupPermissionsMutationResult = Apollo.MutationResult<CopyGroupPermissionsMutation>;
export type CopyGroupPermissionsMutationOptions = Apollo.BaseMutationOptions<CopyGroupPermissionsMutation, CopyGroupPermissionsMutationVariables>;
export const CreateGroupDocument = gql`
    mutation CreateGroup($createGroupInput: CreateGroupInput!) {
  createGroup(createGroupInput: $createGroupInput) {
    id
    updatedAt
    name
    color
    createdAt
    users {
      id
      firstName
      lastName
      email
      createdAt
      pictureURL
      archivedAt
      auth0Id
    }
    createdBy {
      id
      firstName
      email
      createdAt
      archivedAt
      lastName
      updatedAt
      pictureURL
    }
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      createGroupInput: // value for 'createGroupInput'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const CreateGroupFolderDocument = gql`
    mutation CreateGroupFolder($input: CreateGroupFolderInput!) {
  createGroupFolder(input: $input) {
    id
    name
    parentId
    workspaceId
    createdAt
    updatedAt
  }
}
    `;
export type CreateGroupFolderMutationFn = Apollo.MutationFunction<CreateGroupFolderMutation, CreateGroupFolderMutationVariables>;

/**
 * __useCreateGroupFolderMutation__
 *
 * To run a mutation, you first call `useCreateGroupFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupFolderMutation, { data, loading, error }] = useCreateGroupFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupFolderMutation, CreateGroupFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupFolderMutation, CreateGroupFolderMutationVariables>(CreateGroupFolderDocument, options);
      }
export type CreateGroupFolderMutationHookResult = ReturnType<typeof useCreateGroupFolderMutation>;
export type CreateGroupFolderMutationResult = Apollo.MutationResult<CreateGroupFolderMutation>;
export type CreateGroupFolderMutationOptions = Apollo.BaseMutationOptions<CreateGroupFolderMutation, CreateGroupFolderMutationVariables>;
export const DeleteGroupFolderDocument = gql`
    mutation DeleteGroupFolder($id: ID!) {
  deleteGroupFolder(id: $id)
}
    `;
export type DeleteGroupFolderMutationFn = Apollo.MutationFunction<DeleteGroupFolderMutation, DeleteGroupFolderMutationVariables>;

/**
 * __useDeleteGroupFolderMutation__
 *
 * To run a mutation, you first call `useDeleteGroupFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupFolderMutation, { data, loading, error }] = useDeleteGroupFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGroupFolderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupFolderMutation, DeleteGroupFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupFolderMutation, DeleteGroupFolderMutationVariables>(DeleteGroupFolderDocument, options);
      }
export type DeleteGroupFolderMutationHookResult = ReturnType<typeof useDeleteGroupFolderMutation>;
export type DeleteGroupFolderMutationResult = Apollo.MutationResult<DeleteGroupFolderMutation>;
export type DeleteGroupFolderMutationOptions = Apollo.BaseMutationOptions<DeleteGroupFolderMutation, DeleteGroupFolderMutationVariables>;
export const ExportResourceAccessJobDocument = gql`
    mutation ExportResourceAccessJob($workspaceId: ID!) {
  exportResourceAccessJob(workspaceId: $workspaceId)
}
    `;
export type ExportResourceAccessJobMutationFn = Apollo.MutationFunction<ExportResourceAccessJobMutation, ExportResourceAccessJobMutationVariables>;

/**
 * __useExportResourceAccessJobMutation__
 *
 * To run a mutation, you first call `useExportResourceAccessJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportResourceAccessJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportResourceAccessJobMutation, { data, loading, error }] = useExportResourceAccessJobMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useExportResourceAccessJobMutation(baseOptions?: Apollo.MutationHookOptions<ExportResourceAccessJobMutation, ExportResourceAccessJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportResourceAccessJobMutation, ExportResourceAccessJobMutationVariables>(ExportResourceAccessJobDocument, options);
      }
export type ExportResourceAccessJobMutationHookResult = ReturnType<typeof useExportResourceAccessJobMutation>;
export type ExportResourceAccessJobMutationResult = Apollo.MutationResult<ExportResourceAccessJobMutation>;
export type ExportResourceAccessJobMutationOptions = Apollo.BaseMutationOptions<ExportResourceAccessJobMutation, ExportResourceAccessJobMutationVariables>;
export const GetGroupAppliedResourceAccessPermissionsDocument = gql`
    query GetGroupAppliedResourceAccessPermissions($groupId: ID!, $parentId: ID) {
  getGroupAppliedResourceAccessPermissions(groupId: $groupId, parentId: $parentId)
}
    `;

/**
 * __useGetGroupAppliedResourceAccessPermissionsQuery__
 *
 * To run a query within a React component, call `useGetGroupAppliedResourceAccessPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupAppliedResourceAccessPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupAppliedResourceAccessPermissionsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useGetGroupAppliedResourceAccessPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupAppliedResourceAccessPermissionsQuery, GetGroupAppliedResourceAccessPermissionsQueryVariables> & ({ variables: GetGroupAppliedResourceAccessPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupAppliedResourceAccessPermissionsQuery, GetGroupAppliedResourceAccessPermissionsQueryVariables>(GetGroupAppliedResourceAccessPermissionsDocument, options);
      }
export function useGetGroupAppliedResourceAccessPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupAppliedResourceAccessPermissionsQuery, GetGroupAppliedResourceAccessPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupAppliedResourceAccessPermissionsQuery, GetGroupAppliedResourceAccessPermissionsQueryVariables>(GetGroupAppliedResourceAccessPermissionsDocument, options);
        }
// @ts-ignore
export function useGetGroupAppliedResourceAccessPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupAppliedResourceAccessPermissionsQuery, GetGroupAppliedResourceAccessPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupAppliedResourceAccessPermissionsQuery, GetGroupAppliedResourceAccessPermissionsQueryVariables>;
export function useGetGroupAppliedResourceAccessPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupAppliedResourceAccessPermissionsQuery, GetGroupAppliedResourceAccessPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupAppliedResourceAccessPermissionsQuery | undefined, GetGroupAppliedResourceAccessPermissionsQueryVariables>;
export function useGetGroupAppliedResourceAccessPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupAppliedResourceAccessPermissionsQuery, GetGroupAppliedResourceAccessPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupAppliedResourceAccessPermissionsQuery, GetGroupAppliedResourceAccessPermissionsQueryVariables>(GetGroupAppliedResourceAccessPermissionsDocument, options);
        }
export type GetGroupAppliedResourceAccessPermissionsQueryHookResult = ReturnType<typeof useGetGroupAppliedResourceAccessPermissionsQuery>;
export type GetGroupAppliedResourceAccessPermissionsLazyQueryHookResult = ReturnType<typeof useGetGroupAppliedResourceAccessPermissionsLazyQuery>;
export type GetGroupAppliedResourceAccessPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetGroupAppliedResourceAccessPermissionsSuspenseQuery>;
export type GetGroupAppliedResourceAccessPermissionsQueryResult = Apollo.QueryResult<GetGroupAppliedResourceAccessPermissionsQuery, GetGroupAppliedResourceAccessPermissionsQueryVariables>;
export const GetGroupFoldersDocument = gql`
    query GetGroupFolders($workspaceId: ID!) {
  groupFolders(workspaceId: $workspaceId) {
    id
    name
    parentId
    workspaceId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetGroupFoldersQuery__
 *
 * To run a query within a React component, call `useGetGroupFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupFoldersQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetGroupFoldersQuery(baseOptions: Apollo.QueryHookOptions<GetGroupFoldersQuery, GetGroupFoldersQueryVariables> & ({ variables: GetGroupFoldersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupFoldersQuery, GetGroupFoldersQueryVariables>(GetGroupFoldersDocument, options);
      }
export function useGetGroupFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupFoldersQuery, GetGroupFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupFoldersQuery, GetGroupFoldersQueryVariables>(GetGroupFoldersDocument, options);
        }
// @ts-ignore
export function useGetGroupFoldersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupFoldersQuery, GetGroupFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupFoldersQuery, GetGroupFoldersQueryVariables>;
export function useGetGroupFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupFoldersQuery, GetGroupFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupFoldersQuery | undefined, GetGroupFoldersQueryVariables>;
export function useGetGroupFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupFoldersQuery, GetGroupFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupFoldersQuery, GetGroupFoldersQueryVariables>(GetGroupFoldersDocument, options);
        }
export type GetGroupFoldersQueryHookResult = ReturnType<typeof useGetGroupFoldersQuery>;
export type GetGroupFoldersLazyQueryHookResult = ReturnType<typeof useGetGroupFoldersLazyQuery>;
export type GetGroupFoldersSuspenseQueryHookResult = ReturnType<typeof useGetGroupFoldersSuspenseQuery>;
export type GetGroupFoldersQueryResult = Apollo.QueryResult<GetGroupFoldersQuery, GetGroupFoldersQueryVariables>;
export const GetGroupsDocument = gql`
    query GetGroups($filter: GroupArgsFilter!, $limit: Int, $offset: Int, $sorter: GroupArgsSorter) {
  groups(filter: $filter, limit: $limit, offset: $offset, sorter: $sorter) {
    nodes {
      id
      name
      color
      folderId
      createdAt
      updatedAt
      users {
        id
        auth0Id
        firstName
        lastName
        email
        pictureURL
        activityStatus
        updatedAt
        createdAt
      }
      resourceAccess {
        id
        resourceId
        permissions
      }
      createdBy {
        id
        email
        firstName
        lastName
        pictureURL
      }
    }
    pageInfo {
      offset
      totalCount
    }
  }
}
    `;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables> & ({ variables: GetGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
// @ts-ignore
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsQuery | undefined, GetGroupsQueryVariables>;
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsSuspenseQueryHookResult = ReturnType<typeof useGetGroupsSuspenseQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetOneGroupDocument = gql`
    query GetOneGroup($groupId: ID!) {
  group(id: $groupId) {
    ...OneGroup
  }
}
    ${OneGroupFragmentDoc}`;

/**
 * __useGetOneGroupQuery__
 *
 * To run a query within a React component, call `useGetOneGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetOneGroupQuery(baseOptions: Apollo.QueryHookOptions<GetOneGroupQuery, GetOneGroupQueryVariables> & ({ variables: GetOneGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneGroupQuery, GetOneGroupQueryVariables>(GetOneGroupDocument, options);
      }
export function useGetOneGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneGroupQuery, GetOneGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneGroupQuery, GetOneGroupQueryVariables>(GetOneGroupDocument, options);
        }
// @ts-ignore
export function useGetOneGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOneGroupQuery, GetOneGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneGroupQuery, GetOneGroupQueryVariables>;
export function useGetOneGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneGroupQuery, GetOneGroupQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneGroupQuery | undefined, GetOneGroupQueryVariables>;
export function useGetOneGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneGroupQuery, GetOneGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneGroupQuery, GetOneGroupQueryVariables>(GetOneGroupDocument, options);
        }
export type GetOneGroupQueryHookResult = ReturnType<typeof useGetOneGroupQuery>;
export type GetOneGroupLazyQueryHookResult = ReturnType<typeof useGetOneGroupLazyQuery>;
export type GetOneGroupSuspenseQueryHookResult = ReturnType<typeof useGetOneGroupSuspenseQuery>;
export type GetOneGroupQueryResult = Apollo.QueryResult<GetOneGroupQuery, GetOneGroupQueryVariables>;
export const ListGroupsDocument = gql`
    query ListGroups($filter: GroupArgsFilter!, $limit: Int, $offset: Int, $sorter: GroupArgsSorter) {
  groups(filter: $filter, limit: $limit, offset: $offset, sorter: $sorter) {
    nodes {
      id
      name
      color
      folderId
      createdAt
      updatedAt
    }
    pageInfo {
      offset
      totalCount
    }
  }
}
    `;

/**
 * __useListGroupsQuery__
 *
 * To run a query within a React component, call `useListGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useListGroupsQuery(baseOptions: Apollo.QueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables> & ({ variables: ListGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
      }
export function useListGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
        }
// @ts-ignore
export function useListGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ListGroupsQuery, ListGroupsQueryVariables>;
export function useListGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ListGroupsQuery | undefined, ListGroupsQueryVariables>;
export function useListGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
        }
export type ListGroupsQueryHookResult = ReturnType<typeof useListGroupsQuery>;
export type ListGroupsLazyQueryHookResult = ReturnType<typeof useListGroupsLazyQuery>;
export type ListGroupsSuspenseQueryHookResult = ReturnType<typeof useListGroupsSuspenseQuery>;
export type ListGroupsQueryResult = Apollo.QueryResult<ListGroupsQuery, ListGroupsQueryVariables>;
export const RemoveGroupDocument = gql`
    mutation RemoveGroup($id: ID!) {
  removeGroup(id: $id) {
    name
  }
}
    `;
export type RemoveGroupMutationFn = Apollo.MutationFunction<RemoveGroupMutation, RemoveGroupMutationVariables>;

/**
 * __useRemoveGroupMutation__
 *
 * To run a mutation, you first call `useRemoveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroupMutation, { data, loading, error }] = useRemoveGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGroupMutation, RemoveGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGroupMutation, RemoveGroupMutationVariables>(RemoveGroupDocument, options);
      }
export type RemoveGroupMutationHookResult = ReturnType<typeof useRemoveGroupMutation>;
export type RemoveGroupMutationResult = Apollo.MutationResult<RemoveGroupMutation>;
export type RemoveGroupMutationOptions = Apollo.BaseMutationOptions<RemoveGroupMutation, RemoveGroupMutationVariables>;
export const RemoveUsersFromGroupDocument = gql`
    mutation RemoveUsersFromGroup($groupId: ID!, $userIds: [ID!]!) {
  removeUsersFromGroup(groupId: $groupId, userIds: $userIds) {
    id
    name
    color
    users {
      id
      auth0Id
      firstName
      lastName
      email
      pictureURL
      activityStatus
      updatedAt
      createdAt
    }
  }
}
    `;
export type RemoveUsersFromGroupMutationFn = Apollo.MutationFunction<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>;

/**
 * __useRemoveUsersFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveUsersFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUsersFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUsersFromGroupMutation, { data, loading, error }] = useRemoveUsersFromGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useRemoveUsersFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>(RemoveUsersFromGroupDocument, options);
      }
export type RemoveUsersFromGroupMutationHookResult = ReturnType<typeof useRemoveUsersFromGroupMutation>;
export type RemoveUsersFromGroupMutationResult = Apollo.MutationResult<RemoveUsersFromGroupMutation>;
export type RemoveUsersFromGroupMutationOptions = Apollo.BaseMutationOptions<RemoveUsersFromGroupMutation, RemoveUsersFromGroupMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($id: ID!, $updateGroupInput: UpdateGroupInput!) {
  updateGroup(id: $id, updateGroupInput: $updateGroupInput) {
    color
    id
    name
    folderId
    createdAt
    updatedAt
  }
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateGroupInput: // value for 'updateGroupInput'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const UpdateGroupFolderDocument = gql`
    mutation UpdateGroupFolder($input: UpdateGroupFolderInput!) {
  updateGroupFolder(input: $input) {
    id
    name
    parentId
    workspaceId
    createdAt
    updatedAt
  }
}
    `;
export type UpdateGroupFolderMutationFn = Apollo.MutationFunction<UpdateGroupFolderMutation, UpdateGroupFolderMutationVariables>;

/**
 * __useUpdateGroupFolderMutation__
 *
 * To run a mutation, you first call `useUpdateGroupFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupFolderMutation, { data, loading, error }] = useUpdateGroupFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupFolderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupFolderMutation, UpdateGroupFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupFolderMutation, UpdateGroupFolderMutationVariables>(UpdateGroupFolderDocument, options);
      }
export type UpdateGroupFolderMutationHookResult = ReturnType<typeof useUpdateGroupFolderMutation>;
export type UpdateGroupFolderMutationResult = Apollo.MutationResult<UpdateGroupFolderMutation>;
export type UpdateGroupFolderMutationOptions = Apollo.BaseMutationOptions<UpdateGroupFolderMutation, UpdateGroupFolderMutationVariables>;
export const UpdateGroupsResourceAccessDocument = gql`
    mutation UpdateGroupsResourceAccess($updateGroupResourceAccessInput: UpdateGroupResourceAccessInput!) {
  updateGroupResourceAccess(
    updateGroupResourceAccessInput: $updateGroupResourceAccessInput
  ) {
    __typename
    id
    permissions
    resourceId
    groupId
  }
}
    `;
export type UpdateGroupsResourceAccessMutationFn = Apollo.MutationFunction<UpdateGroupsResourceAccessMutation, UpdateGroupsResourceAccessMutationVariables>;

/**
 * __useUpdateGroupsResourceAccessMutation__
 *
 * To run a mutation, you first call `useUpdateGroupsResourceAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupsResourceAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupsResourceAccessMutation, { data, loading, error }] = useUpdateGroupsResourceAccessMutation({
 *   variables: {
 *      updateGroupResourceAccessInput: // value for 'updateGroupResourceAccessInput'
 *   },
 * });
 */
export function useUpdateGroupsResourceAccessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupsResourceAccessMutation, UpdateGroupsResourceAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupsResourceAccessMutation, UpdateGroupsResourceAccessMutationVariables>(UpdateGroupsResourceAccessDocument, options);
      }
export type UpdateGroupsResourceAccessMutationHookResult = ReturnType<typeof useUpdateGroupsResourceAccessMutation>;
export type UpdateGroupsResourceAccessMutationResult = Apollo.MutationResult<UpdateGroupsResourceAccessMutation>;
export type UpdateGroupsResourceAccessMutationOptions = Apollo.BaseMutationOptions<UpdateGroupsResourceAccessMutation, UpdateGroupsResourceAccessMutationVariables>;
export const TranslateContentDocument = gql`
    query TranslateContent($locale: Locale!, $resourceId: ID!, $workspaceId: ID!) {
  translateContent(
    locale: $locale
    resourceId: $resourceId
    workspaceId: $workspaceId
  )
}
    `;

/**
 * __useTranslateContentQuery__
 *
 * To run a query within a React component, call `useTranslateContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslateContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslateContentQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      resourceId: // value for 'resourceId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useTranslateContentQuery(baseOptions: Apollo.QueryHookOptions<TranslateContentQuery, TranslateContentQueryVariables> & ({ variables: TranslateContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TranslateContentQuery, TranslateContentQueryVariables>(TranslateContentDocument, options);
      }
export function useTranslateContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TranslateContentQuery, TranslateContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TranslateContentQuery, TranslateContentQueryVariables>(TranslateContentDocument, options);
        }
// @ts-ignore
export function useTranslateContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TranslateContentQuery, TranslateContentQueryVariables>): Apollo.UseSuspenseQueryResult<TranslateContentQuery, TranslateContentQueryVariables>;
export function useTranslateContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TranslateContentQuery, TranslateContentQueryVariables>): Apollo.UseSuspenseQueryResult<TranslateContentQuery | undefined, TranslateContentQueryVariables>;
export function useTranslateContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TranslateContentQuery, TranslateContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TranslateContentQuery, TranslateContentQueryVariables>(TranslateContentDocument, options);
        }
export type TranslateContentQueryHookResult = ReturnType<typeof useTranslateContentQuery>;
export type TranslateContentLazyQueryHookResult = ReturnType<typeof useTranslateContentLazyQuery>;
export type TranslateContentSuspenseQueryHookResult = ReturnType<typeof useTranslateContentSuspenseQuery>;
export type TranslateContentQueryResult = Apollo.QueryResult<TranslateContentQuery, TranslateContentQueryVariables>;
export const ClearNotificationsDocument = gql`
    mutation ClearNotifications($workspaceId: ID!, $notificationIds: [ID!]) {
  clearNotifications(workspaceId: $workspaceId, notificationIds: $notificationIds)
}
    `;
export type ClearNotificationsMutationFn = Apollo.MutationFunction<ClearNotificationsMutation, ClearNotificationsMutationVariables>;

/**
 * __useClearNotificationsMutation__
 *
 * To run a mutation, you first call `useClearNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearNotificationsMutation, { data, loading, error }] = useClearNotificationsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      notificationIds: // value for 'notificationIds'
 *   },
 * });
 */
export function useClearNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ClearNotificationsMutation, ClearNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearNotificationsMutation, ClearNotificationsMutationVariables>(ClearNotificationsDocument, options);
      }
export type ClearNotificationsMutationHookResult = ReturnType<typeof useClearNotificationsMutation>;
export type ClearNotificationsMutationResult = Apollo.MutationResult<ClearNotificationsMutation>;
export type ClearNotificationsMutationOptions = Apollo.BaseMutationOptions<ClearNotificationsMutation, ClearNotificationsMutationVariables>;
export const GetMyNotificationsDocument = gql`
    query GetMyNotifications($filter: NotificationArgsFilter, $limit: Int, $offset: Int, $sorter: NotificationArgsSorter) {
  myNotifications(
    filter: $filter
    limit: $limit
    offset: $offset
    sorter: $sorter
  ) {
    nodes {
      ...Notification
    }
    pageInfo {
      totalCount
    }
    unreadCount
  }
}
    ${NotificationFragmentDoc}`;

/**
 * __useGetMyNotificationsQuery__
 *
 * To run a query within a React component, call `useGetMyNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNotificationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useGetMyNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, options);
      }
export function useGetMyNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, options);
        }
// @ts-ignore
export function useGetMyNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>;
export function useGetMyNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyNotificationsQuery | undefined, GetMyNotificationsQueryVariables>;
export function useGetMyNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>(GetMyNotificationsDocument, options);
        }
export type GetMyNotificationsQueryHookResult = ReturnType<typeof useGetMyNotificationsQuery>;
export type GetMyNotificationsLazyQueryHookResult = ReturnType<typeof useGetMyNotificationsLazyQuery>;
export type GetMyNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetMyNotificationsSuspenseQuery>;
export type GetMyNotificationsQueryResult = Apollo.QueryResult<GetMyNotificationsQuery, GetMyNotificationsQueryVariables>;
export const MarkNotificationsAsReadDocument = gql`
    mutation MarkNotificationsAsRead($workspaceId: ID!, $notificationIds: [ID!]) {
  markNotificationsAsRead(
    workspaceId: $workspaceId
    notificationIds: $notificationIds
  ) {
    id
    readAt
  }
}
    `;
export type MarkNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;

/**
 * __useMarkNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsAsReadMutation, { data, loading, error }] = useMarkNotificationsAsReadMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      notificationIds: // value for 'notificationIds'
 *   },
 * });
 */
export function useMarkNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>(MarkNotificationsAsReadDocument, options);
      }
export type MarkNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationResult = Apollo.MutationResult<MarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const NotificationsDocument = gql`
    subscription Notifications($workspaceId: ID!) {
  notifications(workspaceId: $workspaceId) {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;

/**
 * __useNotificationsSubscription__
 *
 * To run a query within a React component, call `useNotificationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useNotificationsSubscription(baseOptions: Apollo.SubscriptionHookOptions<NotificationsSubscription, NotificationsSubscriptionVariables> & ({ variables: NotificationsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NotificationsSubscription, NotificationsSubscriptionVariables>(NotificationsDocument, options);
      }
export type NotificationsSubscriptionHookResult = ReturnType<typeof useNotificationsSubscription>;
export type NotificationsSubscriptionResult = Apollo.SubscriptionResult<NotificationsSubscription>;
export const GetResourcesForPermissionsDocument = gql`
    query GetResourcesForPermissions($filter: ResourceArgsFilter!, $sorter: ResourceArgsSorter, $limit: Int, $offset: Int) {
  resources(filter: $filter, sorter: $sorter, limit: $limit, offset: $offset) {
    nodes {
      ...ResourceForPermissionListItem
    }
    pageInfo {
      offset
      totalCount
    }
  }
}
    ${ResourceForPermissionListItemFragmentDoc}`;

/**
 * __useGetResourcesForPermissionsQuery__
 *
 * To run a query within a React component, call `useGetResourcesForPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcesForPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcesForPermissionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetResourcesForPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetResourcesForPermissionsQuery, GetResourcesForPermissionsQueryVariables> & ({ variables: GetResourcesForPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourcesForPermissionsQuery, GetResourcesForPermissionsQueryVariables>(GetResourcesForPermissionsDocument, options);
      }
export function useGetResourcesForPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourcesForPermissionsQuery, GetResourcesForPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourcesForPermissionsQuery, GetResourcesForPermissionsQueryVariables>(GetResourcesForPermissionsDocument, options);
        }
// @ts-ignore
export function useGetResourcesForPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetResourcesForPermissionsQuery, GetResourcesForPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourcesForPermissionsQuery, GetResourcesForPermissionsQueryVariables>;
export function useGetResourcesForPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourcesForPermissionsQuery, GetResourcesForPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourcesForPermissionsQuery | undefined, GetResourcesForPermissionsQueryVariables>;
export function useGetResourcesForPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourcesForPermissionsQuery, GetResourcesForPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResourcesForPermissionsQuery, GetResourcesForPermissionsQueryVariables>(GetResourcesForPermissionsDocument, options);
        }
export type GetResourcesForPermissionsQueryHookResult = ReturnType<typeof useGetResourcesForPermissionsQuery>;
export type GetResourcesForPermissionsLazyQueryHookResult = ReturnType<typeof useGetResourcesForPermissionsLazyQuery>;
export type GetResourcesForPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetResourcesForPermissionsSuspenseQuery>;
export type GetResourcesForPermissionsQueryResult = Apollo.QueryResult<GetResourcesForPermissionsQuery, GetResourcesForPermissionsQueryVariables>;
export const GetResourcesForPermissionsWithoutPaginationDocument = gql`
    query GetResourcesForPermissionsWithoutPagination($filter: ResourceArgsFilter!, $sorter: ResourceArgsSorter) {
  resourcesWithoutPagination(filter: $filter, sorter: $sorter) {
    ...ResourceForPermissionListItem
  }
}
    ${ResourceForPermissionListItemFragmentDoc}`;

/**
 * __useGetResourcesForPermissionsWithoutPaginationQuery__
 *
 * To run a query within a React component, call `useGetResourcesForPermissionsWithoutPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcesForPermissionsWithoutPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcesForPermissionsWithoutPaginationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useGetResourcesForPermissionsWithoutPaginationQuery(baseOptions: Apollo.QueryHookOptions<GetResourcesForPermissionsWithoutPaginationQuery, GetResourcesForPermissionsWithoutPaginationQueryVariables> & ({ variables: GetResourcesForPermissionsWithoutPaginationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourcesForPermissionsWithoutPaginationQuery, GetResourcesForPermissionsWithoutPaginationQueryVariables>(GetResourcesForPermissionsWithoutPaginationDocument, options);
      }
export function useGetResourcesForPermissionsWithoutPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourcesForPermissionsWithoutPaginationQuery, GetResourcesForPermissionsWithoutPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourcesForPermissionsWithoutPaginationQuery, GetResourcesForPermissionsWithoutPaginationQueryVariables>(GetResourcesForPermissionsWithoutPaginationDocument, options);
        }
// @ts-ignore
export function useGetResourcesForPermissionsWithoutPaginationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetResourcesForPermissionsWithoutPaginationQuery, GetResourcesForPermissionsWithoutPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourcesForPermissionsWithoutPaginationQuery, GetResourcesForPermissionsWithoutPaginationQueryVariables>;
export function useGetResourcesForPermissionsWithoutPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourcesForPermissionsWithoutPaginationQuery, GetResourcesForPermissionsWithoutPaginationQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourcesForPermissionsWithoutPaginationQuery | undefined, GetResourcesForPermissionsWithoutPaginationQueryVariables>;
export function useGetResourcesForPermissionsWithoutPaginationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourcesForPermissionsWithoutPaginationQuery, GetResourcesForPermissionsWithoutPaginationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResourcesForPermissionsWithoutPaginationQuery, GetResourcesForPermissionsWithoutPaginationQueryVariables>(GetResourcesForPermissionsWithoutPaginationDocument, options);
        }
export type GetResourcesForPermissionsWithoutPaginationQueryHookResult = ReturnType<typeof useGetResourcesForPermissionsWithoutPaginationQuery>;
export type GetResourcesForPermissionsWithoutPaginationLazyQueryHookResult = ReturnType<typeof useGetResourcesForPermissionsWithoutPaginationLazyQuery>;
export type GetResourcesForPermissionsWithoutPaginationSuspenseQueryHookResult = ReturnType<typeof useGetResourcesForPermissionsWithoutPaginationSuspenseQuery>;
export type GetResourcesForPermissionsWithoutPaginationQueryResult = Apollo.QueryResult<GetResourcesForPermissionsWithoutPaginationQuery, GetResourcesForPermissionsWithoutPaginationQueryVariables>;
export const GetRedactionsDocument = gql`
    query GetRedactions($filter: RedactionArgsFilter!, $sorter: RedactionArgsSorter, $limit: Int, $offset: Int) {
  redactions(filter: $filter, sorter: $sorter, limit: $limit, offset: $offset) {
    pageInfo {
      offset
      totalCount
    }
    nodes {
      ...Redaction
    }
  }
}
    ${RedactionFragmentDoc}`;

/**
 * __useGetRedactionsQuery__
 *
 * To run a query within a React component, call `useGetRedactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRedactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRedactionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetRedactionsQuery(baseOptions: Apollo.QueryHookOptions<GetRedactionsQuery, GetRedactionsQueryVariables> & ({ variables: GetRedactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRedactionsQuery, GetRedactionsQueryVariables>(GetRedactionsDocument, options);
      }
export function useGetRedactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRedactionsQuery, GetRedactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRedactionsQuery, GetRedactionsQueryVariables>(GetRedactionsDocument, options);
        }
// @ts-ignore
export function useGetRedactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRedactionsQuery, GetRedactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRedactionsQuery, GetRedactionsQueryVariables>;
export function useGetRedactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRedactionsQuery, GetRedactionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRedactionsQuery | undefined, GetRedactionsQueryVariables>;
export function useGetRedactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRedactionsQuery, GetRedactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRedactionsQuery, GetRedactionsQueryVariables>(GetRedactionsDocument, options);
        }
export type GetRedactionsQueryHookResult = ReturnType<typeof useGetRedactionsQuery>;
export type GetRedactionsLazyQueryHookResult = ReturnType<typeof useGetRedactionsLazyQuery>;
export type GetRedactionsSuspenseQueryHookResult = ReturnType<typeof useGetRedactionsSuspenseQuery>;
export type GetRedactionsQueryResult = Apollo.QueryResult<GetRedactionsQuery, GetRedactionsQueryVariables>;
export const GetRedactionsSummaryDocument = gql`
    query GetRedactionsSummary($filter: RedactionArgsFilter!, $sorter: RedactionArgsSorter) {
  redactionsSummary(filter: $filter, sorter: $sorter) {
    counts {
      status {
        redacted
        ignored
        pending
        failed
      }
      keywords {
        keyword
        count
      }
    }
  }
}
    `;

/**
 * __useGetRedactionsSummaryQuery__
 *
 * To run a query within a React component, call `useGetRedactionsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRedactionsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRedactionsSummaryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useGetRedactionsSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetRedactionsSummaryQuery, GetRedactionsSummaryQueryVariables> & ({ variables: GetRedactionsSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRedactionsSummaryQuery, GetRedactionsSummaryQueryVariables>(GetRedactionsSummaryDocument, options);
      }
export function useGetRedactionsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRedactionsSummaryQuery, GetRedactionsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRedactionsSummaryQuery, GetRedactionsSummaryQueryVariables>(GetRedactionsSummaryDocument, options);
        }
// @ts-ignore
export function useGetRedactionsSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRedactionsSummaryQuery, GetRedactionsSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetRedactionsSummaryQuery, GetRedactionsSummaryQueryVariables>;
export function useGetRedactionsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRedactionsSummaryQuery, GetRedactionsSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetRedactionsSummaryQuery | undefined, GetRedactionsSummaryQueryVariables>;
export function useGetRedactionsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRedactionsSummaryQuery, GetRedactionsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRedactionsSummaryQuery, GetRedactionsSummaryQueryVariables>(GetRedactionsSummaryDocument, options);
        }
export type GetRedactionsSummaryQueryHookResult = ReturnType<typeof useGetRedactionsSummaryQuery>;
export type GetRedactionsSummaryLazyQueryHookResult = ReturnType<typeof useGetRedactionsSummaryLazyQuery>;
export type GetRedactionsSummarySuspenseQueryHookResult = ReturnType<typeof useGetRedactionsSummarySuspenseQuery>;
export type GetRedactionsSummaryQueryResult = Apollo.QueryResult<GetRedactionsSummaryQuery, GetRedactionsSummaryQueryVariables>;
export const RedactEntitiesJobDocument = gql`
    mutation RedactEntitiesJob($filter: RedactionArgsFilter!, $action: String!, $include: [String!], $exclude: [String!]) {
  redactEntities(
    filter: $filter
    action: $action
    include: $include
    exclude: $exclude
  )
}
    `;
export type RedactEntitiesJobMutationFn = Apollo.MutationFunction<RedactEntitiesJobMutation, RedactEntitiesJobMutationVariables>;

/**
 * __useRedactEntitiesJobMutation__
 *
 * To run a mutation, you first call `useRedactEntitiesJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedactEntitiesJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redactEntitiesJobMutation, { data, loading, error }] = useRedactEntitiesJobMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      action: // value for 'action'
 *      include: // value for 'include'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useRedactEntitiesJobMutation(baseOptions?: Apollo.MutationHookOptions<RedactEntitiesJobMutation, RedactEntitiesJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedactEntitiesJobMutation, RedactEntitiesJobMutationVariables>(RedactEntitiesJobDocument, options);
      }
export type RedactEntitiesJobMutationHookResult = ReturnType<typeof useRedactEntitiesJobMutation>;
export type RedactEntitiesJobMutationResult = Apollo.MutationResult<RedactEntitiesJobMutation>;
export type RedactEntitiesJobMutationOptions = Apollo.BaseMutationOptions<RedactEntitiesJobMutation, RedactEntitiesJobMutationVariables>;
export const RedactSearchDocument = gql`
    query RedactSearch($workspaceId: ID!, $files: [String!]!, $entities: [RedactEntityArgs!], $keywords: [String!]) {
  redactSearchResults(
    workspaceId: $workspaceId
    files: $files
    entities: $entities
    keywords: $keywords
  ) {
    id
    text
    entity
    status
    matchData {
      id
      pageIndex
      previewText
      rangeInPreview
      rectsOnPage
    }
  }
}
    `;

/**
 * __useRedactSearchQuery__
 *
 * To run a query within a React component, call `useRedactSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedactSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedactSearchQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      files: // value for 'files'
 *      entities: // value for 'entities'
 *      keywords: // value for 'keywords'
 *   },
 * });
 */
export function useRedactSearchQuery(baseOptions: Apollo.QueryHookOptions<RedactSearchQuery, RedactSearchQueryVariables> & ({ variables: RedactSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedactSearchQuery, RedactSearchQueryVariables>(RedactSearchDocument, options);
      }
export function useRedactSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedactSearchQuery, RedactSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedactSearchQuery, RedactSearchQueryVariables>(RedactSearchDocument, options);
        }
// @ts-ignore
export function useRedactSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RedactSearchQuery, RedactSearchQueryVariables>): Apollo.UseSuspenseQueryResult<RedactSearchQuery, RedactSearchQueryVariables>;
export function useRedactSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RedactSearchQuery, RedactSearchQueryVariables>): Apollo.UseSuspenseQueryResult<RedactSearchQuery | undefined, RedactSearchQueryVariables>;
export function useRedactSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RedactSearchQuery, RedactSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RedactSearchQuery, RedactSearchQueryVariables>(RedactSearchDocument, options);
        }
export type RedactSearchQueryHookResult = ReturnType<typeof useRedactSearchQuery>;
export type RedactSearchLazyQueryHookResult = ReturnType<typeof useRedactSearchLazyQuery>;
export type RedactSearchSuspenseQueryHookResult = ReturnType<typeof useRedactSearchSuspenseQuery>;
export type RedactSearchQueryResult = Apollo.QueryResult<RedactSearchQuery, RedactSearchQueryVariables>;
export const ResourcesRedactedDocument = gql`
    subscription ResourcesRedacted($workspaceId: ID!) {
  resourcesRedacted(workspaceId: $workspaceId)
}
    `;

/**
 * __useResourcesRedactedSubscription__
 *
 * To run a query within a React component, call `useResourcesRedactedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useResourcesRedactedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesRedactedSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useResourcesRedactedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ResourcesRedactedSubscription, ResourcesRedactedSubscriptionVariables> & ({ variables: ResourcesRedactedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ResourcesRedactedSubscription, ResourcesRedactedSubscriptionVariables>(ResourcesRedactedDocument, options);
      }
export type ResourcesRedactedSubscriptionHookResult = ReturnType<typeof useResourcesRedactedSubscription>;
export type ResourcesRedactedSubscriptionResult = Apollo.SubscriptionResult<ResourcesRedactedSubscription>;
export const BulkUpdateRequestListStatusDocument = gql`
    mutation BulkUpdateRequestListStatus($input: BulkUpdateStatusInput!) {
  bulkUpdateRequestListStatus(input: $input) {
    ...RequestListFolderFragment
  }
}
    ${RequestListFolderFragmentFragmentDoc}`;
export type BulkUpdateRequestListStatusMutationFn = Apollo.MutationFunction<BulkUpdateRequestListStatusMutation, BulkUpdateRequestListStatusMutationVariables>;

/**
 * __useBulkUpdateRequestListStatusMutation__
 *
 * To run a mutation, you first call `useBulkUpdateRequestListStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateRequestListStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateRequestListStatusMutation, { data, loading, error }] = useBulkUpdateRequestListStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateRequestListStatusMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateRequestListStatusMutation, BulkUpdateRequestListStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateRequestListStatusMutation, BulkUpdateRequestListStatusMutationVariables>(BulkUpdateRequestListStatusDocument, options);
      }
export type BulkUpdateRequestListStatusMutationHookResult = ReturnType<typeof useBulkUpdateRequestListStatusMutation>;
export type BulkUpdateRequestListStatusMutationResult = Apollo.MutationResult<BulkUpdateRequestListStatusMutation>;
export type BulkUpdateRequestListStatusMutationOptions = Apollo.BaseMutationOptions<BulkUpdateRequestListStatusMutation, BulkUpdateRequestListStatusMutationVariables>;
export const CreateRequestListFolderDocument = gql`
    mutation CreateRequestListFolder($input: CreateRequestListFolderInput!) {
  createRequestListFolder(input: $input) {
    ...RequestListFolderFragment
  }
}
    ${RequestListFolderFragmentFragmentDoc}`;
export type CreateRequestListFolderMutationFn = Apollo.MutationFunction<CreateRequestListFolderMutation, CreateRequestListFolderMutationVariables>;

/**
 * __useCreateRequestListFolderMutation__
 *
 * To run a mutation, you first call `useCreateRequestListFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRequestListFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRequestListFolderMutation, { data, loading, error }] = useCreateRequestListFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRequestListFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateRequestListFolderMutation, CreateRequestListFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRequestListFolderMutation, CreateRequestListFolderMutationVariables>(CreateRequestListFolderDocument, options);
      }
export type CreateRequestListFolderMutationHookResult = ReturnType<typeof useCreateRequestListFolderMutation>;
export type CreateRequestListFolderMutationResult = Apollo.MutationResult<CreateRequestListFolderMutation>;
export type CreateRequestListFolderMutationOptions = Apollo.BaseMutationOptions<CreateRequestListFolderMutation, CreateRequestListFolderMutationVariables>;
export const DeleteRequestListFoldersDocument = gql`
    mutation DeleteRequestListFolders($ids: [ID!]!, $workspaceId: ID!) {
  deleteRequestListFolders(ids: $ids, workspaceId: $workspaceId)
}
    `;
export type DeleteRequestListFoldersMutationFn = Apollo.MutationFunction<DeleteRequestListFoldersMutation, DeleteRequestListFoldersMutationVariables>;

/**
 * __useDeleteRequestListFoldersMutation__
 *
 * To run a mutation, you first call `useDeleteRequestListFoldersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequestListFoldersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequestListFoldersMutation, { data, loading, error }] = useDeleteRequestListFoldersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteRequestListFoldersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRequestListFoldersMutation, DeleteRequestListFoldersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRequestListFoldersMutation, DeleteRequestListFoldersMutationVariables>(DeleteRequestListFoldersDocument, options);
      }
export type DeleteRequestListFoldersMutationHookResult = ReturnType<typeof useDeleteRequestListFoldersMutation>;
export type DeleteRequestListFoldersMutationResult = Apollo.MutationResult<DeleteRequestListFoldersMutation>;
export type DeleteRequestListFoldersMutationOptions = Apollo.BaseMutationOptions<DeleteRequestListFoldersMutation, DeleteRequestListFoldersMutationVariables>;
export const GenerateAiDescriptionsDocument = gql`
    mutation GenerateAIDescriptions($input: GenerateAIDescriptionsInput!) {
  generateAIDescriptions(input: $input)
}
    `;
export type GenerateAiDescriptionsMutationFn = Apollo.MutationFunction<GenerateAiDescriptionsMutation, GenerateAiDescriptionsMutationVariables>;

/**
 * __useGenerateAiDescriptionsMutation__
 *
 * To run a mutation, you first call `useGenerateAiDescriptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAiDescriptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAiDescriptionsMutation, { data, loading, error }] = useGenerateAiDescriptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAiDescriptionsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAiDescriptionsMutation, GenerateAiDescriptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAiDescriptionsMutation, GenerateAiDescriptionsMutationVariables>(GenerateAiDescriptionsDocument, options);
      }
export type GenerateAiDescriptionsMutationHookResult = ReturnType<typeof useGenerateAiDescriptionsMutation>;
export type GenerateAiDescriptionsMutationResult = Apollo.MutationResult<GenerateAiDescriptionsMutation>;
export type GenerateAiDescriptionsMutationOptions = Apollo.BaseMutationOptions<GenerateAiDescriptionsMutation, GenerateAiDescriptionsMutationVariables>;
export const GetRequestListFolderDocument = gql`
    query GetRequestListFolder($id: ID!, $workspaceId: ID!) {
  requestListFolder(id: $id, workspaceId: $workspaceId) {
    ...RequestListFolderFragment
  }
}
    ${RequestListFolderFragmentFragmentDoc}`;

/**
 * __useGetRequestListFolderQuery__
 *
 * To run a query within a React component, call `useGetRequestListFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestListFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestListFolderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetRequestListFolderQuery(baseOptions: Apollo.QueryHookOptions<GetRequestListFolderQuery, GetRequestListFolderQueryVariables> & ({ variables: GetRequestListFolderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequestListFolderQuery, GetRequestListFolderQueryVariables>(GetRequestListFolderDocument, options);
      }
export function useGetRequestListFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRequestListFolderQuery, GetRequestListFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequestListFolderQuery, GetRequestListFolderQueryVariables>(GetRequestListFolderDocument, options);
        }
// @ts-ignore
export function useGetRequestListFolderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRequestListFolderQuery, GetRequestListFolderQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequestListFolderQuery, GetRequestListFolderQueryVariables>;
export function useGetRequestListFolderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestListFolderQuery, GetRequestListFolderQueryVariables>): Apollo.UseSuspenseQueryResult<GetRequestListFolderQuery | undefined, GetRequestListFolderQueryVariables>;
export function useGetRequestListFolderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequestListFolderQuery, GetRequestListFolderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequestListFolderQuery, GetRequestListFolderQueryVariables>(GetRequestListFolderDocument, options);
        }
export type GetRequestListFolderQueryHookResult = ReturnType<typeof useGetRequestListFolderQuery>;
export type GetRequestListFolderLazyQueryHookResult = ReturnType<typeof useGetRequestListFolderLazyQuery>;
export type GetRequestListFolderSuspenseQueryHookResult = ReturnType<typeof useGetRequestListFolderSuspenseQuery>;
export type GetRequestListFolderQueryResult = Apollo.QueryResult<GetRequestListFolderQuery, GetRequestListFolderQueryVariables>;
export const ImportRequestListDocument = gql`
    mutation ImportRequestList($input: ImportRequestListInput!) {
  importRequestList(input: $input) {
    ...RequestListFolderFragment
  }
}
    ${RequestListFolderFragmentFragmentDoc}`;
export type ImportRequestListMutationFn = Apollo.MutationFunction<ImportRequestListMutation, ImportRequestListMutationVariables>;

/**
 * __useImportRequestListMutation__
 *
 * To run a mutation, you first call `useImportRequestListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRequestListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRequestListMutation, { data, loading, error }] = useImportRequestListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportRequestListMutation(baseOptions?: Apollo.MutationHookOptions<ImportRequestListMutation, ImportRequestListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportRequestListMutation, ImportRequestListMutationVariables>(ImportRequestListDocument, options);
      }
export type ImportRequestListMutationHookResult = ReturnType<typeof useImportRequestListMutation>;
export type ImportRequestListMutationResult = Apollo.MutationResult<ImportRequestListMutation>;
export type ImportRequestListMutationOptions = Apollo.BaseMutationOptions<ImportRequestListMutation, ImportRequestListMutationVariables>;
export const ItemDescriptionGeneratedDocument = gql`
    subscription ItemDescriptionGenerated($workspaceId: ID!) {
  itemDescriptionGenerated(workspaceId: $workspaceId) {
    id
    description
  }
}
    `;

/**
 * __useItemDescriptionGeneratedSubscription__
 *
 * To run a query within a React component, call `useItemDescriptionGeneratedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useItemDescriptionGeneratedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemDescriptionGeneratedSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useItemDescriptionGeneratedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ItemDescriptionGeneratedSubscription, ItemDescriptionGeneratedSubscriptionVariables> & ({ variables: ItemDescriptionGeneratedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ItemDescriptionGeneratedSubscription, ItemDescriptionGeneratedSubscriptionVariables>(ItemDescriptionGeneratedDocument, options);
      }
export type ItemDescriptionGeneratedSubscriptionHookResult = ReturnType<typeof useItemDescriptionGeneratedSubscription>;
export type ItemDescriptionGeneratedSubscriptionResult = Apollo.SubscriptionResult<ItemDescriptionGeneratedSubscription>;
export const ListRequestListFoldersDocument = gql`
    query ListRequestListFolders($filter: RequestListArgsFilter!, $sorter: RequestListArgsSorter) {
  requestListFolders(filter: $filter, sorter: $sorter) {
    ...RequestListFolderFragment
  }
}
    ${RequestListFolderFragmentFragmentDoc}`;

/**
 * __useListRequestListFoldersQuery__
 *
 * To run a query within a React component, call `useListRequestListFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRequestListFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRequestListFoldersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useListRequestListFoldersQuery(baseOptions: Apollo.QueryHookOptions<ListRequestListFoldersQuery, ListRequestListFoldersQueryVariables> & ({ variables: ListRequestListFoldersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRequestListFoldersQuery, ListRequestListFoldersQueryVariables>(ListRequestListFoldersDocument, options);
      }
export function useListRequestListFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRequestListFoldersQuery, ListRequestListFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRequestListFoldersQuery, ListRequestListFoldersQueryVariables>(ListRequestListFoldersDocument, options);
        }
// @ts-ignore
export function useListRequestListFoldersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListRequestListFoldersQuery, ListRequestListFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<ListRequestListFoldersQuery, ListRequestListFoldersQueryVariables>;
export function useListRequestListFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListRequestListFoldersQuery, ListRequestListFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<ListRequestListFoldersQuery | undefined, ListRequestListFoldersQueryVariables>;
export function useListRequestListFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListRequestListFoldersQuery, ListRequestListFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListRequestListFoldersQuery, ListRequestListFoldersQueryVariables>(ListRequestListFoldersDocument, options);
        }
export type ListRequestListFoldersQueryHookResult = ReturnType<typeof useListRequestListFoldersQuery>;
export type ListRequestListFoldersLazyQueryHookResult = ReturnType<typeof useListRequestListFoldersLazyQuery>;
export type ListRequestListFoldersSuspenseQueryHookResult = ReturnType<typeof useListRequestListFoldersSuspenseQuery>;
export type ListRequestListFoldersQueryResult = Apollo.QueryResult<ListRequestListFoldersQuery, ListRequestListFoldersQueryVariables>;
export const RecentClassifiedDocumentsDocument = gql`
    query RecentClassifiedDocuments($workspaceId: ID!, $offset: Int, $limit: Int) {
  recentClassifiedDocuments(
    workspaceId: $workspaceId
    offset: $offset
    limit: $limit
  ) {
    nodes {
      ...DocumentClassificationFragment
    }
    pageInfo {
      offset
      totalCount
    }
  }
}
    ${DocumentClassificationFragmentFragmentDoc}`;

/**
 * __useRecentClassifiedDocumentsQuery__
 *
 * To run a query within a React component, call `useRecentClassifiedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentClassifiedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentClassifiedDocumentsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecentClassifiedDocumentsQuery(baseOptions: Apollo.QueryHookOptions<RecentClassifiedDocumentsQuery, RecentClassifiedDocumentsQueryVariables> & ({ variables: RecentClassifiedDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentClassifiedDocumentsQuery, RecentClassifiedDocumentsQueryVariables>(RecentClassifiedDocumentsDocument, options);
      }
export function useRecentClassifiedDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentClassifiedDocumentsQuery, RecentClassifiedDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentClassifiedDocumentsQuery, RecentClassifiedDocumentsQueryVariables>(RecentClassifiedDocumentsDocument, options);
        }
// @ts-ignore
export function useRecentClassifiedDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecentClassifiedDocumentsQuery, RecentClassifiedDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<RecentClassifiedDocumentsQuery, RecentClassifiedDocumentsQueryVariables>;
export function useRecentClassifiedDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentClassifiedDocumentsQuery, RecentClassifiedDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<RecentClassifiedDocumentsQuery | undefined, RecentClassifiedDocumentsQueryVariables>;
export function useRecentClassifiedDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentClassifiedDocumentsQuery, RecentClassifiedDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentClassifiedDocumentsQuery, RecentClassifiedDocumentsQueryVariables>(RecentClassifiedDocumentsDocument, options);
        }
export type RecentClassifiedDocumentsQueryHookResult = ReturnType<typeof useRecentClassifiedDocumentsQuery>;
export type RecentClassifiedDocumentsLazyQueryHookResult = ReturnType<typeof useRecentClassifiedDocumentsLazyQuery>;
export type RecentClassifiedDocumentsSuspenseQueryHookResult = ReturnType<typeof useRecentClassifiedDocumentsSuspenseQuery>;
export type RecentClassifiedDocumentsQueryResult = Apollo.QueryResult<RecentClassifiedDocumentsQuery, RecentClassifiedDocumentsQueryVariables>;
export const RecentDirectUploadDocumentsDocument = gql`
    query RecentDirectUploadDocuments($workspaceId: ID!, $offset: Int, $limit: Int) {
  recentDirectUploadDocuments(
    workspaceId: $workspaceId
    offset: $offset
    limit: $limit
  ) {
    nodes {
      ...DocumentClassificationFragment
    }
    pageInfo {
      offset
      totalCount
    }
  }
}
    ${DocumentClassificationFragmentFragmentDoc}`;

/**
 * __useRecentDirectUploadDocumentsQuery__
 *
 * To run a query within a React component, call `useRecentDirectUploadDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentDirectUploadDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentDirectUploadDocumentsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecentDirectUploadDocumentsQuery(baseOptions: Apollo.QueryHookOptions<RecentDirectUploadDocumentsQuery, RecentDirectUploadDocumentsQueryVariables> & ({ variables: RecentDirectUploadDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentDirectUploadDocumentsQuery, RecentDirectUploadDocumentsQueryVariables>(RecentDirectUploadDocumentsDocument, options);
      }
export function useRecentDirectUploadDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentDirectUploadDocumentsQuery, RecentDirectUploadDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentDirectUploadDocumentsQuery, RecentDirectUploadDocumentsQueryVariables>(RecentDirectUploadDocumentsDocument, options);
        }
// @ts-ignore
export function useRecentDirectUploadDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecentDirectUploadDocumentsQuery, RecentDirectUploadDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<RecentDirectUploadDocumentsQuery, RecentDirectUploadDocumentsQueryVariables>;
export function useRecentDirectUploadDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentDirectUploadDocumentsQuery, RecentDirectUploadDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<RecentDirectUploadDocumentsQuery | undefined, RecentDirectUploadDocumentsQueryVariables>;
export function useRecentDirectUploadDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentDirectUploadDocumentsQuery, RecentDirectUploadDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentDirectUploadDocumentsQuery, RecentDirectUploadDocumentsQueryVariables>(RecentDirectUploadDocumentsDocument, options);
        }
export type RecentDirectUploadDocumentsQueryHookResult = ReturnType<typeof useRecentDirectUploadDocumentsQuery>;
export type RecentDirectUploadDocumentsLazyQueryHookResult = ReturnType<typeof useRecentDirectUploadDocumentsLazyQuery>;
export type RecentDirectUploadDocumentsSuspenseQueryHookResult = ReturnType<typeof useRecentDirectUploadDocumentsSuspenseQuery>;
export type RecentDirectUploadDocumentsQueryResult = Apollo.QueryResult<RecentDirectUploadDocumentsQuery, RecentDirectUploadDocumentsQueryVariables>;
export const RecentPendingValidationDocumentsDocument = gql`
    query RecentPendingValidationDocuments($workspaceId: ID!, $offset: Int, $limit: Int) {
  recentPendingValidationDocuments(
    workspaceId: $workspaceId
    offset: $offset
    limit: $limit
  ) {
    nodes {
      ...DocumentClassificationFragment
    }
    pageInfo {
      offset
      totalCount
    }
  }
}
    ${DocumentClassificationFragmentFragmentDoc}`;

/**
 * __useRecentPendingValidationDocumentsQuery__
 *
 * To run a query within a React component, call `useRecentPendingValidationDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentPendingValidationDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentPendingValidationDocumentsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecentPendingValidationDocumentsQuery(baseOptions: Apollo.QueryHookOptions<RecentPendingValidationDocumentsQuery, RecentPendingValidationDocumentsQueryVariables> & ({ variables: RecentPendingValidationDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentPendingValidationDocumentsQuery, RecentPendingValidationDocumentsQueryVariables>(RecentPendingValidationDocumentsDocument, options);
      }
export function useRecentPendingValidationDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentPendingValidationDocumentsQuery, RecentPendingValidationDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentPendingValidationDocumentsQuery, RecentPendingValidationDocumentsQueryVariables>(RecentPendingValidationDocumentsDocument, options);
        }
// @ts-ignore
export function useRecentPendingValidationDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecentPendingValidationDocumentsQuery, RecentPendingValidationDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<RecentPendingValidationDocumentsQuery, RecentPendingValidationDocumentsQueryVariables>;
export function useRecentPendingValidationDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentPendingValidationDocumentsQuery, RecentPendingValidationDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<RecentPendingValidationDocumentsQuery | undefined, RecentPendingValidationDocumentsQueryVariables>;
export function useRecentPendingValidationDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentPendingValidationDocumentsQuery, RecentPendingValidationDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentPendingValidationDocumentsQuery, RecentPendingValidationDocumentsQueryVariables>(RecentPendingValidationDocumentsDocument, options);
        }
export type RecentPendingValidationDocumentsQueryHookResult = ReturnType<typeof useRecentPendingValidationDocumentsQuery>;
export type RecentPendingValidationDocumentsLazyQueryHookResult = ReturnType<typeof useRecentPendingValidationDocumentsLazyQuery>;
export type RecentPendingValidationDocumentsSuspenseQueryHookResult = ReturnType<typeof useRecentPendingValidationDocumentsSuspenseQuery>;
export type RecentPendingValidationDocumentsQueryResult = Apollo.QueryResult<RecentPendingValidationDocumentsQuery, RecentPendingValidationDocumentsQueryVariables>;
export const RecentUnclassifiedDocumentsDocument = gql`
    query RecentUnclassifiedDocuments($workspaceId: ID!, $offset: Int, $limit: Int) {
  recentUnclassifiedDocuments(
    workspaceId: $workspaceId
    offset: $offset
    limit: $limit
  ) {
    nodes {
      ...DocumentClassificationFragment
    }
    pageInfo {
      offset
      totalCount
    }
  }
}
    ${DocumentClassificationFragmentFragmentDoc}`;

/**
 * __useRecentUnclassifiedDocumentsQuery__
 *
 * To run a query within a React component, call `useRecentUnclassifiedDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentUnclassifiedDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentUnclassifiedDocumentsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecentUnclassifiedDocumentsQuery(baseOptions: Apollo.QueryHookOptions<RecentUnclassifiedDocumentsQuery, RecentUnclassifiedDocumentsQueryVariables> & ({ variables: RecentUnclassifiedDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentUnclassifiedDocumentsQuery, RecentUnclassifiedDocumentsQueryVariables>(RecentUnclassifiedDocumentsDocument, options);
      }
export function useRecentUnclassifiedDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentUnclassifiedDocumentsQuery, RecentUnclassifiedDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentUnclassifiedDocumentsQuery, RecentUnclassifiedDocumentsQueryVariables>(RecentUnclassifiedDocumentsDocument, options);
        }
// @ts-ignore
export function useRecentUnclassifiedDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecentUnclassifiedDocumentsQuery, RecentUnclassifiedDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<RecentUnclassifiedDocumentsQuery, RecentUnclassifiedDocumentsQueryVariables>;
export function useRecentUnclassifiedDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentUnclassifiedDocumentsQuery, RecentUnclassifiedDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<RecentUnclassifiedDocumentsQuery | undefined, RecentUnclassifiedDocumentsQueryVariables>;
export function useRecentUnclassifiedDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentUnclassifiedDocumentsQuery, RecentUnclassifiedDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentUnclassifiedDocumentsQuery, RecentUnclassifiedDocumentsQueryVariables>(RecentUnclassifiedDocumentsDocument, options);
        }
export type RecentUnclassifiedDocumentsQueryHookResult = ReturnType<typeof useRecentUnclassifiedDocumentsQuery>;
export type RecentUnclassifiedDocumentsLazyQueryHookResult = ReturnType<typeof useRecentUnclassifiedDocumentsLazyQuery>;
export type RecentUnclassifiedDocumentsSuspenseQueryHookResult = ReturnType<typeof useRecentUnclassifiedDocumentsSuspenseQuery>;
export type RecentUnclassifiedDocumentsQueryResult = Apollo.QueryResult<RecentUnclassifiedDocumentsQuery, RecentUnclassifiedDocumentsQueryVariables>;
export const ReclassifyDocumentDocument = gql`
    mutation ReclassifyDocument($input: ReclassifyDocumentInput!) {
  reclassifyDocument(input: $input) {
    ...DocumentClassificationFragment
  }
}
    ${DocumentClassificationFragmentFragmentDoc}`;
export type ReclassifyDocumentMutationFn = Apollo.MutationFunction<ReclassifyDocumentMutation, ReclassifyDocumentMutationVariables>;

/**
 * __useReclassifyDocumentMutation__
 *
 * To run a mutation, you first call `useReclassifyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReclassifyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reclassifyDocumentMutation, { data, loading, error }] = useReclassifyDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReclassifyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ReclassifyDocumentMutation, ReclassifyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReclassifyDocumentMutation, ReclassifyDocumentMutationVariables>(ReclassifyDocumentDocument, options);
      }
export type ReclassifyDocumentMutationHookResult = ReturnType<typeof useReclassifyDocumentMutation>;
export type ReclassifyDocumentMutationResult = Apollo.MutationResult<ReclassifyDocumentMutation>;
export type ReclassifyDocumentMutationOptions = Apollo.BaseMutationOptions<ReclassifyDocumentMutation, ReclassifyDocumentMutationVariables>;
export const UpdateRequestListFolderDocument = gql`
    mutation UpdateRequestListFolder($input: UpdateRequestListFolderInput!) {
  updateRequestListFolder(input: $input) {
    ...RequestListFolderFragment
  }
}
    ${RequestListFolderFragmentFragmentDoc}`;
export type UpdateRequestListFolderMutationFn = Apollo.MutationFunction<UpdateRequestListFolderMutation, UpdateRequestListFolderMutationVariables>;

/**
 * __useUpdateRequestListFolderMutation__
 *
 * To run a mutation, you first call `useUpdateRequestListFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequestListFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequestListFolderMutation, { data, loading, error }] = useUpdateRequestListFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRequestListFolderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRequestListFolderMutation, UpdateRequestListFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRequestListFolderMutation, UpdateRequestListFolderMutationVariables>(UpdateRequestListFolderDocument, options);
      }
export type UpdateRequestListFolderMutationHookResult = ReturnType<typeof useUpdateRequestListFolderMutation>;
export type UpdateRequestListFolderMutationResult = Apollo.MutationResult<UpdateRequestListFolderMutation>;
export type UpdateRequestListFolderMutationOptions = Apollo.BaseMutationOptions<UpdateRequestListFolderMutation, UpdateRequestListFolderMutationVariables>;
export const UploadToRequestListFolderDocument = gql`
    mutation UploadToRequestListFolder($input: UploadToRequestListFolderInput!) {
  uploadToRequestListFolder(input: $input) {
    ...ResourceRowFragment
  }
}
    ${ResourceRowFragmentFragmentDoc}`;
export type UploadToRequestListFolderMutationFn = Apollo.MutationFunction<UploadToRequestListFolderMutation, UploadToRequestListFolderMutationVariables>;

/**
 * __useUploadToRequestListFolderMutation__
 *
 * To run a mutation, you first call `useUploadToRequestListFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadToRequestListFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadToRequestListFolderMutation, { data, loading, error }] = useUploadToRequestListFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadToRequestListFolderMutation(baseOptions?: Apollo.MutationHookOptions<UploadToRequestListFolderMutation, UploadToRequestListFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadToRequestListFolderMutation, UploadToRequestListFolderMutationVariables>(UploadToRequestListFolderDocument, options);
      }
export type UploadToRequestListFolderMutationHookResult = ReturnType<typeof useUploadToRequestListFolderMutation>;
export type UploadToRequestListFolderMutationResult = Apollo.MutationResult<UploadToRequestListFolderMutation>;
export type UploadToRequestListFolderMutationOptions = Apollo.BaseMutationOptions<UploadToRequestListFolderMutation, UploadToRequestListFolderMutationVariables>;
export const ValidateAllClassificationsDocument = gql`
    mutation ValidateAllClassifications($workspaceId: ID!) {
  validateAllClassifications(workspaceId: $workspaceId)
}
    `;
export type ValidateAllClassificationsMutationFn = Apollo.MutationFunction<ValidateAllClassificationsMutation, ValidateAllClassificationsMutationVariables>;

/**
 * __useValidateAllClassificationsMutation__
 *
 * To run a mutation, you first call `useValidateAllClassificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAllClassificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAllClassificationsMutation, { data, loading, error }] = useValidateAllClassificationsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useValidateAllClassificationsMutation(baseOptions?: Apollo.MutationHookOptions<ValidateAllClassificationsMutation, ValidateAllClassificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateAllClassificationsMutation, ValidateAllClassificationsMutationVariables>(ValidateAllClassificationsDocument, options);
      }
export type ValidateAllClassificationsMutationHookResult = ReturnType<typeof useValidateAllClassificationsMutation>;
export type ValidateAllClassificationsMutationResult = Apollo.MutationResult<ValidateAllClassificationsMutation>;
export type ValidateAllClassificationsMutationOptions = Apollo.BaseMutationOptions<ValidateAllClassificationsMutation, ValidateAllClassificationsMutationVariables>;
export const ValidateClassificationDocument = gql`
    mutation ValidateClassification($input: ValidateClassificationInput!) {
  validateClassification(input: $input) {
    ...DocumentClassificationFragment
  }
}
    ${DocumentClassificationFragmentFragmentDoc}`;
export type ValidateClassificationMutationFn = Apollo.MutationFunction<ValidateClassificationMutation, ValidateClassificationMutationVariables>;

/**
 * __useValidateClassificationMutation__
 *
 * To run a mutation, you first call `useValidateClassificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateClassificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateClassificationMutation, { data, loading, error }] = useValidateClassificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateClassificationMutation(baseOptions?: Apollo.MutationHookOptions<ValidateClassificationMutation, ValidateClassificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateClassificationMutation, ValidateClassificationMutationVariables>(ValidateClassificationDocument, options);
      }
export type ValidateClassificationMutationHookResult = ReturnType<typeof useValidateClassificationMutation>;
export type ValidateClassificationMutationResult = Apollo.MutationResult<ValidateClassificationMutation>;
export type ValidateClassificationMutationOptions = Apollo.BaseMutationOptions<ValidateClassificationMutation, ValidateClassificationMutationVariables>;
export const BulkMoveResourcesDocument = gql`
    mutation BulkMoveResources($resourcesToMove: [String!]!, $to: ID) {
  bulkMoveResources(resourcesToMove: $resourcesToMove, to: $to) {
    id
    parentId
    workspaceId
    name
    type
    mimeType
    size
    pspdfKitId
    isFavorite
    redactions {
      id
      entity
      text
      matchData {
        pageIndex
        previewText
        rangeInPreview
        rectsOnPage
      }
    }
    createdBy {
      id
      auth0Id
      firstName
      lastName
      email
      pictureURL
    }
    createdAt
    updatedAt
    archivedAt
  }
}
    `;
export type BulkMoveResourcesMutationFn = Apollo.MutationFunction<BulkMoveResourcesMutation, BulkMoveResourcesMutationVariables>;

/**
 * __useBulkMoveResourcesMutation__
 *
 * To run a mutation, you first call `useBulkMoveResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkMoveResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkMoveResourcesMutation, { data, loading, error }] = useBulkMoveResourcesMutation({
 *   variables: {
 *      resourcesToMove: // value for 'resourcesToMove'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useBulkMoveResourcesMutation(baseOptions?: Apollo.MutationHookOptions<BulkMoveResourcesMutation, BulkMoveResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkMoveResourcesMutation, BulkMoveResourcesMutationVariables>(BulkMoveResourcesDocument, options);
      }
export type BulkMoveResourcesMutationHookResult = ReturnType<typeof useBulkMoveResourcesMutation>;
export type BulkMoveResourcesMutationResult = Apollo.MutationResult<BulkMoveResourcesMutation>;
export type BulkMoveResourcesMutationOptions = Apollo.BaseMutationOptions<BulkMoveResourcesMutation, BulkMoveResourcesMutationVariables>;
export const BulkRenameResourcesDocument = gql`
    mutation BulkRenameResources($renameComponents: [ResourceBulkRenameComponentType!]!, $resourcesToRename: [ResourceToRename!]!, $renameOptions: [ResourceBulkRenameOptionType!], $customValues: [String!]) {
  bulkRenameResources(
    renameComponents: $renameComponents
    resourcesToRename: $resourcesToRename
    renameOptions: $renameOptions
    customValues: $customValues
  ) {
    id
    name
    updatedAt
  }
}
    `;
export type BulkRenameResourcesMutationFn = Apollo.MutationFunction<BulkRenameResourcesMutation, BulkRenameResourcesMutationVariables>;

/**
 * __useBulkRenameResourcesMutation__
 *
 * To run a mutation, you first call `useBulkRenameResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRenameResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRenameResourcesMutation, { data, loading, error }] = useBulkRenameResourcesMutation({
 *   variables: {
 *      renameComponents: // value for 'renameComponents'
 *      resourcesToRename: // value for 'resourcesToRename'
 *      renameOptions: // value for 'renameOptions'
 *      customValues: // value for 'customValues'
 *   },
 * });
 */
export function useBulkRenameResourcesMutation(baseOptions?: Apollo.MutationHookOptions<BulkRenameResourcesMutation, BulkRenameResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRenameResourcesMutation, BulkRenameResourcesMutationVariables>(BulkRenameResourcesDocument, options);
      }
export type BulkRenameResourcesMutationHookResult = ReturnType<typeof useBulkRenameResourcesMutation>;
export type BulkRenameResourcesMutationResult = Apollo.MutationResult<BulkRenameResourcesMutation>;
export type BulkRenameResourcesMutationOptions = Apollo.BaseMutationOptions<BulkRenameResourcesMutation, BulkRenameResourcesMutationVariables>;
export const CopyResourcesDocument = gql`
    mutation CopyResources($copyInput: CopyInput!) {
  copy(copyInput: $copyInput) {
    id
  }
}
    `;
export type CopyResourcesMutationFn = Apollo.MutationFunction<CopyResourcesMutation, CopyResourcesMutationVariables>;

/**
 * __useCopyResourcesMutation__
 *
 * To run a mutation, you first call `useCopyResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyResourcesMutation, { data, loading, error }] = useCopyResourcesMutation({
 *   variables: {
 *      copyInput: // value for 'copyInput'
 *   },
 * });
 */
export function useCopyResourcesMutation(baseOptions?: Apollo.MutationHookOptions<CopyResourcesMutation, CopyResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyResourcesMutation, CopyResourcesMutationVariables>(CopyResourcesDocument, options);
      }
export type CopyResourcesMutationHookResult = ReturnType<typeof useCopyResourcesMutation>;
export type CopyResourcesMutationResult = Apollo.MutationResult<CopyResourcesMutation>;
export type CopyResourcesMutationOptions = Apollo.BaseMutationOptions<CopyResourcesMutation, CopyResourcesMutationVariables>;
export const CreateDownloadActivityDocument = gql`
    mutation CreateDownloadActivity($resourceId: ID!) {
  createDownloadActivity(resourceId: $resourceId)
}
    `;
export type CreateDownloadActivityMutationFn = Apollo.MutationFunction<CreateDownloadActivityMutation, CreateDownloadActivityMutationVariables>;

/**
 * __useCreateDownloadActivityMutation__
 *
 * To run a mutation, you first call `useCreateDownloadActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDownloadActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDownloadActivityMutation, { data, loading, error }] = useCreateDownloadActivityMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useCreateDownloadActivityMutation(baseOptions?: Apollo.MutationHookOptions<CreateDownloadActivityMutation, CreateDownloadActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDownloadActivityMutation, CreateDownloadActivityMutationVariables>(CreateDownloadActivityDocument, options);
      }
export type CreateDownloadActivityMutationHookResult = ReturnType<typeof useCreateDownloadActivityMutation>;
export type CreateDownloadActivityMutationResult = Apollo.MutationResult<CreateDownloadActivityMutation>;
export type CreateDownloadActivityMutationOptions = Apollo.BaseMutationOptions<CreateDownloadActivityMutation, CreateDownloadActivityMutationVariables>;
export const CreateResourcesDocument = gql`
    mutation CreateResources($createResourcesInput: CreateResourcesInput!) {
  createResources(createResourcesInput: $createResourcesInput) {
    ...ResourceRowFragment
  }
}
    ${ResourceRowFragmentFragmentDoc}`;
export type CreateResourcesMutationFn = Apollo.MutationFunction<CreateResourcesMutation, CreateResourcesMutationVariables>;

/**
 * __useCreateResourcesMutation__
 *
 * To run a mutation, you first call `useCreateResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourcesMutation, { data, loading, error }] = useCreateResourcesMutation({
 *   variables: {
 *      createResourcesInput: // value for 'createResourcesInput'
 *   },
 * });
 */
export function useCreateResourcesMutation(baseOptions?: Apollo.MutationHookOptions<CreateResourcesMutation, CreateResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResourcesMutation, CreateResourcesMutationVariables>(CreateResourcesDocument, options);
      }
export type CreateResourcesMutationHookResult = ReturnType<typeof useCreateResourcesMutation>;
export type CreateResourcesMutationResult = Apollo.MutationResult<CreateResourcesMutation>;
export type CreateResourcesMutationOptions = Apollo.BaseMutationOptions<CreateResourcesMutation, CreateResourcesMutationVariables>;
export const ExportWorkspaceResourcesJobDocument = gql`
    mutation ExportWorkspaceResourcesJob($workspaceId: ID!) {
  exportWorkspaceResourcesJob(workspaceId: $workspaceId)
}
    `;
export type ExportWorkspaceResourcesJobMutationFn = Apollo.MutationFunction<ExportWorkspaceResourcesJobMutation, ExportWorkspaceResourcesJobMutationVariables>;

/**
 * __useExportWorkspaceResourcesJobMutation__
 *
 * To run a mutation, you first call `useExportWorkspaceResourcesJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportWorkspaceResourcesJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportWorkspaceResourcesJobMutation, { data, loading, error }] = useExportWorkspaceResourcesJobMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useExportWorkspaceResourcesJobMutation(baseOptions?: Apollo.MutationHookOptions<ExportWorkspaceResourcesJobMutation, ExportWorkspaceResourcesJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportWorkspaceResourcesJobMutation, ExportWorkspaceResourcesJobMutationVariables>(ExportWorkspaceResourcesJobDocument, options);
      }
export type ExportWorkspaceResourcesJobMutationHookResult = ReturnType<typeof useExportWorkspaceResourcesJobMutation>;
export type ExportWorkspaceResourcesJobMutationResult = Apollo.MutationResult<ExportWorkspaceResourcesJobMutation>;
export type ExportWorkspaceResourcesJobMutationOptions = Apollo.BaseMutationOptions<ExportWorkspaceResourcesJobMutation, ExportWorkspaceResourcesJobMutationVariables>;
export const FinalizeMultipartUploadDocument = gql`
    mutation FinalizeMultipartUpload($finalizeMultipartUploadInput: FinalizeMultipartUploadInput!) {
  finalizeMultipartUpload(
    finalizeMultipartUploadInput: $finalizeMultipartUploadInput
  )
}
    `;
export type FinalizeMultipartUploadMutationFn = Apollo.MutationFunction<FinalizeMultipartUploadMutation, FinalizeMultipartUploadMutationVariables>;

/**
 * __useFinalizeMultipartUploadMutation__
 *
 * To run a mutation, you first call `useFinalizeMultipartUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeMultipartUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeMultipartUploadMutation, { data, loading, error }] = useFinalizeMultipartUploadMutation({
 *   variables: {
 *      finalizeMultipartUploadInput: // value for 'finalizeMultipartUploadInput'
 *   },
 * });
 */
export function useFinalizeMultipartUploadMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeMultipartUploadMutation, FinalizeMultipartUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeMultipartUploadMutation, FinalizeMultipartUploadMutationVariables>(FinalizeMultipartUploadDocument, options);
      }
export type FinalizeMultipartUploadMutationHookResult = ReturnType<typeof useFinalizeMultipartUploadMutation>;
export type FinalizeMultipartUploadMutationResult = Apollo.MutationResult<FinalizeMultipartUploadMutation>;
export type FinalizeMultipartUploadMutationOptions = Apollo.BaseMutationOptions<FinalizeMultipartUploadMutation, FinalizeMultipartUploadMutationVariables>;
export const GetDatadumpConfigDocument = gql`
    query GetDatadumpConfig($workspaceId: ID!) {
  datadumpConfig(workspaceId: $workspaceId) {
    id
    dataroomFolderId
    datadumpFolderId
  }
}
    `;

/**
 * __useGetDatadumpConfigQuery__
 *
 * To run a query within a React component, call `useGetDatadumpConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatadumpConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatadumpConfigQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetDatadumpConfigQuery(baseOptions: Apollo.QueryHookOptions<GetDatadumpConfigQuery, GetDatadumpConfigQueryVariables> & ({ variables: GetDatadumpConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatadumpConfigQuery, GetDatadumpConfigQueryVariables>(GetDatadumpConfigDocument, options);
      }
export function useGetDatadumpConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatadumpConfigQuery, GetDatadumpConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatadumpConfigQuery, GetDatadumpConfigQueryVariables>(GetDatadumpConfigDocument, options);
        }
// @ts-ignore
export function useGetDatadumpConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatadumpConfigQuery, GetDatadumpConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatadumpConfigQuery, GetDatadumpConfigQueryVariables>;
export function useGetDatadumpConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatadumpConfigQuery, GetDatadumpConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetDatadumpConfigQuery | undefined, GetDatadumpConfigQueryVariables>;
export function useGetDatadumpConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatadumpConfigQuery, GetDatadumpConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatadumpConfigQuery, GetDatadumpConfigQueryVariables>(GetDatadumpConfigDocument, options);
        }
export type GetDatadumpConfigQueryHookResult = ReturnType<typeof useGetDatadumpConfigQuery>;
export type GetDatadumpConfigLazyQueryHookResult = ReturnType<typeof useGetDatadumpConfigLazyQuery>;
export type GetDatadumpConfigSuspenseQueryHookResult = ReturnType<typeof useGetDatadumpConfigSuspenseQuery>;
export type GetDatadumpConfigQueryResult = Apollo.QueryResult<GetDatadumpConfigQuery, GetDatadumpConfigQueryVariables>;
export const GetMultipartPreSignedUrlsDocument = gql`
    query GetMultipartPreSignedUrls($fileKey: String!, $uploadId: String!, $parts: Int!) {
  getMultipartPreSignedUrls(fileKey: $fileKey, uploadId: $uploadId, parts: $parts)
}
    `;

/**
 * __useGetMultipartPreSignedUrlsQuery__
 *
 * To run a query within a React component, call `useGetMultipartPreSignedUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultipartPreSignedUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultipartPreSignedUrlsQuery({
 *   variables: {
 *      fileKey: // value for 'fileKey'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useGetMultipartPreSignedUrlsQuery(baseOptions: Apollo.QueryHookOptions<GetMultipartPreSignedUrlsQuery, GetMultipartPreSignedUrlsQueryVariables> & ({ variables: GetMultipartPreSignedUrlsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultipartPreSignedUrlsQuery, GetMultipartPreSignedUrlsQueryVariables>(GetMultipartPreSignedUrlsDocument, options);
      }
export function useGetMultipartPreSignedUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMultipartPreSignedUrlsQuery, GetMultipartPreSignedUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultipartPreSignedUrlsQuery, GetMultipartPreSignedUrlsQueryVariables>(GetMultipartPreSignedUrlsDocument, options);
        }
// @ts-ignore
export function useGetMultipartPreSignedUrlsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMultipartPreSignedUrlsQuery, GetMultipartPreSignedUrlsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMultipartPreSignedUrlsQuery, GetMultipartPreSignedUrlsQueryVariables>;
export function useGetMultipartPreSignedUrlsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMultipartPreSignedUrlsQuery, GetMultipartPreSignedUrlsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMultipartPreSignedUrlsQuery | undefined, GetMultipartPreSignedUrlsQueryVariables>;
export function useGetMultipartPreSignedUrlsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMultipartPreSignedUrlsQuery, GetMultipartPreSignedUrlsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMultipartPreSignedUrlsQuery, GetMultipartPreSignedUrlsQueryVariables>(GetMultipartPreSignedUrlsDocument, options);
        }
export type GetMultipartPreSignedUrlsQueryHookResult = ReturnType<typeof useGetMultipartPreSignedUrlsQuery>;
export type GetMultipartPreSignedUrlsLazyQueryHookResult = ReturnType<typeof useGetMultipartPreSignedUrlsLazyQuery>;
export type GetMultipartPreSignedUrlsSuspenseQueryHookResult = ReturnType<typeof useGetMultipartPreSignedUrlsSuspenseQuery>;
export type GetMultipartPreSignedUrlsQueryResult = Apollo.QueryResult<GetMultipartPreSignedUrlsQuery, GetMultipartPreSignedUrlsQueryVariables>;
export const GetNonDownloadableResourcesDocument = gql`
    query GetNonDownloadableResources($workspaceId: ID!, $resourceIds: [ID!]!) {
  nonDownloadableResources(workspaceId: $workspaceId, resourceIds: $resourceIds) {
    id
    name
  }
}
    `;

/**
 * __useGetNonDownloadableResourcesQuery__
 *
 * To run a query within a React component, call `useGetNonDownloadableResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonDownloadableResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonDownloadableResourcesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      resourceIds: // value for 'resourceIds'
 *   },
 * });
 */
export function useGetNonDownloadableResourcesQuery(baseOptions: Apollo.QueryHookOptions<GetNonDownloadableResourcesQuery, GetNonDownloadableResourcesQueryVariables> & ({ variables: GetNonDownloadableResourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonDownloadableResourcesQuery, GetNonDownloadableResourcesQueryVariables>(GetNonDownloadableResourcesDocument, options);
      }
export function useGetNonDownloadableResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonDownloadableResourcesQuery, GetNonDownloadableResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonDownloadableResourcesQuery, GetNonDownloadableResourcesQueryVariables>(GetNonDownloadableResourcesDocument, options);
        }
// @ts-ignore
export function useGetNonDownloadableResourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNonDownloadableResourcesQuery, GetNonDownloadableResourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetNonDownloadableResourcesQuery, GetNonDownloadableResourcesQueryVariables>;
export function useGetNonDownloadableResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNonDownloadableResourcesQuery, GetNonDownloadableResourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetNonDownloadableResourcesQuery | undefined, GetNonDownloadableResourcesQueryVariables>;
export function useGetNonDownloadableResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNonDownloadableResourcesQuery, GetNonDownloadableResourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNonDownloadableResourcesQuery, GetNonDownloadableResourcesQueryVariables>(GetNonDownloadableResourcesDocument, options);
        }
export type GetNonDownloadableResourcesQueryHookResult = ReturnType<typeof useGetNonDownloadableResourcesQuery>;
export type GetNonDownloadableResourcesLazyQueryHookResult = ReturnType<typeof useGetNonDownloadableResourcesLazyQuery>;
export type GetNonDownloadableResourcesSuspenseQueryHookResult = ReturnType<typeof useGetNonDownloadableResourcesSuspenseQuery>;
export type GetNonDownloadableResourcesQueryResult = Apollo.QueryResult<GetNonDownloadableResourcesQuery, GetNonDownloadableResourcesQueryVariables>;
export const GetOneResourceDocument = gql`
    query GetOneResource($workspaceId: ID!, $resourceId: ID!, $isViewed: Boolean) {
  resource(workspaceId: $workspaceId, id: $resourceId, isViewed: $isViewed) {
    id
    index
    rank
    publicId
    parentId
    workspaceId
    name
    type
    canDownload
    viewUrl
    mimeType
    size
    summary
    pspdfKitId
    isFavorite
    isFaulty
    isQaOnly
    accesses {
      id
      permissions
      resourceId
      groupId
    }
    inheritedAccesses {
      id
      permissions
      resourceId
      groupId
    }
    descendantsAccesses {
      id
      permissions
      resourceId
      groupId
    }
    redactions {
      id
      status
      entity
      text
      matchData {
        id
        pageIndex
        previewText
        rangeInPreview
        rectsOnPage
        isAnnotation
      }
    }
    activities {
      id
      topic
      createdAt
    }
    createdBy {
      id
      firstName
      lastName
      email
      pictureURL
    }
    createdAt
    updatedAt
    metadata {
      ... on GenericDocumentMetadataType {
        documentType
      }
      ... on CustomerAgreementMetadataType {
        documentType
        customer
        startDate
        endDate
        terminationClause
        earlyTerminationIndemnity
        limitationOfLiability
        changeOfControl
        exclusivity
        contractValue
      }
      ... on EmployeeAgreementMetadataType {
        documentType
        employee
        jobTitle
        hiringDate
        baseSalary
        ote
        nonCompete
        nonSolicitation
        ipClause
        governingLaw
      }
      ... on LeaseMetadataType {
        documentType
        document
        address
        term
        earlyTerminationAndRenewal
        annualRent
        increaseAnnual
        geoRisks
      }
    }
  }
}
    `;

/**
 * __useGetOneResourceQuery__
 *
 * To run a query within a React component, call `useGetOneResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneResourceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      resourceId: // value for 'resourceId'
 *      isViewed: // value for 'isViewed'
 *   },
 * });
 */
export function useGetOneResourceQuery(baseOptions: Apollo.QueryHookOptions<GetOneResourceQuery, GetOneResourceQueryVariables> & ({ variables: GetOneResourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneResourceQuery, GetOneResourceQueryVariables>(GetOneResourceDocument, options);
      }
export function useGetOneResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneResourceQuery, GetOneResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneResourceQuery, GetOneResourceQueryVariables>(GetOneResourceDocument, options);
        }
// @ts-ignore
export function useGetOneResourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOneResourceQuery, GetOneResourceQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneResourceQuery, GetOneResourceQueryVariables>;
export function useGetOneResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneResourceQuery, GetOneResourceQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneResourceQuery | undefined, GetOneResourceQueryVariables>;
export function useGetOneResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneResourceQuery, GetOneResourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneResourceQuery, GetOneResourceQueryVariables>(GetOneResourceDocument, options);
        }
export type GetOneResourceQueryHookResult = ReturnType<typeof useGetOneResourceQuery>;
export type GetOneResourceLazyQueryHookResult = ReturnType<typeof useGetOneResourceLazyQuery>;
export type GetOneResourceSuspenseQueryHookResult = ReturnType<typeof useGetOneResourceSuspenseQuery>;
export type GetOneResourceQueryResult = Apollo.QueryResult<GetOneResourceQuery, GetOneResourceQueryVariables>;
export const GetParentPermissionsDocument = gql`
    query GetParentPermissions($filter: ResourceArgsFilter!, $limit: Int) {
  resources(filter: $filter, limit: $limit) {
    nodes {
      id
      name
      accesses {
        id
        permissions
        groupId
        group {
          id
          name
          color
          folderId
        }
      }
      inheritedAccesses {
        id
        permissions
        groupId
        group {
          id
          name
          color
          folderId
        }
      }
    }
  }
}
    `;

/**
 * __useGetParentPermissionsQuery__
 *
 * To run a query within a React component, call `useGetParentPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentPermissionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetParentPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetParentPermissionsQuery, GetParentPermissionsQueryVariables> & ({ variables: GetParentPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParentPermissionsQuery, GetParentPermissionsQueryVariables>(GetParentPermissionsDocument, options);
      }
export function useGetParentPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParentPermissionsQuery, GetParentPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParentPermissionsQuery, GetParentPermissionsQueryVariables>(GetParentPermissionsDocument, options);
        }
// @ts-ignore
export function useGetParentPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetParentPermissionsQuery, GetParentPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetParentPermissionsQuery, GetParentPermissionsQueryVariables>;
export function useGetParentPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParentPermissionsQuery, GetParentPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetParentPermissionsQuery | undefined, GetParentPermissionsQueryVariables>;
export function useGetParentPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParentPermissionsQuery, GetParentPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParentPermissionsQuery, GetParentPermissionsQueryVariables>(GetParentPermissionsDocument, options);
        }
export type GetParentPermissionsQueryHookResult = ReturnType<typeof useGetParentPermissionsQuery>;
export type GetParentPermissionsLazyQueryHookResult = ReturnType<typeof useGetParentPermissionsLazyQuery>;
export type GetParentPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetParentPermissionsSuspenseQuery>;
export type GetParentPermissionsQueryResult = Apollo.QueryResult<GetParentPermissionsQuery, GetParentPermissionsQueryVariables>;
export const GetResourceDownloadUrlDocument = gql`
    query GetResourceDownloadUrl($workspaceId: ID!, $resourceId: ID!) {
  resourceDownloadUrl(workspaceId: $workspaceId, resourceId: $resourceId)
}
    `;

/**
 * __useGetResourceDownloadUrlQuery__
 *
 * To run a query within a React component, call `useGetResourceDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceDownloadUrlQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useGetResourceDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetResourceDownloadUrlQuery, GetResourceDownloadUrlQueryVariables> & ({ variables: GetResourceDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourceDownloadUrlQuery, GetResourceDownloadUrlQueryVariables>(GetResourceDownloadUrlDocument, options);
      }
export function useGetResourceDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourceDownloadUrlQuery, GetResourceDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourceDownloadUrlQuery, GetResourceDownloadUrlQueryVariables>(GetResourceDownloadUrlDocument, options);
        }
// @ts-ignore
export function useGetResourceDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetResourceDownloadUrlQuery, GetResourceDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourceDownloadUrlQuery, GetResourceDownloadUrlQueryVariables>;
export function useGetResourceDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourceDownloadUrlQuery, GetResourceDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourceDownloadUrlQuery | undefined, GetResourceDownloadUrlQueryVariables>;
export function useGetResourceDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourceDownloadUrlQuery, GetResourceDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResourceDownloadUrlQuery, GetResourceDownloadUrlQueryVariables>(GetResourceDownloadUrlDocument, options);
        }
export type GetResourceDownloadUrlQueryHookResult = ReturnType<typeof useGetResourceDownloadUrlQuery>;
export type GetResourceDownloadUrlLazyQueryHookResult = ReturnType<typeof useGetResourceDownloadUrlLazyQuery>;
export type GetResourceDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useGetResourceDownloadUrlSuspenseQuery>;
export type GetResourceDownloadUrlQueryResult = Apollo.QueryResult<GetResourceDownloadUrlQuery, GetResourceDownloadUrlQueryVariables>;
export const GetResourcePathDocument = gql`
    query getResourcePath($workspaceId: ID!, $resourceId: ID!) {
  resource(workspaceId: $workspaceId, id: $resourceId) {
    id
    name
    path {
      id
      name
    }
  }
}
    `;

/**
 * __useGetResourcePathQuery__
 *
 * To run a query within a React component, call `useGetResourcePathQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcePathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcePathQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useGetResourcePathQuery(baseOptions: Apollo.QueryHookOptions<GetResourcePathQuery, GetResourcePathQueryVariables> & ({ variables: GetResourcePathQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourcePathQuery, GetResourcePathQueryVariables>(GetResourcePathDocument, options);
      }
export function useGetResourcePathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourcePathQuery, GetResourcePathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourcePathQuery, GetResourcePathQueryVariables>(GetResourcePathDocument, options);
        }
// @ts-ignore
export function useGetResourcePathSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetResourcePathQuery, GetResourcePathQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourcePathQuery, GetResourcePathQueryVariables>;
export function useGetResourcePathSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourcePathQuery, GetResourcePathQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourcePathQuery | undefined, GetResourcePathQueryVariables>;
export function useGetResourcePathSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourcePathQuery, GetResourcePathQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResourcePathQuery, GetResourcePathQueryVariables>(GetResourcePathDocument, options);
        }
export type GetResourcePathQueryHookResult = ReturnType<typeof useGetResourcePathQuery>;
export type GetResourcePathLazyQueryHookResult = ReturnType<typeof useGetResourcePathLazyQuery>;
export type GetResourcePathSuspenseQueryHookResult = ReturnType<typeof useGetResourcePathSuspenseQuery>;
export type GetResourcePathQueryResult = Apollo.QueryResult<GetResourcePathQuery, GetResourcePathQueryVariables>;
export const GetResourceRedactedUrlDocument = gql`
    query GetResourceRedactedUrl($workspaceId: ID!, $resourceId: ID!) {
  resourceRedactedUrl(workspaceId: $workspaceId, resourceId: $resourceId)
}
    `;

/**
 * __useGetResourceRedactedUrlQuery__
 *
 * To run a query within a React component, call `useGetResourceRedactedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceRedactedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceRedactedUrlQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useGetResourceRedactedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetResourceRedactedUrlQuery, GetResourceRedactedUrlQueryVariables> & ({ variables: GetResourceRedactedUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourceRedactedUrlQuery, GetResourceRedactedUrlQueryVariables>(GetResourceRedactedUrlDocument, options);
      }
export function useGetResourceRedactedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourceRedactedUrlQuery, GetResourceRedactedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourceRedactedUrlQuery, GetResourceRedactedUrlQueryVariables>(GetResourceRedactedUrlDocument, options);
        }
// @ts-ignore
export function useGetResourceRedactedUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetResourceRedactedUrlQuery, GetResourceRedactedUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourceRedactedUrlQuery, GetResourceRedactedUrlQueryVariables>;
export function useGetResourceRedactedUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourceRedactedUrlQuery, GetResourceRedactedUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourceRedactedUrlQuery | undefined, GetResourceRedactedUrlQueryVariables>;
export function useGetResourceRedactedUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourceRedactedUrlQuery, GetResourceRedactedUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResourceRedactedUrlQuery, GetResourceRedactedUrlQueryVariables>(GetResourceRedactedUrlDocument, options);
        }
export type GetResourceRedactedUrlQueryHookResult = ReturnType<typeof useGetResourceRedactedUrlQuery>;
export type GetResourceRedactedUrlLazyQueryHookResult = ReturnType<typeof useGetResourceRedactedUrlLazyQuery>;
export type GetResourceRedactedUrlSuspenseQueryHookResult = ReturnType<typeof useGetResourceRedactedUrlSuspenseQuery>;
export type GetResourceRedactedUrlQueryResult = Apollo.QueryResult<GetResourceRedactedUrlQuery, GetResourceRedactedUrlQueryVariables>;
export const GetResourcesAccessDocument = gql`
    query GetResourcesAccess($filter: ResourceArgsFilter!, $sorter: ResourceArgsSorter, $limit: Int, $offset: Int) {
  resources(filter: $filter, sorter: $sorter, limit: $limit, offset: $offset) {
    nodes {
      id
      name
      type
      resourceAccess {
        id
        permissions
        groupId
        resourceId
      }
    }
  }
}
    `;

/**
 * __useGetResourcesAccessQuery__
 *
 * To run a query within a React component, call `useGetResourcesAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcesAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcesAccessQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetResourcesAccessQuery(baseOptions: Apollo.QueryHookOptions<GetResourcesAccessQuery, GetResourcesAccessQueryVariables> & ({ variables: GetResourcesAccessQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourcesAccessQuery, GetResourcesAccessQueryVariables>(GetResourcesAccessDocument, options);
      }
export function useGetResourcesAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourcesAccessQuery, GetResourcesAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourcesAccessQuery, GetResourcesAccessQueryVariables>(GetResourcesAccessDocument, options);
        }
// @ts-ignore
export function useGetResourcesAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetResourcesAccessQuery, GetResourcesAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourcesAccessQuery, GetResourcesAccessQueryVariables>;
export function useGetResourcesAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourcesAccessQuery, GetResourcesAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourcesAccessQuery | undefined, GetResourcesAccessQueryVariables>;
export function useGetResourcesAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourcesAccessQuery, GetResourcesAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResourcesAccessQuery, GetResourcesAccessQueryVariables>(GetResourcesAccessDocument, options);
        }
export type GetResourcesAccessQueryHookResult = ReturnType<typeof useGetResourcesAccessQuery>;
export type GetResourcesAccessLazyQueryHookResult = ReturnType<typeof useGetResourcesAccessLazyQuery>;
export type GetResourcesAccessSuspenseQueryHookResult = ReturnType<typeof useGetResourcesAccessSuspenseQuery>;
export type GetResourcesAccessQueryResult = Apollo.QueryResult<GetResourcesAccessQuery, GetResourcesAccessQueryVariables>;
export const GetResourcesSearchDocument = gql`
    query GetResourcesSearch($filter: ResourceArgsFilter!, $sorter: ResourceArgsSorter, $limit: Int, $offset: Int) {
  resources(filter: $filter, sorter: $sorter, limit: $limit, offset: $offset) {
    nodes {
      ...ResourceSearchItem
    }
    pageInfo {
      offset
      totalCount
    }
  }
}
    ${ResourceSearchItemFragmentDoc}`;

/**
 * __useGetResourcesSearchQuery__
 *
 * To run a query within a React component, call `useGetResourcesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourcesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourcesSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetResourcesSearchQuery(baseOptions: Apollo.QueryHookOptions<GetResourcesSearchQuery, GetResourcesSearchQueryVariables> & ({ variables: GetResourcesSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResourcesSearchQuery, GetResourcesSearchQueryVariables>(GetResourcesSearchDocument, options);
      }
export function useGetResourcesSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourcesSearchQuery, GetResourcesSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResourcesSearchQuery, GetResourcesSearchQueryVariables>(GetResourcesSearchDocument, options);
        }
// @ts-ignore
export function useGetResourcesSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetResourcesSearchQuery, GetResourcesSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourcesSearchQuery, GetResourcesSearchQueryVariables>;
export function useGetResourcesSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourcesSearchQuery, GetResourcesSearchQueryVariables>): Apollo.UseSuspenseQueryResult<GetResourcesSearchQuery | undefined, GetResourcesSearchQueryVariables>;
export function useGetResourcesSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResourcesSearchQuery, GetResourcesSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResourcesSearchQuery, GetResourcesSearchQueryVariables>(GetResourcesSearchDocument, options);
        }
export type GetResourcesSearchQueryHookResult = ReturnType<typeof useGetResourcesSearchQuery>;
export type GetResourcesSearchLazyQueryHookResult = ReturnType<typeof useGetResourcesSearchLazyQuery>;
export type GetResourcesSearchSuspenseQueryHookResult = ReturnType<typeof useGetResourcesSearchSuspenseQuery>;
export type GetResourcesSearchQueryResult = Apollo.QueryResult<GetResourcesSearchQuery, GetResourcesSearchQueryVariables>;
export const GetUploadSignedUrlDocument = gql`
    query GetUploadSignedUrl($fileKey: String!) {
  resourceUploadSignedUrl(fileKey: $fileKey)
}
    `;

/**
 * __useGetUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadSignedUrlQuery({
 *   variables: {
 *      fileKey: // value for 'fileKey'
 *   },
 * });
 */
export function useGetUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetUploadSignedUrlQuery, GetUploadSignedUrlQueryVariables> & ({ variables: GetUploadSignedUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadSignedUrlQuery, GetUploadSignedUrlQueryVariables>(GetUploadSignedUrlDocument, options);
      }
export function useGetUploadSignedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadSignedUrlQuery, GetUploadSignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadSignedUrlQuery, GetUploadSignedUrlQueryVariables>(GetUploadSignedUrlDocument, options);
        }
// @ts-ignore
export function useGetUploadSignedUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlQuery, GetUploadSignedUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadSignedUrlQuery, GetUploadSignedUrlQueryVariables>;
export function useGetUploadSignedUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlQuery, GetUploadSignedUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetUploadSignedUrlQuery | undefined, GetUploadSignedUrlQueryVariables>;
export function useGetUploadSignedUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadSignedUrlQuery, GetUploadSignedUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadSignedUrlQuery, GetUploadSignedUrlQueryVariables>(GetUploadSignedUrlDocument, options);
        }
export type GetUploadSignedUrlQueryHookResult = ReturnType<typeof useGetUploadSignedUrlQuery>;
export type GetUploadSignedUrlLazyQueryHookResult = ReturnType<typeof useGetUploadSignedUrlLazyQuery>;
export type GetUploadSignedUrlSuspenseQueryHookResult = ReturnType<typeof useGetUploadSignedUrlSuspenseQuery>;
export type GetUploadSignedUrlQueryResult = Apollo.QueryResult<GetUploadSignedUrlQuery, GetUploadSignedUrlQueryVariables>;
export const InitializeMultipartUploadDocument = gql`
    mutation InitializeMultipartUpload($fileKey: String!) {
  initializeMultipartUpload(fileKey: $fileKey) {
    uploadId
    fileKey
  }
}
    `;
export type InitializeMultipartUploadMutationFn = Apollo.MutationFunction<InitializeMultipartUploadMutation, InitializeMultipartUploadMutationVariables>;

/**
 * __useInitializeMultipartUploadMutation__
 *
 * To run a mutation, you first call `useInitializeMultipartUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeMultipartUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeMultipartUploadMutation, { data, loading, error }] = useInitializeMultipartUploadMutation({
 *   variables: {
 *      fileKey: // value for 'fileKey'
 *   },
 * });
 */
export function useInitializeMultipartUploadMutation(baseOptions?: Apollo.MutationHookOptions<InitializeMultipartUploadMutation, InitializeMultipartUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitializeMultipartUploadMutation, InitializeMultipartUploadMutationVariables>(InitializeMultipartUploadDocument, options);
      }
export type InitializeMultipartUploadMutationHookResult = ReturnType<typeof useInitializeMultipartUploadMutation>;
export type InitializeMultipartUploadMutationResult = Apollo.MutationResult<InitializeMultipartUploadMutation>;
export type InitializeMultipartUploadMutationOptions = Apollo.BaseMutationOptions<InitializeMultipartUploadMutation, InitializeMultipartUploadMutationVariables>;
export const ListResourceQuestionsDocument = gql`
    query ListResourceQuestions($filter: QuestionArgsFilter!, $limit: Int, $offset: Int, $sorter: QuestionArgSorter) {
  questions(filter: $filter, limit: $limit, offset: $offset, sorter: $sorter) {
    nodes {
      id
      title
      priority
      createdBy {
        id
        email
        firstName
        lastName
        pictureURL
      }
      createdAt
      archivedAt
    }
  }
}
    `;

/**
 * __useListResourceQuestionsQuery__
 *
 * To run a query within a React component, call `useListResourceQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListResourceQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListResourceQuestionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useListResourceQuestionsQuery(baseOptions: Apollo.QueryHookOptions<ListResourceQuestionsQuery, ListResourceQuestionsQueryVariables> & ({ variables: ListResourceQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListResourceQuestionsQuery, ListResourceQuestionsQueryVariables>(ListResourceQuestionsDocument, options);
      }
export function useListResourceQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListResourceQuestionsQuery, ListResourceQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListResourceQuestionsQuery, ListResourceQuestionsQueryVariables>(ListResourceQuestionsDocument, options);
        }
// @ts-ignore
export function useListResourceQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListResourceQuestionsQuery, ListResourceQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListResourceQuestionsQuery, ListResourceQuestionsQueryVariables>;
export function useListResourceQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListResourceQuestionsQuery, ListResourceQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListResourceQuestionsQuery | undefined, ListResourceQuestionsQueryVariables>;
export function useListResourceQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListResourceQuestionsQuery, ListResourceQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListResourceQuestionsQuery, ListResourceQuestionsQueryVariables>(ListResourceQuestionsDocument, options);
        }
export type ListResourceQuestionsQueryHookResult = ReturnType<typeof useListResourceQuestionsQuery>;
export type ListResourceQuestionsLazyQueryHookResult = ReturnType<typeof useListResourceQuestionsLazyQuery>;
export type ListResourceQuestionsSuspenseQueryHookResult = ReturnType<typeof useListResourceQuestionsSuspenseQuery>;
export type ListResourceQuestionsQueryResult = Apollo.QueryResult<ListResourceQuestionsQuery, ListResourceQuestionsQueryVariables>;
export const ListResourcesDocument = gql`
    query ListResources($filter: ResourceArgsFilter!, $sorter: ResourceArgsSorter, $limit: Int, $offset: Int) {
  resources(filter: $filter, sorter: $sorter, limit: $limit, offset: $offset) {
    nodes {
      ...ResourceRowFragment
    }
    pageInfo {
      offset
      totalCount
    }
  }
}
    ${ResourceRowFragmentFragmentDoc}`;

/**
 * __useListResourcesQuery__
 *
 * To run a query within a React component, call `useListResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListResourcesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useListResourcesQuery(baseOptions: Apollo.QueryHookOptions<ListResourcesQuery, ListResourcesQueryVariables> & ({ variables: ListResourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListResourcesQuery, ListResourcesQueryVariables>(ListResourcesDocument, options);
      }
export function useListResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListResourcesQuery, ListResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListResourcesQuery, ListResourcesQueryVariables>(ListResourcesDocument, options);
        }
// @ts-ignore
export function useListResourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListResourcesQuery, ListResourcesQueryVariables>): Apollo.UseSuspenseQueryResult<ListResourcesQuery, ListResourcesQueryVariables>;
export function useListResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListResourcesQuery, ListResourcesQueryVariables>): Apollo.UseSuspenseQueryResult<ListResourcesQuery | undefined, ListResourcesQueryVariables>;
export function useListResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListResourcesQuery, ListResourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListResourcesQuery, ListResourcesQueryVariables>(ListResourcesDocument, options);
        }
export type ListResourcesQueryHookResult = ReturnType<typeof useListResourcesQuery>;
export type ListResourcesLazyQueryHookResult = ReturnType<typeof useListResourcesLazyQuery>;
export type ListResourcesSuspenseQueryHookResult = ReturnType<typeof useListResourcesSuspenseQuery>;
export type ListResourcesQueryResult = Apollo.QueryResult<ListResourcesQuery, ListResourcesQueryVariables>;
export const ManualRedactDocument = gql`
    mutation ManualRedact($manualRedactInput: ManualRedactInput!) {
  manualRedact(manualRedactInput: $manualRedactInput)
}
    `;
export type ManualRedactMutationFn = Apollo.MutationFunction<ManualRedactMutation, ManualRedactMutationVariables>;

/**
 * __useManualRedactMutation__
 *
 * To run a mutation, you first call `useManualRedactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManualRedactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manualRedactMutation, { data, loading, error }] = useManualRedactMutation({
 *   variables: {
 *      manualRedactInput: // value for 'manualRedactInput'
 *   },
 * });
 */
export function useManualRedactMutation(baseOptions?: Apollo.MutationHookOptions<ManualRedactMutation, ManualRedactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManualRedactMutation, ManualRedactMutationVariables>(ManualRedactDocument, options);
      }
export type ManualRedactMutationHookResult = ReturnType<typeof useManualRedactMutation>;
export type ManualRedactMutationResult = Apollo.MutationResult<ManualRedactMutation>;
export type ManualRedactMutationOptions = Apollo.BaseMutationOptions<ManualRedactMutation, ManualRedactMutationVariables>;
export const RemoveRedactionsDocument = gql`
    mutation RemoveRedactions($redactionIds: [ID!]!, $workspaceId: ID!) {
  removeRedactions(redactionIds: $redactionIds, workspaceId: $workspaceId) {
    id
    redactions {
      id
      status
    }
  }
}
    `;
export type RemoveRedactionsMutationFn = Apollo.MutationFunction<RemoveRedactionsMutation, RemoveRedactionsMutationVariables>;

/**
 * __useRemoveRedactionsMutation__
 *
 * To run a mutation, you first call `useRemoveRedactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRedactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRedactionsMutation, { data, loading, error }] = useRemoveRedactionsMutation({
 *   variables: {
 *      redactionIds: // value for 'redactionIds'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useRemoveRedactionsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRedactionsMutation, RemoveRedactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRedactionsMutation, RemoveRedactionsMutationVariables>(RemoveRedactionsDocument, options);
      }
export type RemoveRedactionsMutationHookResult = ReturnType<typeof useRemoveRedactionsMutation>;
export type RemoveRedactionsMutationResult = Apollo.MutationResult<RemoveRedactionsMutation>;
export type RemoveRedactionsMutationOptions = Apollo.BaseMutationOptions<RemoveRedactionsMutation, RemoveRedactionsMutationVariables>;
export const RemoveResourcesDocument = gql`
    mutation RemoveResources($workspaceId: ID!, $resourceIds: [ID!], $deleteAction: DeleteAction!, $selectAll: Boolean, $parentId: ID) {
  removeResources(
    resourceIds: $resourceIds
    deleteAction: $deleteAction
    workspaceId: $workspaceId
    selectAll: $selectAll
    parentId: $parentId
  )
}
    `;
export type RemoveResourcesMutationFn = Apollo.MutationFunction<RemoveResourcesMutation, RemoveResourcesMutationVariables>;

/**
 * __useRemoveResourcesMutation__
 *
 * To run a mutation, you first call `useRemoveResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeResourcesMutation, { data, loading, error }] = useRemoveResourcesMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      resourceIds: // value for 'resourceIds'
 *      deleteAction: // value for 'deleteAction'
 *      selectAll: // value for 'selectAll'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useRemoveResourcesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveResourcesMutation, RemoveResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveResourcesMutation, RemoveResourcesMutationVariables>(RemoveResourcesDocument, options);
      }
export type RemoveResourcesMutationHookResult = ReturnType<typeof useRemoveResourcesMutation>;
export type RemoveResourcesMutationResult = Apollo.MutationResult<RemoveResourcesMutation>;
export type RemoveResourcesMutationOptions = Apollo.BaseMutationOptions<RemoveResourcesMutation, RemoveResourcesMutationVariables>;
export const ReprocessResourcesDocument = gql`
    mutation ReprocessResources($resourceIds: [ID!]!) {
  reprocessResources(resourceIds: $resourceIds)
}
    `;
export type ReprocessResourcesMutationFn = Apollo.MutationFunction<ReprocessResourcesMutation, ReprocessResourcesMutationVariables>;

/**
 * __useReprocessResourcesMutation__
 *
 * To run a mutation, you first call `useReprocessResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprocessResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprocessResourcesMutation, { data, loading, error }] = useReprocessResourcesMutation({
 *   variables: {
 *      resourceIds: // value for 'resourceIds'
 *   },
 * });
 */
export function useReprocessResourcesMutation(baseOptions?: Apollo.MutationHookOptions<ReprocessResourcesMutation, ReprocessResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReprocessResourcesMutation, ReprocessResourcesMutationVariables>(ReprocessResourcesDocument, options);
      }
export type ReprocessResourcesMutationHookResult = ReturnType<typeof useReprocessResourcesMutation>;
export type ReprocessResourcesMutationResult = Apollo.MutationResult<ReprocessResourcesMutation>;
export type ReprocessResourcesMutationOptions = Apollo.BaseMutationOptions<ReprocessResourcesMutation, ReprocessResourcesMutationVariables>;
export const ResourcesIndexViewDocument = gql`
    query ResourcesIndexView($filter: ResourceArgsFilter!, $sorter: ResourceArgsSorter) {
  resourcesIndexView(filter: $filter, sorter: $sorter) {
    id
    name
    index
    rank
    size
    type
    pspdfKitId
    parentId
    mimeType
    createdAt
    workspaceId
  }
}
    `;

/**
 * __useResourcesIndexViewQuery__
 *
 * To run a query within a React component, call `useResourcesIndexViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesIndexViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesIndexViewQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useResourcesIndexViewQuery(baseOptions: Apollo.QueryHookOptions<ResourcesIndexViewQuery, ResourcesIndexViewQueryVariables> & ({ variables: ResourcesIndexViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcesIndexViewQuery, ResourcesIndexViewQueryVariables>(ResourcesIndexViewDocument, options);
      }
export function useResourcesIndexViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesIndexViewQuery, ResourcesIndexViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcesIndexViewQuery, ResourcesIndexViewQueryVariables>(ResourcesIndexViewDocument, options);
        }
// @ts-ignore
export function useResourcesIndexViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResourcesIndexViewQuery, ResourcesIndexViewQueryVariables>): Apollo.UseSuspenseQueryResult<ResourcesIndexViewQuery, ResourcesIndexViewQueryVariables>;
export function useResourcesIndexViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResourcesIndexViewQuery, ResourcesIndexViewQueryVariables>): Apollo.UseSuspenseQueryResult<ResourcesIndexViewQuery | undefined, ResourcesIndexViewQueryVariables>;
export function useResourcesIndexViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResourcesIndexViewQuery, ResourcesIndexViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResourcesIndexViewQuery, ResourcesIndexViewQueryVariables>(ResourcesIndexViewDocument, options);
        }
export type ResourcesIndexViewQueryHookResult = ReturnType<typeof useResourcesIndexViewQuery>;
export type ResourcesIndexViewLazyQueryHookResult = ReturnType<typeof useResourcesIndexViewLazyQuery>;
export type ResourcesIndexViewSuspenseQueryHookResult = ReturnType<typeof useResourcesIndexViewSuspenseQuery>;
export type ResourcesIndexViewQueryResult = Apollo.QueryResult<ResourcesIndexViewQuery, ResourcesIndexViewQueryVariables>;
export const RestoreResourcesDocument = gql`
    mutation RestoreResources($workspaceId: ID!, $resourceIds: [ID!], $selectAll: Boolean, $from: DateTime) {
  restoreResources(
    workspaceId: $workspaceId
    resourceIds: $resourceIds
    selectAll: $selectAll
    from: $from
  )
}
    `;
export type RestoreResourcesMutationFn = Apollo.MutationFunction<RestoreResourcesMutation, RestoreResourcesMutationVariables>;

/**
 * __useRestoreResourcesMutation__
 *
 * To run a mutation, you first call `useRestoreResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreResourcesMutation, { data, loading, error }] = useRestoreResourcesMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      resourceIds: // value for 'resourceIds'
 *      selectAll: // value for 'selectAll'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useRestoreResourcesMutation(baseOptions?: Apollo.MutationHookOptions<RestoreResourcesMutation, RestoreResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreResourcesMutation, RestoreResourcesMutationVariables>(RestoreResourcesDocument, options);
      }
export type RestoreResourcesMutationHookResult = ReturnType<typeof useRestoreResourcesMutation>;
export type RestoreResourcesMutationResult = Apollo.MutationResult<RestoreResourcesMutation>;
export type RestoreResourcesMutationOptions = Apollo.BaseMutationOptions<RestoreResourcesMutation, RestoreResourcesMutationVariables>;
export const SuggestRenameDocument = gql`
    mutation SuggestRename($suggestRenameInput: SuggestRenameInput!) {
  suggestRename(suggestRenameInput: $suggestRenameInput)
}
    `;
export type SuggestRenameMutationFn = Apollo.MutationFunction<SuggestRenameMutation, SuggestRenameMutationVariables>;

/**
 * __useSuggestRenameMutation__
 *
 * To run a mutation, you first call `useSuggestRenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestRenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestRenameMutation, { data, loading, error }] = useSuggestRenameMutation({
 *   variables: {
 *      suggestRenameInput: // value for 'suggestRenameInput'
 *   },
 * });
 */
export function useSuggestRenameMutation(baseOptions?: Apollo.MutationHookOptions<SuggestRenameMutation, SuggestRenameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuggestRenameMutation, SuggestRenameMutationVariables>(SuggestRenameDocument, options);
      }
export type SuggestRenameMutationHookResult = ReturnType<typeof useSuggestRenameMutation>;
export type SuggestRenameMutationResult = Apollo.MutationResult<SuggestRenameMutation>;
export type SuggestRenameMutationOptions = Apollo.BaseMutationOptions<SuggestRenameMutation, SuggestRenameMutationVariables>;
export const UpdateFavoriteResourcesDocument = gql`
    mutation UpdateFavoriteResources($updateFavoriteResourcesInput: UpdateFavoriteResourcesInput!) {
  updateFavoriteResources(
    updateFavoriteResourcesInput: $updateFavoriteResourcesInput
  ) {
    id
    name
    isFavorite
    updatedAt
  }
}
    `;
export type UpdateFavoriteResourcesMutationFn = Apollo.MutationFunction<UpdateFavoriteResourcesMutation, UpdateFavoriteResourcesMutationVariables>;

/**
 * __useUpdateFavoriteResourcesMutation__
 *
 * To run a mutation, you first call `useUpdateFavoriteResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFavoriteResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavoriteResourcesMutation, { data, loading, error }] = useUpdateFavoriteResourcesMutation({
 *   variables: {
 *      updateFavoriteResourcesInput: // value for 'updateFavoriteResourcesInput'
 *   },
 * });
 */
export function useUpdateFavoriteResourcesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFavoriteResourcesMutation, UpdateFavoriteResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFavoriteResourcesMutation, UpdateFavoriteResourcesMutationVariables>(UpdateFavoriteResourcesDocument, options);
      }
export type UpdateFavoriteResourcesMutationHookResult = ReturnType<typeof useUpdateFavoriteResourcesMutation>;
export type UpdateFavoriteResourcesMutationResult = Apollo.MutationResult<UpdateFavoriteResourcesMutation>;
export type UpdateFavoriteResourcesMutationOptions = Apollo.BaseMutationOptions<UpdateFavoriteResourcesMutation, UpdateFavoriteResourcesMutationVariables>;
export const UpdateResourceDocument = gql`
    mutation UpdateResource($updateResourceInput: UpdateResourceInput!) {
  updateResource(updateResourceInput: $updateResourceInput) {
    id
    name
    isFavorite
    updatedAt
  }
}
    `;
export type UpdateResourceMutationFn = Apollo.MutationFunction<UpdateResourceMutation, UpdateResourceMutationVariables>;

/**
 * __useUpdateResourceMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMutation, { data, loading, error }] = useUpdateResourceMutation({
 *   variables: {
 *      updateResourceInput: // value for 'updateResourceInput'
 *   },
 * });
 */
export function useUpdateResourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResourceMutation, UpdateResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResourceMutation, UpdateResourceMutationVariables>(UpdateResourceDocument, options);
      }
export type UpdateResourceMutationHookResult = ReturnType<typeof useUpdateResourceMutation>;
export type UpdateResourceMutationResult = Apollo.MutationResult<UpdateResourceMutation>;
export type UpdateResourceMutationOptions = Apollo.BaseMutationOptions<UpdateResourceMutation, UpdateResourceMutationVariables>;
export const ZipFilesAndSendByEmailDocument = gql`
    mutation ZipFilesAndSendByEmail($workspaceId: ID!, $resourceIds: [ID!]!, $selectAll: Boolean, $parentId: ID, $permission: Permission) {
  zipFilesAndSendByEmail(
    workspaceId: $workspaceId
    resourceIds: $resourceIds
    selectAll: $selectAll
    parentId: $parentId
    permission: $permission
  )
}
    `;
export type ZipFilesAndSendByEmailMutationFn = Apollo.MutationFunction<ZipFilesAndSendByEmailMutation, ZipFilesAndSendByEmailMutationVariables>;

/**
 * __useZipFilesAndSendByEmailMutation__
 *
 * To run a mutation, you first call `useZipFilesAndSendByEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZipFilesAndSendByEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zipFilesAndSendByEmailMutation, { data, loading, error }] = useZipFilesAndSendByEmailMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      resourceIds: // value for 'resourceIds'
 *      selectAll: // value for 'selectAll'
 *      parentId: // value for 'parentId'
 *      permission: // value for 'permission'
 *   },
 * });
 */
export function useZipFilesAndSendByEmailMutation(baseOptions?: Apollo.MutationHookOptions<ZipFilesAndSendByEmailMutation, ZipFilesAndSendByEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ZipFilesAndSendByEmailMutation, ZipFilesAndSendByEmailMutationVariables>(ZipFilesAndSendByEmailDocument, options);
      }
export type ZipFilesAndSendByEmailMutationHookResult = ReturnType<typeof useZipFilesAndSendByEmailMutation>;
export type ZipFilesAndSendByEmailMutationResult = Apollo.MutationResult<ZipFilesAndSendByEmailMutation>;
export type ZipFilesAndSendByEmailMutationOptions = Apollo.BaseMutationOptions<ZipFilesAndSendByEmailMutation, ZipFilesAndSendByEmailMutationVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($createRoleInput: CreateRoleInput!) {
  createRole(createRoleInput: $createRoleInput) {
    ...Role
  }
}
    ${RoleFragmentDoc}`;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      createRoleInput: // value for 'createRoleInput'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation DeleteRole($roleId: ID!) {
  deleteRole(roleId: $roleId)
}
    `;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const GetRolesDocument = gql`
    query GetRoles($workspaceId: ID!) {
  roles(workspaceId: $workspaceId) {
    ...Role
  }
}
    ${RoleFragmentDoc}`;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables> & ({ variables: GetRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
// @ts-ignore
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRolesQuery, GetRolesQueryVariables>;
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRolesQuery | undefined, GetRolesQueryVariables>;
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesSuspenseQueryHookResult = ReturnType<typeof useGetRolesSuspenseQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($updateRoleInput: UpdateRoleInput!) {
  updateRole(updateRoleInput: $updateRoleInput) {
    ...Role
  }
}
    ${RoleFragmentDoc}`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      updateRoleInput: // value for 'updateRoleInput'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const SearchDocument = gql`
    query Search($filter: SearchArgsFilter!, $query: String!, $limit: Int, $offset: Int) {
  search(filter: $filter, query: $query, limit: $limit, offset: $offset) {
    ...SearchResult
  }
}
    ${SearchResultFragmentDoc}`;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables> & ({ variables: SearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
// @ts-ignore
export function useSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuery, SearchQueryVariables>;
export function useSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>): Apollo.UseSuspenseQueryResult<SearchQuery | undefined, SearchQueryVariables>;
export function useSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchSuspenseQueryHookResult = ReturnType<typeof useSearchSuspenseQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const TrackSearchDocument = gql`
    mutation TrackSearch($input: TrackSearchInput!) {
  trackSearch(input: $input)
}
    `;
export type TrackSearchMutationFn = Apollo.MutationFunction<TrackSearchMutation, TrackSearchMutationVariables>;

/**
 * __useTrackSearchMutation__
 *
 * To run a mutation, you first call `useTrackSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackSearchMutation, { data, loading, error }] = useTrackSearchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrackSearchMutation(baseOptions?: Apollo.MutationHookOptions<TrackSearchMutation, TrackSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackSearchMutation, TrackSearchMutationVariables>(TrackSearchDocument, options);
      }
export type TrackSearchMutationHookResult = ReturnType<typeof useTrackSearchMutation>;
export type TrackSearchMutationResult = Apollo.MutationResult<TrackSearchMutation>;
export type TrackSearchMutationOptions = Apollo.BaseMutationOptions<TrackSearchMutation, TrackSearchMutationVariables>;
export const AssignOwnerToQuestionDocument = gql`
    mutation AssignOwnerToQuestion($assignOwnerInput: AssignOwnerInput!) {
  assignOwnerToQuestion(assignOwnerInput: $assignOwnerInput) {
    id
    owners {
      id
      email
      firstName
      lastName
      pictureURL
    }
  }
}
    `;
export type AssignOwnerToQuestionMutationFn = Apollo.MutationFunction<AssignOwnerToQuestionMutation, AssignOwnerToQuestionMutationVariables>;

/**
 * __useAssignOwnerToQuestionMutation__
 *
 * To run a mutation, you first call `useAssignOwnerToQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignOwnerToQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignOwnerToQuestionMutation, { data, loading, error }] = useAssignOwnerToQuestionMutation({
 *   variables: {
 *      assignOwnerInput: // value for 'assignOwnerInput'
 *   },
 * });
 */
export function useAssignOwnerToQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AssignOwnerToQuestionMutation, AssignOwnerToQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignOwnerToQuestionMutation, AssignOwnerToQuestionMutationVariables>(AssignOwnerToQuestionDocument, options);
      }
export type AssignOwnerToQuestionMutationHookResult = ReturnType<typeof useAssignOwnerToQuestionMutation>;
export type AssignOwnerToQuestionMutationResult = Apollo.MutationResult<AssignOwnerToQuestionMutation>;
export type AssignOwnerToQuestionMutationOptions = Apollo.BaseMutationOptions<AssignOwnerToQuestionMutation, AssignOwnerToQuestionMutationVariables>;
export const ConfirmAnswerDocument = gql`
    mutation ConfirmAnswer($confirmAnswerInput: ConfirmAnswerInput!) {
  confirmAnswer(confirmAnswerInput: $confirmAnswerInput) {
    id
  }
}
    `;
export type ConfirmAnswerMutationFn = Apollo.MutationFunction<ConfirmAnswerMutation, ConfirmAnswerMutationVariables>;

/**
 * __useConfirmAnswerMutation__
 *
 * To run a mutation, you first call `useConfirmAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAnswerMutation, { data, loading, error }] = useConfirmAnswerMutation({
 *   variables: {
 *      confirmAnswerInput: // value for 'confirmAnswerInput'
 *   },
 * });
 */
export function useConfirmAnswerMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmAnswerMutation, ConfirmAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmAnswerMutation, ConfirmAnswerMutationVariables>(ConfirmAnswerDocument, options);
      }
export type ConfirmAnswerMutationHookResult = ReturnType<typeof useConfirmAnswerMutation>;
export type ConfirmAnswerMutationResult = Apollo.MutationResult<ConfirmAnswerMutation>;
export type ConfirmAnswerMutationOptions = Apollo.BaseMutationOptions<ConfirmAnswerMutation, ConfirmAnswerMutationVariables>;
export const CreateQuestionDocument = gql`
    mutation CreateQuestion($createQuestionInput: CreateQuestionInput!) {
  createQuestion(createQuestionInput: $createQuestionInput) {
    id
    publicId
    title
    priority
    resolutionStatus
    isAnswered
    answersCount
    resources {
      id
      name
      type
      mimeType
    }
    createdBy {
      id
      email
      firstName
      lastName
      pictureURL
    }
    owners {
      id
      email
      firstName
      lastName
      pictureURL
    }
    groups {
      id
      name
      color
    }
    latestAnswer {
      id
      description
    }
    createdAt
    updatedAt
    archivedAt
  }
}
    `;
export type CreateQuestionMutationFn = Apollo.MutationFunction<CreateQuestionMutation, CreateQuestionMutationVariables>;

/**
 * __useCreateQuestionMutation__
 *
 * To run a mutation, you first call `useCreateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionMutation, { data, loading, error }] = useCreateQuestionMutation({
 *   variables: {
 *      createQuestionInput: // value for 'createQuestionInput'
 *   },
 * });
 */
export function useCreateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionMutation, CreateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionMutation, CreateQuestionMutationVariables>(CreateQuestionDocument, options);
      }
export type CreateQuestionMutationHookResult = ReturnType<typeof useCreateQuestionMutation>;
export type CreateQuestionMutationResult = Apollo.MutationResult<CreateQuestionMutation>;
export type CreateQuestionMutationOptions = Apollo.BaseMutationOptions<CreateQuestionMutation, CreateQuestionMutationVariables>;
export const CreateTopicDocument = gql`
    mutation CreateTopic($input: CreateTopicInput!) {
  createTopic(input: $input) {
    id
    name
  }
}
    `;
export type CreateTopicMutationFn = Apollo.MutationFunction<CreateTopicMutation, CreateTopicMutationVariables>;

/**
 * __useCreateTopicMutation__
 *
 * To run a mutation, you first call `useCreateTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTopicMutation, { data, loading, error }] = useCreateTopicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTopicMutation(baseOptions?: Apollo.MutationHookOptions<CreateTopicMutation, CreateTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTopicMutation, CreateTopicMutationVariables>(CreateTopicDocument, options);
      }
export type CreateTopicMutationHookResult = ReturnType<typeof useCreateTopicMutation>;
export type CreateTopicMutationResult = Apollo.MutationResult<CreateTopicMutation>;
export type CreateTopicMutationOptions = Apollo.BaseMutationOptions<CreateTopicMutation, CreateTopicMutationVariables>;
export const DeleteAnswersDocument = gql`
    mutation DeleteAnswers($deleteAnswersInput: DeleteAnswersInput!) {
  deleteAnswers(deleteAnswersInput: $deleteAnswersInput) {
    id
  }
}
    `;
export type DeleteAnswersMutationFn = Apollo.MutationFunction<DeleteAnswersMutation, DeleteAnswersMutationVariables>;

/**
 * __useDeleteAnswersMutation__
 *
 * To run a mutation, you first call `useDeleteAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnswersMutation, { data, loading, error }] = useDeleteAnswersMutation({
 *   variables: {
 *      deleteAnswersInput: // value for 'deleteAnswersInput'
 *   },
 * });
 */
export function useDeleteAnswersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnswersMutation, DeleteAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnswersMutation, DeleteAnswersMutationVariables>(DeleteAnswersDocument, options);
      }
export type DeleteAnswersMutationHookResult = ReturnType<typeof useDeleteAnswersMutation>;
export type DeleteAnswersMutationResult = Apollo.MutationResult<DeleteAnswersMutation>;
export type DeleteAnswersMutationOptions = Apollo.BaseMutationOptions<DeleteAnswersMutation, DeleteAnswersMutationVariables>;
export const DeleteQuestionsDocument = gql`
    mutation DeleteQuestions($deleteQuestionsInput: DeleteQuestionsInput!) {
  deleteQuestions(deleteQuestionsInput: $deleteQuestionsInput) {
    id
  }
}
    `;
export type DeleteQuestionsMutationFn = Apollo.MutationFunction<DeleteQuestionsMutation, DeleteQuestionsMutationVariables>;

/**
 * __useDeleteQuestionsMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionsMutation, { data, loading, error }] = useDeleteQuestionsMutation({
 *   variables: {
 *      deleteQuestionsInput: // value for 'deleteQuestionsInput'
 *   },
 * });
 */
export function useDeleteQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuestionsMutation, DeleteQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuestionsMutation, DeleteQuestionsMutationVariables>(DeleteQuestionsDocument, options);
      }
export type DeleteQuestionsMutationHookResult = ReturnType<typeof useDeleteQuestionsMutation>;
export type DeleteQuestionsMutationResult = Apollo.MutationResult<DeleteQuestionsMutation>;
export type DeleteQuestionsMutationOptions = Apollo.BaseMutationOptions<DeleteQuestionsMutation, DeleteQuestionsMutationVariables>;
export const DeleteTopicDocument = gql`
    mutation DeleteTopic($topicId: ID!) {
  deleteTopic(topicId: $topicId)
}
    `;
export type DeleteTopicMutationFn = Apollo.MutationFunction<DeleteTopicMutation, DeleteTopicMutationVariables>;

/**
 * __useDeleteTopicMutation__
 *
 * To run a mutation, you first call `useDeleteTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTopicMutation, { data, loading, error }] = useDeleteTopicMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useDeleteTopicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTopicMutation, DeleteTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTopicMutation, DeleteTopicMutationVariables>(DeleteTopicDocument, options);
      }
export type DeleteTopicMutationHookResult = ReturnType<typeof useDeleteTopicMutation>;
export type DeleteTopicMutationResult = Apollo.MutationResult<DeleteTopicMutation>;
export type DeleteTopicMutationOptions = Apollo.BaseMutationOptions<DeleteTopicMutation, DeleteTopicMutationVariables>;
export const ExportQuestionsDocument = gql`
    mutation ExportQuestions($exportQuestionInput: ExportQuestionInput!) {
  exportQuestions(exportQuestionInput: $exportQuestionInput) {
    downloadLink
  }
}
    `;
export type ExportQuestionsMutationFn = Apollo.MutationFunction<ExportQuestionsMutation, ExportQuestionsMutationVariables>;

/**
 * __useExportQuestionsMutation__
 *
 * To run a mutation, you first call `useExportQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportQuestionsMutation, { data, loading, error }] = useExportQuestionsMutation({
 *   variables: {
 *      exportQuestionInput: // value for 'exportQuestionInput'
 *   },
 * });
 */
export function useExportQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<ExportQuestionsMutation, ExportQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportQuestionsMutation, ExportQuestionsMutationVariables>(ExportQuestionsDocument, options);
      }
export type ExportQuestionsMutationHookResult = ReturnType<typeof useExportQuestionsMutation>;
export type ExportQuestionsMutationResult = Apollo.MutationResult<ExportQuestionsMutation>;
export type ExportQuestionsMutationOptions = Apollo.BaseMutationOptions<ExportQuestionsMutation, ExportQuestionsMutationVariables>;
export const GetOneQuestionDocument = gql`
    query GetOneQuestion($questionId: ID!) {
  question(questionId: $questionId) {
    id
    publicId
    title
    priority
    resolutionStatus
    assignedTopics {
      id
      name
    }
    description
    isAnswered
    answersCount
    createdBy {
      id
      firstName
      lastName
      email
      pictureURL
    }
    resources {
      id
      name
      type
      mimeType
    }
    owners {
      id
      email
      firstName
      lastName
      pictureURL
    }
    groups {
      id
      name
      color
    }
    createdAt
    updatedAt
    hasConfirmedAnswer
    duplicateQuestionIds
    duplicates {
      id
      publicId
      title
      answersCount
      createdAt
      latestAnswer {
        id
        description
        resources {
          id
          name
          type
          mimeType
        }
      }
    }
  }
}
    `;

/**
 * __useGetOneQuestionQuery__
 *
 * To run a query within a React component, call `useGetOneQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneQuestionQuery({
 *   variables: {
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useGetOneQuestionQuery(baseOptions: Apollo.QueryHookOptions<GetOneQuestionQuery, GetOneQuestionQueryVariables> & ({ variables: GetOneQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneQuestionQuery, GetOneQuestionQueryVariables>(GetOneQuestionDocument, options);
      }
export function useGetOneQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneQuestionQuery, GetOneQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneQuestionQuery, GetOneQuestionQueryVariables>(GetOneQuestionDocument, options);
        }
// @ts-ignore
export function useGetOneQuestionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOneQuestionQuery, GetOneQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneQuestionQuery, GetOneQuestionQueryVariables>;
export function useGetOneQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneQuestionQuery, GetOneQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneQuestionQuery | undefined, GetOneQuestionQueryVariables>;
export function useGetOneQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneQuestionQuery, GetOneQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneQuestionQuery, GetOneQuestionQueryVariables>(GetOneQuestionDocument, options);
        }
export type GetOneQuestionQueryHookResult = ReturnType<typeof useGetOneQuestionQuery>;
export type GetOneQuestionLazyQueryHookResult = ReturnType<typeof useGetOneQuestionLazyQuery>;
export type GetOneQuestionSuspenseQueryHookResult = ReturnType<typeof useGetOneQuestionSuspenseQuery>;
export type GetOneQuestionQueryResult = Apollo.QueryResult<GetOneQuestionQuery, GetOneQuestionQueryVariables>;
export const GetThreadDocument = gql`
    query GetThread($filter: ThreadArgsFilter!, $limit: Int, $offset: Int, $sorter: ThreadArgsSorter) {
  thread(filter: $filter, limit: $limit, offset: $offset, sorter: $sorter) {
    nodes {
      id
      description
      parentQuestionId
      isConfirmed
      isFollowUp
      editedAt
      createdBy {
        id
        firstName
        lastName
        email
        pictureURL
      }
      resources {
        id
        name
        type
        mimeType
      }
      readReceipts {
        user {
          id
          firstName
          lastName
          email
          pictureURL
        }
        readAt
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetThreadQuery__
 *
 * To run a query within a React component, call `useGetThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useGetThreadQuery(baseOptions: Apollo.QueryHookOptions<GetThreadQuery, GetThreadQueryVariables> & ({ variables: GetThreadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreadQuery, GetThreadQueryVariables>(GetThreadDocument, options);
      }
export function useGetThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThreadQuery, GetThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreadQuery, GetThreadQueryVariables>(GetThreadDocument, options);
        }
// @ts-ignore
export function useGetThreadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetThreadQuery, GetThreadQueryVariables>): Apollo.UseSuspenseQueryResult<GetThreadQuery, GetThreadQueryVariables>;
export function useGetThreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThreadQuery, GetThreadQueryVariables>): Apollo.UseSuspenseQueryResult<GetThreadQuery | undefined, GetThreadQueryVariables>;
export function useGetThreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThreadQuery, GetThreadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetThreadQuery, GetThreadQueryVariables>(GetThreadDocument, options);
        }
export type GetThreadQueryHookResult = ReturnType<typeof useGetThreadQuery>;
export type GetThreadLazyQueryHookResult = ReturnType<typeof useGetThreadLazyQuery>;
export type GetThreadSuspenseQueryHookResult = ReturnType<typeof useGetThreadSuspenseQuery>;
export type GetThreadQueryResult = Apollo.QueryResult<GetThreadQuery, GetThreadQueryVariables>;
export const TopicsDocument = gql`
    query Topics($workspaceId: ID!, $sorter: TopicSorter) {
  topics(workspaceId: $workspaceId, sorter: $sorter) {
    id
    name
    createdAt
    assignedUsers {
      id
      email
      firstName
      lastName
      pictureURL
      activityStatus
    }
  }
}
    `;

/**
 * __useTopicsQuery__
 *
 * To run a query within a React component, call `useTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useTopicsQuery(baseOptions: Apollo.QueryHookOptions<TopicsQuery, TopicsQueryVariables> & ({ variables: TopicsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopicsQuery, TopicsQueryVariables>(TopicsDocument, options);
      }
export function useTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopicsQuery, TopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopicsQuery, TopicsQueryVariables>(TopicsDocument, options);
        }
// @ts-ignore
export function useTopicsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TopicsQuery, TopicsQueryVariables>): Apollo.UseSuspenseQueryResult<TopicsQuery, TopicsQueryVariables>;
export function useTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopicsQuery, TopicsQueryVariables>): Apollo.UseSuspenseQueryResult<TopicsQuery | undefined, TopicsQueryVariables>;
export function useTopicsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopicsQuery, TopicsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopicsQuery, TopicsQueryVariables>(TopicsDocument, options);
        }
export type TopicsQueryHookResult = ReturnType<typeof useTopicsQuery>;
export type TopicsLazyQueryHookResult = ReturnType<typeof useTopicsLazyQuery>;
export type TopicsSuspenseQueryHookResult = ReturnType<typeof useTopicsSuspenseQuery>;
export type TopicsQueryResult = Apollo.QueryResult<TopicsQuery, TopicsQueryVariables>;
export const ListQuestionsDocument = gql`
    query ListQuestions($filter: QuestionArgsFilter!, $limit: Int, $offset: Int, $sorter: QuestionArgSorter) {
  questions(filter: $filter, limit: $limit, offset: $offset, sorter: $sorter) {
    pageInfo {
      totalCount
      offset
    }
    nodes {
      ...QuestionListItem
    }
  }
}
    ${QuestionListItemFragmentDoc}`;

/**
 * __useListQuestionsQuery__
 *
 * To run a query within a React component, call `useListQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListQuestionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *   },
 * });
 */
export function useListQuestionsQuery(baseOptions: Apollo.QueryHookOptions<ListQuestionsQuery, ListQuestionsQueryVariables> & ({ variables: ListQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListQuestionsQuery, ListQuestionsQueryVariables>(ListQuestionsDocument, options);
      }
export function useListQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListQuestionsQuery, ListQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListQuestionsQuery, ListQuestionsQueryVariables>(ListQuestionsDocument, options);
        }
// @ts-ignore
export function useListQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListQuestionsQuery, ListQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListQuestionsQuery, ListQuestionsQueryVariables>;
export function useListQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListQuestionsQuery, ListQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListQuestionsQuery | undefined, ListQuestionsQueryVariables>;
export function useListQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListQuestionsQuery, ListQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListQuestionsQuery, ListQuestionsQueryVariables>(ListQuestionsDocument, options);
        }
export type ListQuestionsQueryHookResult = ReturnType<typeof useListQuestionsQuery>;
export type ListQuestionsLazyQueryHookResult = ReturnType<typeof useListQuestionsLazyQuery>;
export type ListQuestionsSuspenseQueryHookResult = ReturnType<typeof useListQuestionsSuspenseQuery>;
export type ListQuestionsQueryResult = Apollo.QueryResult<ListQuestionsQuery, ListQuestionsQueryVariables>;
export const MarkAnswersAsReadDocument = gql`
    mutation MarkAnswersAsRead($markAnswersAsReadInput: MarkAnswersAsReadInput!) {
  markAnswersAsRead(markAnswersAsReadInput: $markAnswersAsReadInput)
}
    `;
export type MarkAnswersAsReadMutationFn = Apollo.MutationFunction<MarkAnswersAsReadMutation, MarkAnswersAsReadMutationVariables>;

/**
 * __useMarkAnswersAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAnswersAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAnswersAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAnswersAsReadMutation, { data, loading, error }] = useMarkAnswersAsReadMutation({
 *   variables: {
 *      markAnswersAsReadInput: // value for 'markAnswersAsReadInput'
 *   },
 * });
 */
export function useMarkAnswersAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAnswersAsReadMutation, MarkAnswersAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAnswersAsReadMutation, MarkAnswersAsReadMutationVariables>(MarkAnswersAsReadDocument, options);
      }
export type MarkAnswersAsReadMutationHookResult = ReturnType<typeof useMarkAnswersAsReadMutation>;
export type MarkAnswersAsReadMutationResult = Apollo.MutationResult<MarkAnswersAsReadMutation>;
export type MarkAnswersAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAnswersAsReadMutation, MarkAnswersAsReadMutationVariables>;
export const MarkQuestionAsReadDocument = gql`
    mutation MarkQuestionAsRead($markQuestionAsReadInput: MarkQuestionAsReadInput!) {
  markQuestionAsRead(markQuestionAsReadInput: $markQuestionAsReadInput)
}
    `;
export type MarkQuestionAsReadMutationFn = Apollo.MutationFunction<MarkQuestionAsReadMutation, MarkQuestionAsReadMutationVariables>;

/**
 * __useMarkQuestionAsReadMutation__
 *
 * To run a mutation, you first call `useMarkQuestionAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkQuestionAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markQuestionAsReadMutation, { data, loading, error }] = useMarkQuestionAsReadMutation({
 *   variables: {
 *      markQuestionAsReadInput: // value for 'markQuestionAsReadInput'
 *   },
 * });
 */
export function useMarkQuestionAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkQuestionAsReadMutation, MarkQuestionAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkQuestionAsReadMutation, MarkQuestionAsReadMutationVariables>(MarkQuestionAsReadDocument, options);
      }
export type MarkQuestionAsReadMutationHookResult = ReturnType<typeof useMarkQuestionAsReadMutation>;
export type MarkQuestionAsReadMutationResult = Apollo.MutationResult<MarkQuestionAsReadMutation>;
export type MarkQuestionAsReadMutationOptions = Apollo.BaseMutationOptions<MarkQuestionAsReadMutation, MarkQuestionAsReadMutationVariables>;
export const ReplyInThreadDocument = gql`
    mutation ReplyInThread($replyInThreadInput: ReplyInThreadInput!) {
  replyInThread(replyInThreadInput: $replyInThreadInput) {
    id
    description
    createdBy {
      firstName
      lastName
      email
      pictureURL
    }
    resources {
      id
      name
      type
      mimeType
    }
    createdAt
    updatedAt
  }
}
    `;
export type ReplyInThreadMutationFn = Apollo.MutationFunction<ReplyInThreadMutation, ReplyInThreadMutationVariables>;

/**
 * __useReplyInThreadMutation__
 *
 * To run a mutation, you first call `useReplyInThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyInThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyInThreadMutation, { data, loading, error }] = useReplyInThreadMutation({
 *   variables: {
 *      replyInThreadInput: // value for 'replyInThreadInput'
 *   },
 * });
 */
export function useReplyInThreadMutation(baseOptions?: Apollo.MutationHookOptions<ReplyInThreadMutation, ReplyInThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplyInThreadMutation, ReplyInThreadMutationVariables>(ReplyInThreadDocument, options);
      }
export type ReplyInThreadMutationHookResult = ReturnType<typeof useReplyInThreadMutation>;
export type ReplyInThreadMutationResult = Apollo.MutationResult<ReplyInThreadMutation>;
export type ReplyInThreadMutationOptions = Apollo.BaseMutationOptions<ReplyInThreadMutation, ReplyInThreadMutationVariables>;
export const ToggleWorkspaceSupportStatusDocument = gql`
    mutation ToggleWorkspaceSupportStatus($workspaceId: ID!) {
  toggleWorkspaceSupportStatus(workspaceId: $workspaceId) {
    id
    name
    supportStatus
  }
}
    `;
export type ToggleWorkspaceSupportStatusMutationFn = Apollo.MutationFunction<ToggleWorkspaceSupportStatusMutation, ToggleWorkspaceSupportStatusMutationVariables>;

/**
 * __useToggleWorkspaceSupportStatusMutation__
 *
 * To run a mutation, you first call `useToggleWorkspaceSupportStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleWorkspaceSupportStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleWorkspaceSupportStatusMutation, { data, loading, error }] = useToggleWorkspaceSupportStatusMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useToggleWorkspaceSupportStatusMutation(baseOptions?: Apollo.MutationHookOptions<ToggleWorkspaceSupportStatusMutation, ToggleWorkspaceSupportStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleWorkspaceSupportStatusMutation, ToggleWorkspaceSupportStatusMutationVariables>(ToggleWorkspaceSupportStatusDocument, options);
      }
export type ToggleWorkspaceSupportStatusMutationHookResult = ReturnType<typeof useToggleWorkspaceSupportStatusMutation>;
export type ToggleWorkspaceSupportStatusMutationResult = Apollo.MutationResult<ToggleWorkspaceSupportStatusMutation>;
export type ToggleWorkspaceSupportStatusMutationOptions = Apollo.BaseMutationOptions<ToggleWorkspaceSupportStatusMutation, ToggleWorkspaceSupportStatusMutationVariables>;
export const UnconfirmAnswerDocument = gql`
    mutation UnconfirmAnswer($unconfirmAnswerInput: UnconfirmAnswerInput!) {
  unconfirmAnswer(unconfirmAnswerInput: $unconfirmAnswerInput) {
    id
  }
}
    `;
export type UnconfirmAnswerMutationFn = Apollo.MutationFunction<UnconfirmAnswerMutation, UnconfirmAnswerMutationVariables>;

/**
 * __useUnconfirmAnswerMutation__
 *
 * To run a mutation, you first call `useUnconfirmAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnconfirmAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unconfirmAnswerMutation, { data, loading, error }] = useUnconfirmAnswerMutation({
 *   variables: {
 *      unconfirmAnswerInput: // value for 'unconfirmAnswerInput'
 *   },
 * });
 */
export function useUnconfirmAnswerMutation(baseOptions?: Apollo.MutationHookOptions<UnconfirmAnswerMutation, UnconfirmAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnconfirmAnswerMutation, UnconfirmAnswerMutationVariables>(UnconfirmAnswerDocument, options);
      }
export type UnconfirmAnswerMutationHookResult = ReturnType<typeof useUnconfirmAnswerMutation>;
export type UnconfirmAnswerMutationResult = Apollo.MutationResult<UnconfirmAnswerMutation>;
export type UnconfirmAnswerMutationOptions = Apollo.BaseMutationOptions<UnconfirmAnswerMutation, UnconfirmAnswerMutationVariables>;
export const UpdateAnswerDocument = gql`
    mutation UpdateAnswer($updateAnswerInput: UpdateAnswerInput!) {
  updateAnswer(updateAnswerInput: $updateAnswerInput) {
    id
    description
    parentQuestionId
    createdBy {
      firstName
      lastName
      email
      pictureURL
    }
    createdAt
    updatedAt
  }
}
    `;
export type UpdateAnswerMutationFn = Apollo.MutationFunction<UpdateAnswerMutation, UpdateAnswerMutationVariables>;

/**
 * __useUpdateAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnswerMutation, { data, loading, error }] = useUpdateAnswerMutation({
 *   variables: {
 *      updateAnswerInput: // value for 'updateAnswerInput'
 *   },
 * });
 */
export function useUpdateAnswerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnswerMutation, UpdateAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnswerMutation, UpdateAnswerMutationVariables>(UpdateAnswerDocument, options);
      }
export type UpdateAnswerMutationHookResult = ReturnType<typeof useUpdateAnswerMutation>;
export type UpdateAnswerMutationResult = Apollo.MutationResult<UpdateAnswerMutation>;
export type UpdateAnswerMutationOptions = Apollo.BaseMutationOptions<UpdateAnswerMutation, UpdateAnswerMutationVariables>;
export const UpdateQuestionDocument = gql`
    mutation UpdateQuestion($updateQuestionInput: UpdateQuestionInput!) {
  updateQuestion(updateQuestionInput: $updateQuestionInput) {
    id
    publicId
    title
    priority
    resolutionStatus
    description
    isAnswered
    answersCount
    resources {
      id
      name
      type
      mimeType
    }
    createdBy {
      firstName
      lastName
      email
      pictureURL
    }
    owners {
      id
      email
      firstName
      lastName
      pictureURL
    }
    groups {
      id
      name
      color
    }
    latestAnswer {
      id
      description
      isFollowUp
    }
    createdAt
    updatedAt
  }
}
    `;
export type UpdateQuestionMutationFn = Apollo.MutationFunction<UpdateQuestionMutation, UpdateQuestionMutationVariables>;

/**
 * __useUpdateQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionMutation, { data, loading, error }] = useUpdateQuestionMutation({
 *   variables: {
 *      updateQuestionInput: // value for 'updateQuestionInput'
 *   },
 * });
 */
export function useUpdateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionMutation, UpdateQuestionMutationVariables>(UpdateQuestionDocument, options);
      }
export type UpdateQuestionMutationHookResult = ReturnType<typeof useUpdateQuestionMutation>;
export type UpdateQuestionMutationResult = Apollo.MutationResult<UpdateQuestionMutation>;
export type UpdateQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionMutation, UpdateQuestionMutationVariables>;
export const UpdateQuestionGroupsDocument = gql`
    mutation UpdateQuestionGroups($updateQuestionGroupsInput: UpdateQuestionGroupsInput!) {
  updateQuestionGroups(updateQuestionGroupsInput: $updateQuestionGroupsInput) {
    id
    groups {
      id
      name
      color
    }
  }
}
    `;
export type UpdateQuestionGroupsMutationFn = Apollo.MutationFunction<UpdateQuestionGroupsMutation, UpdateQuestionGroupsMutationVariables>;

/**
 * __useUpdateQuestionGroupsMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionGroupsMutation, { data, loading, error }] = useUpdateQuestionGroupsMutation({
 *   variables: {
 *      updateQuestionGroupsInput: // value for 'updateQuestionGroupsInput'
 *   },
 * });
 */
export function useUpdateQuestionGroupsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionGroupsMutation, UpdateQuestionGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionGroupsMutation, UpdateQuestionGroupsMutationVariables>(UpdateQuestionGroupsDocument, options);
      }
export type UpdateQuestionGroupsMutationHookResult = ReturnType<typeof useUpdateQuestionGroupsMutation>;
export type UpdateQuestionGroupsMutationResult = Apollo.MutationResult<UpdateQuestionGroupsMutation>;
export type UpdateQuestionGroupsMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionGroupsMutation, UpdateQuestionGroupsMutationVariables>;
export const UpdateQuestionPriorityDocument = gql`
    mutation UpdateQuestionPriority($updateQuestionPriorityInput: UpdateQuestionPriorityInput!) {
  updateQuestionPriority(
    updateQuestionPriorityInput: $updateQuestionPriorityInput
  ) {
    id
    priority
  }
}
    `;
export type UpdateQuestionPriorityMutationFn = Apollo.MutationFunction<UpdateQuestionPriorityMutation, UpdateQuestionPriorityMutationVariables>;

/**
 * __useUpdateQuestionPriorityMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionPriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionPriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionPriorityMutation, { data, loading, error }] = useUpdateQuestionPriorityMutation({
 *   variables: {
 *      updateQuestionPriorityInput: // value for 'updateQuestionPriorityInput'
 *   },
 * });
 */
export function useUpdateQuestionPriorityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionPriorityMutation, UpdateQuestionPriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionPriorityMutation, UpdateQuestionPriorityMutationVariables>(UpdateQuestionPriorityDocument, options);
      }
export type UpdateQuestionPriorityMutationHookResult = ReturnType<typeof useUpdateQuestionPriorityMutation>;
export type UpdateQuestionPriorityMutationResult = Apollo.MutationResult<UpdateQuestionPriorityMutation>;
export type UpdateQuestionPriorityMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionPriorityMutation, UpdateQuestionPriorityMutationVariables>;
export const UpdateQuestionResolutionStatusDocument = gql`
    mutation UpdateQuestionResolutionStatus($updateQuestionResolutionStatusInput: UpdateQuestionResolutionStatusInput!) {
  updateQuestionResolutionStatus(
    updateQuestionResolutionStatusInput: $updateQuestionResolutionStatusInput
  ) {
    id
    resolutionStatus
  }
}
    `;
export type UpdateQuestionResolutionStatusMutationFn = Apollo.MutationFunction<UpdateQuestionResolutionStatusMutation, UpdateQuestionResolutionStatusMutationVariables>;

/**
 * __useUpdateQuestionResolutionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionResolutionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionResolutionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionResolutionStatusMutation, { data, loading, error }] = useUpdateQuestionResolutionStatusMutation({
 *   variables: {
 *      updateQuestionResolutionStatusInput: // value for 'updateQuestionResolutionStatusInput'
 *   },
 * });
 */
export function useUpdateQuestionResolutionStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionResolutionStatusMutation, UpdateQuestionResolutionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionResolutionStatusMutation, UpdateQuestionResolutionStatusMutationVariables>(UpdateQuestionResolutionStatusDocument, options);
      }
export type UpdateQuestionResolutionStatusMutationHookResult = ReturnType<typeof useUpdateQuestionResolutionStatusMutation>;
export type UpdateQuestionResolutionStatusMutationResult = Apollo.MutationResult<UpdateQuestionResolutionStatusMutation>;
export type UpdateQuestionResolutionStatusMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionResolutionStatusMutation, UpdateQuestionResolutionStatusMutationVariables>;
export const UpdateQuestionTopicsDocument = gql`
    mutation UpdateQuestionTopics($updateQuestionTopicsInput: UpdateQuestionTopicsInput!) {
  updateQuestionTopics(updateQuestionTopicsInput: $updateQuestionTopicsInput) {
    id
  }
}
    `;
export type UpdateQuestionTopicsMutationFn = Apollo.MutationFunction<UpdateQuestionTopicsMutation, UpdateQuestionTopicsMutationVariables>;

/**
 * __useUpdateQuestionTopicsMutation__
 *
 * To run a mutation, you first call `useUpdateQuestionTopicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuestionTopicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuestionTopicsMutation, { data, loading, error }] = useUpdateQuestionTopicsMutation({
 *   variables: {
 *      updateQuestionTopicsInput: // value for 'updateQuestionTopicsInput'
 *   },
 * });
 */
export function useUpdateQuestionTopicsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuestionTopicsMutation, UpdateQuestionTopicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuestionTopicsMutation, UpdateQuestionTopicsMutationVariables>(UpdateQuestionTopicsDocument, options);
      }
export type UpdateQuestionTopicsMutationHookResult = ReturnType<typeof useUpdateQuestionTopicsMutation>;
export type UpdateQuestionTopicsMutationResult = Apollo.MutationResult<UpdateQuestionTopicsMutation>;
export type UpdateQuestionTopicsMutationOptions = Apollo.BaseMutationOptions<UpdateQuestionTopicsMutation, UpdateQuestionTopicsMutationVariables>;
export const UpdateTopicDocument = gql`
    mutation UpdateTopic($input: UpdateTopicInput!) {
  updateTopic(input: $input) {
    id
    name
  }
}
    `;
export type UpdateTopicMutationFn = Apollo.MutationFunction<UpdateTopicMutation, UpdateTopicMutationVariables>;

/**
 * __useUpdateTopicMutation__
 *
 * To run a mutation, you first call `useUpdateTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTopicMutation, { data, loading, error }] = useUpdateTopicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTopicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTopicMutation, UpdateTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTopicMutation, UpdateTopicMutationVariables>(UpdateTopicDocument, options);
      }
export type UpdateTopicMutationHookResult = ReturnType<typeof useUpdateTopicMutation>;
export type UpdateTopicMutationResult = Apollo.MutationResult<UpdateTopicMutation>;
export type UpdateTopicMutationOptions = Apollo.BaseMutationOptions<UpdateTopicMutation, UpdateTopicMutationVariables>;
export const UpdateTopicUserAssignmentsDocument = gql`
    mutation UpdateTopicUserAssignments($input: UpdateTopicUserAssignmentsInput!) {
  updateTopicUserAssignments(input: $input) {
    id
    name
    assignedUsers {
      id
      email
      firstName
      lastName
      pictureURL
      activityStatus
    }
  }
}
    `;
export type UpdateTopicUserAssignmentsMutationFn = Apollo.MutationFunction<UpdateTopicUserAssignmentsMutation, UpdateTopicUserAssignmentsMutationVariables>;

/**
 * __useUpdateTopicUserAssignmentsMutation__
 *
 * To run a mutation, you first call `useUpdateTopicUserAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTopicUserAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTopicUserAssignmentsMutation, { data, loading, error }] = useUpdateTopicUserAssignmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTopicUserAssignmentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTopicUserAssignmentsMutation, UpdateTopicUserAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTopicUserAssignmentsMutation, UpdateTopicUserAssignmentsMutationVariables>(UpdateTopicUserAssignmentsDocument, options);
      }
export type UpdateTopicUserAssignmentsMutationHookResult = ReturnType<typeof useUpdateTopicUserAssignmentsMutation>;
export type UpdateTopicUserAssignmentsMutationResult = Apollo.MutationResult<UpdateTopicUserAssignmentsMutation>;
export type UpdateTopicUserAssignmentsMutationOptions = Apollo.BaseMutationOptions<UpdateTopicUserAssignmentsMutation, UpdateTopicUserAssignmentsMutationVariables>;
export const GetOneUserDocument = gql`
    query GetOneUser($userId: ID!, $workspaceId: ID!) {
  user(id: $userId, workspaceId: $workspaceId) {
    id
    auth0Id
    firstName
    lastName
    email
    pictureURL
    createdAt
    groups(workspaceId: $workspaceId) {
      id
      name
      color
    }
  }
}
    `;

/**
 * __useGetOneUserQuery__
 *
 * To run a query within a React component, call `useGetOneUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetOneUserQuery(baseOptions: Apollo.QueryHookOptions<GetOneUserQuery, GetOneUserQueryVariables> & ({ variables: GetOneUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneUserQuery, GetOneUserQueryVariables>(GetOneUserDocument, options);
      }
export function useGetOneUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneUserQuery, GetOneUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneUserQuery, GetOneUserQueryVariables>(GetOneUserDocument, options);
        }
// @ts-ignore
export function useGetOneUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOneUserQuery, GetOneUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneUserQuery, GetOneUserQueryVariables>;
export function useGetOneUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneUserQuery, GetOneUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetOneUserQuery | undefined, GetOneUserQueryVariables>;
export function useGetOneUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneUserQuery, GetOneUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneUserQuery, GetOneUserQueryVariables>(GetOneUserDocument, options);
        }
export type GetOneUserQueryHookResult = ReturnType<typeof useGetOneUserQuery>;
export type GetOneUserLazyQueryHookResult = ReturnType<typeof useGetOneUserLazyQuery>;
export type GetOneUserSuspenseQueryHookResult = ReturnType<typeof useGetOneUserSuspenseQuery>;
export type GetOneUserQueryResult = Apollo.QueryResult<GetOneUserQuery, GetOneUserQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($filter: UserArgsFilter!, $limit: Int, $offset: Int, $sorter: UserArgsSorter, $workspaceId: ID!) {
  users(filter: $filter, limit: $limit, offset: $offset, sorter: $sorter) {
    nodes {
      ...UserListItem
    }
    pageInfo {
      offset
      totalCount
    }
  }
}
    ${UserListItemFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sorter: // value for 'sorter'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables> & ({ variables: GetUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery | undefined, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const RefreshOnlineStatusDocument = gql`
    mutation RefreshOnlineStatus {
  refreshOnlineStatus
}
    `;
export type RefreshOnlineStatusMutationFn = Apollo.MutationFunction<RefreshOnlineStatusMutation, RefreshOnlineStatusMutationVariables>;

/**
 * __useRefreshOnlineStatusMutation__
 *
 * To run a mutation, you first call `useRefreshOnlineStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshOnlineStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshOnlineStatusMutation, { data, loading, error }] = useRefreshOnlineStatusMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshOnlineStatusMutation(baseOptions?: Apollo.MutationHookOptions<RefreshOnlineStatusMutation, RefreshOnlineStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshOnlineStatusMutation, RefreshOnlineStatusMutationVariables>(RefreshOnlineStatusDocument, options);
      }
export type RefreshOnlineStatusMutationHookResult = ReturnType<typeof useRefreshOnlineStatusMutation>;
export type RefreshOnlineStatusMutationResult = Apollo.MutationResult<RefreshOnlineStatusMutation>;
export type RefreshOnlineStatusMutationOptions = Apollo.BaseMutationOptions<RefreshOnlineStatusMutation, RefreshOnlineStatusMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($updateUserInput: UpdateUserInput!) {
  updateUser(updateUserInput: $updateUserInput) {
    id
    firstName
    lastName
    email
    pictureURL
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      updateUserInput: // value for 'updateUserInput'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserGroupsDocument = gql`
    mutation UpdateUserGroups($updateGroupsInput: UpdateUserGroupsInput!) {
  updateGroups(updateGroupsInput: $updateGroupsInput) {
    id
    firstName
    lastName
    email
    pictureURL
  }
}
    `;
export type UpdateUserGroupsMutationFn = Apollo.MutationFunction<UpdateUserGroupsMutation, UpdateUserGroupsMutationVariables>;

/**
 * __useUpdateUserGroupsMutation__
 *
 * To run a mutation, you first call `useUpdateUserGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserGroupsMutation, { data, loading, error }] = useUpdateUserGroupsMutation({
 *   variables: {
 *      updateGroupsInput: // value for 'updateGroupsInput'
 *   },
 * });
 */
export function useUpdateUserGroupsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserGroupsMutation, UpdateUserGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserGroupsMutation, UpdateUserGroupsMutationVariables>(UpdateUserGroupsDocument, options);
      }
export type UpdateUserGroupsMutationHookResult = ReturnType<typeof useUpdateUserGroupsMutation>;
export type UpdateUserGroupsMutationResult = Apollo.MutationResult<UpdateUserGroupsMutation>;
export type UpdateUserGroupsMutationOptions = Apollo.BaseMutationOptions<UpdateUserGroupsMutation, UpdateUserGroupsMutationVariables>;
export const AddUsersToWorkspaceDocument = gql`
    mutation AddUsersToWorkspace($addUsersToWorkspaceInput: [AddUserToWorkspaceInput!]!, $workspaceId: ID!) {
  addUsersToWorkspace(
    addUsersToWorkspaceInput: $addUsersToWorkspaceInput
    workspaceId: $workspaceId
  ) {
    id
  }
}
    `;
export type AddUsersToWorkspaceMutationFn = Apollo.MutationFunction<AddUsersToWorkspaceMutation, AddUsersToWorkspaceMutationVariables>;

/**
 * __useAddUsersToWorkspaceMutation__
 *
 * To run a mutation, you first call `useAddUsersToWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUsersToWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUsersToWorkspaceMutation, { data, loading, error }] = useAddUsersToWorkspaceMutation({
 *   variables: {
 *      addUsersToWorkspaceInput: // value for 'addUsersToWorkspaceInput'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useAddUsersToWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<AddUsersToWorkspaceMutation, AddUsersToWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUsersToWorkspaceMutation, AddUsersToWorkspaceMutationVariables>(AddUsersToWorkspaceDocument, options);
      }
export type AddUsersToWorkspaceMutationHookResult = ReturnType<typeof useAddUsersToWorkspaceMutation>;
export type AddUsersToWorkspaceMutationResult = Apollo.MutationResult<AddUsersToWorkspaceMutation>;
export type AddUsersToWorkspaceMutationOptions = Apollo.BaseMutationOptions<AddUsersToWorkspaceMutation, AddUsersToWorkspaceMutationVariables>;
export const ArchiveWorkspaceDocument = gql`
    mutation ArchiveWorkspace($archiveWorkspaceId: ID!) {
  archiveWorkspace(id: $archiveWorkspaceId)
}
    `;
export type ArchiveWorkspaceMutationFn = Apollo.MutationFunction<ArchiveWorkspaceMutation, ArchiveWorkspaceMutationVariables>;

/**
 * __useArchiveWorkspaceMutation__
 *
 * To run a mutation, you first call `useArchiveWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveWorkspaceMutation, { data, loading, error }] = useArchiveWorkspaceMutation({
 *   variables: {
 *      archiveWorkspaceId: // value for 'archiveWorkspaceId'
 *   },
 * });
 */
export function useArchiveWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveWorkspaceMutation, ArchiveWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveWorkspaceMutation, ArchiveWorkspaceMutationVariables>(ArchiveWorkspaceDocument, options);
      }
export type ArchiveWorkspaceMutationHookResult = ReturnType<typeof useArchiveWorkspaceMutation>;
export type ArchiveWorkspaceMutationResult = Apollo.MutationResult<ArchiveWorkspaceMutation>;
export type ArchiveWorkspaceMutationOptions = Apollo.BaseMutationOptions<ArchiveWorkspaceMutation, ArchiveWorkspaceMutationVariables>;
export const ChangeWorkspaceUserRoleDocument = gql`
    mutation ChangeWorkspaceUserRole($userId: ID!, $workspaceId: ID!, $roleId: ID!) {
  changeWorkspaceUserRole(
    userId: $userId
    workspaceId: $workspaceId
    roleId: $roleId
  ) {
    id
    role {
      ...Role
    }
  }
}
    ${RoleFragmentDoc}`;
export type ChangeWorkspaceUserRoleMutationFn = Apollo.MutationFunction<ChangeWorkspaceUserRoleMutation, ChangeWorkspaceUserRoleMutationVariables>;

/**
 * __useChangeWorkspaceUserRoleMutation__
 *
 * To run a mutation, you first call `useChangeWorkspaceUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeWorkspaceUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeWorkspaceUserRoleMutation, { data, loading, error }] = useChangeWorkspaceUserRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      workspaceId: // value for 'workspaceId'
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useChangeWorkspaceUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<ChangeWorkspaceUserRoleMutation, ChangeWorkspaceUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeWorkspaceUserRoleMutation, ChangeWorkspaceUserRoleMutationVariables>(ChangeWorkspaceUserRoleDocument, options);
      }
export type ChangeWorkspaceUserRoleMutationHookResult = ReturnType<typeof useChangeWorkspaceUserRoleMutation>;
export type ChangeWorkspaceUserRoleMutationResult = Apollo.MutationResult<ChangeWorkspaceUserRoleMutation>;
export type ChangeWorkspaceUserRoleMutationOptions = Apollo.BaseMutationOptions<ChangeWorkspaceUserRoleMutation, ChangeWorkspaceUserRoleMutationVariables>;
export const CreateVisitActivityDocument = gql`
    mutation CreateVisitActivity($workspaceId: ID!) {
  createVisitActivity(workspaceId: $workspaceId)
}
    `;
export type CreateVisitActivityMutationFn = Apollo.MutationFunction<CreateVisitActivityMutation, CreateVisitActivityMutationVariables>;

/**
 * __useCreateVisitActivityMutation__
 *
 * To run a mutation, you first call `useCreateVisitActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVisitActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVisitActivityMutation, { data, loading, error }] = useCreateVisitActivityMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCreateVisitActivityMutation(baseOptions?: Apollo.MutationHookOptions<CreateVisitActivityMutation, CreateVisitActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVisitActivityMutation, CreateVisitActivityMutationVariables>(CreateVisitActivityDocument, options);
      }
export type CreateVisitActivityMutationHookResult = ReturnType<typeof useCreateVisitActivityMutation>;
export type CreateVisitActivityMutationResult = Apollo.MutationResult<CreateVisitActivityMutation>;
export type CreateVisitActivityMutationOptions = Apollo.BaseMutationOptions<CreateVisitActivityMutation, CreateVisitActivityMutationVariables>;
export const GetCurrentWorkspaceDocument = gql`
    query GetCurrentWorkspace($workspaceId: ID!) {
  workspace(id: $workspaceId) {
    id
    name
    status
    isPaymentActive
    isPaymentDetailsValidated
    processingStatus
    supportStatus
    tenant {
      id
      name
    }
    workspaceSettings {
      modules {
        analytics
        requestList
      }
    }
  }
}
    `;

/**
 * __useGetCurrentWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetCurrentWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentWorkspaceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetCurrentWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentWorkspaceQuery, GetCurrentWorkspaceQueryVariables> & ({ variables: GetCurrentWorkspaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentWorkspaceQuery, GetCurrentWorkspaceQueryVariables>(GetCurrentWorkspaceDocument, options);
      }
export function useGetCurrentWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentWorkspaceQuery, GetCurrentWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentWorkspaceQuery, GetCurrentWorkspaceQueryVariables>(GetCurrentWorkspaceDocument, options);
        }
// @ts-ignore
export function useGetCurrentWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentWorkspaceQuery, GetCurrentWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentWorkspaceQuery, GetCurrentWorkspaceQueryVariables>;
export function useGetCurrentWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentWorkspaceQuery, GetCurrentWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentWorkspaceQuery | undefined, GetCurrentWorkspaceQueryVariables>;
export function useGetCurrentWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentWorkspaceQuery, GetCurrentWorkspaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentWorkspaceQuery, GetCurrentWorkspaceQueryVariables>(GetCurrentWorkspaceDocument, options);
        }
export type GetCurrentWorkspaceQueryHookResult = ReturnType<typeof useGetCurrentWorkspaceQuery>;
export type GetCurrentWorkspaceLazyQueryHookResult = ReturnType<typeof useGetCurrentWorkspaceLazyQuery>;
export type GetCurrentWorkspaceSuspenseQueryHookResult = ReturnType<typeof useGetCurrentWorkspaceSuspenseQuery>;
export type GetCurrentWorkspaceQueryResult = Apollo.QueryResult<GetCurrentWorkspaceQuery, GetCurrentWorkspaceQueryVariables>;
export const GetWorkspaceSettingsDocument = gql`
    query GetWorkspaceSettings($workspaceId: ID!) {
  workspaceSettings(workspaceId: $workspaceId) {
    id
    adminContact
    loginPageBackgroundUrl
    themeColor
    indexationMethod
    watermarkForPermissions
    watermarkPresets
    updatedAt
    autoTopicAssignment
  }
}
    `;

/**
 * __useGetWorkspaceSettingsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSettingsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables> & ({ variables: GetWorkspaceSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>(GetWorkspaceSettingsDocument, options);
      }
export function useGetWorkspaceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>(GetWorkspaceSettingsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>;
export function useGetWorkspaceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceSettingsQuery | undefined, GetWorkspaceSettingsQueryVariables>;
export function useGetWorkspaceSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>(GetWorkspaceSettingsDocument, options);
        }
export type GetWorkspaceSettingsQueryHookResult = ReturnType<typeof useGetWorkspaceSettingsQuery>;
export type GetWorkspaceSettingsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceSettingsLazyQuery>;
export type GetWorkspaceSettingsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceSettingsSuspenseQuery>;
export type GetWorkspaceSettingsQueryResult = Apollo.QueryResult<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>;
export const MoveAndRankResourcesDocument = gql`
    mutation MoveAndRankResources($sourceId: String!, $targetId: String!, $workspaceId: String!, $parentId: ID) {
  moveAndRankResources(
    sourceId: $sourceId
    targetId: $targetId
    workspaceId: $workspaceId
    parentId: $parentId
  )
}
    `;
export type MoveAndRankResourcesMutationFn = Apollo.MutationFunction<MoveAndRankResourcesMutation, MoveAndRankResourcesMutationVariables>;

/**
 * __useMoveAndRankResourcesMutation__
 *
 * To run a mutation, you first call `useMoveAndRankResourcesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveAndRankResourcesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveAndRankResourcesMutation, { data, loading, error }] = useMoveAndRankResourcesMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      targetId: // value for 'targetId'
 *      workspaceId: // value for 'workspaceId'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useMoveAndRankResourcesMutation(baseOptions?: Apollo.MutationHookOptions<MoveAndRankResourcesMutation, MoveAndRankResourcesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveAndRankResourcesMutation, MoveAndRankResourcesMutationVariables>(MoveAndRankResourcesDocument, options);
      }
export type MoveAndRankResourcesMutationHookResult = ReturnType<typeof useMoveAndRankResourcesMutation>;
export type MoveAndRankResourcesMutationResult = Apollo.MutationResult<MoveAndRankResourcesMutation>;
export type MoveAndRankResourcesMutationOptions = Apollo.BaseMutationOptions<MoveAndRankResourcesMutation, MoveAndRankResourcesMutationVariables>;
export const ReindexWorkspaceDocument = gql`
    mutation ReindexWorkspace($workspaceId: ID!, $folderId: ID) {
  reindexWorkspace(id: $workspaceId, folderId: $folderId)
}
    `;
export type ReindexWorkspaceMutationFn = Apollo.MutationFunction<ReindexWorkspaceMutation, ReindexWorkspaceMutationVariables>;

/**
 * __useReindexWorkspaceMutation__
 *
 * To run a mutation, you first call `useReindexWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReindexWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reindexWorkspaceMutation, { data, loading, error }] = useReindexWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useReindexWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<ReindexWorkspaceMutation, ReindexWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReindexWorkspaceMutation, ReindexWorkspaceMutationVariables>(ReindexWorkspaceDocument, options);
      }
export type ReindexWorkspaceMutationHookResult = ReturnType<typeof useReindexWorkspaceMutation>;
export type ReindexWorkspaceMutationResult = Apollo.MutationResult<ReindexWorkspaceMutation>;
export type ReindexWorkspaceMutationOptions = Apollo.BaseMutationOptions<ReindexWorkspaceMutation, ReindexWorkspaceMutationVariables>;
export const ResendUserInviteDocument = gql`
    query ResendUserInvite($userToInviteId: ID!, $workspaceId: ID!) {
  resendUserInvite(userToInviteId: $userToInviteId, workspaceId: $workspaceId)
}
    `;

/**
 * __useResendUserInviteQuery__
 *
 * To run a query within a React component, call `useResendUserInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useResendUserInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResendUserInviteQuery({
 *   variables: {
 *      userToInviteId: // value for 'userToInviteId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useResendUserInviteQuery(baseOptions: Apollo.QueryHookOptions<ResendUserInviteQuery, ResendUserInviteQueryVariables> & ({ variables: ResendUserInviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResendUserInviteQuery, ResendUserInviteQueryVariables>(ResendUserInviteDocument, options);
      }
export function useResendUserInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResendUserInviteQuery, ResendUserInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResendUserInviteQuery, ResendUserInviteQueryVariables>(ResendUserInviteDocument, options);
        }
// @ts-ignore
export function useResendUserInviteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResendUserInviteQuery, ResendUserInviteQueryVariables>): Apollo.UseSuspenseQueryResult<ResendUserInviteQuery, ResendUserInviteQueryVariables>;
export function useResendUserInviteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResendUserInviteQuery, ResendUserInviteQueryVariables>): Apollo.UseSuspenseQueryResult<ResendUserInviteQuery | undefined, ResendUserInviteQueryVariables>;
export function useResendUserInviteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResendUserInviteQuery, ResendUserInviteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResendUserInviteQuery, ResendUserInviteQueryVariables>(ResendUserInviteDocument, options);
        }
export type ResendUserInviteQueryHookResult = ReturnType<typeof useResendUserInviteQuery>;
export type ResendUserInviteLazyQueryHookResult = ReturnType<typeof useResendUserInviteLazyQuery>;
export type ResendUserInviteSuspenseQueryHookResult = ReturnType<typeof useResendUserInviteSuspenseQuery>;
export type ResendUserInviteQueryResult = Apollo.QueryResult<ResendUserInviteQuery, ResendUserInviteQueryVariables>;
export const SendSummaryMailDocument = gql`
    mutation SendSummaryMail($workspaceId: ID!) {
  sendSummaryMail(id: $workspaceId)
}
    `;
export type SendSummaryMailMutationFn = Apollo.MutationFunction<SendSummaryMailMutation, SendSummaryMailMutationVariables>;

/**
 * __useSendSummaryMailMutation__
 *
 * To run a mutation, you first call `useSendSummaryMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSummaryMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSummaryMailMutation, { data, loading, error }] = useSendSummaryMailMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useSendSummaryMailMutation(baseOptions?: Apollo.MutationHookOptions<SendSummaryMailMutation, SendSummaryMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSummaryMailMutation, SendSummaryMailMutationVariables>(SendSummaryMailDocument, options);
      }
export type SendSummaryMailMutationHookResult = ReturnType<typeof useSendSummaryMailMutation>;
export type SendSummaryMailMutationResult = Apollo.MutationResult<SendSummaryMailMutation>;
export type SendSummaryMailMutationOptions = Apollo.BaseMutationOptions<SendSummaryMailMutation, SendSummaryMailMutationVariables>;
export const ToggleUserSuspendedDocument = gql`
    mutation ToggleUserSuspended($userId: ID!, $workspaceId: ID!) {
  toggleUserSuspended(userId: $userId, workspaceId: $workspaceId) {
    workspaceUsers {
      isSuspended
      user {
        id
        email
        lastName
        firstName
      }
    }
  }
}
    `;
export type ToggleUserSuspendedMutationFn = Apollo.MutationFunction<ToggleUserSuspendedMutation, ToggleUserSuspendedMutationVariables>;

/**
 * __useToggleUserSuspendedMutation__
 *
 * To run a mutation, you first call `useToggleUserSuspendedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUserSuspendedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUserSuspendedMutation, { data, loading, error }] = useToggleUserSuspendedMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useToggleUserSuspendedMutation(baseOptions?: Apollo.MutationHookOptions<ToggleUserSuspendedMutation, ToggleUserSuspendedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleUserSuspendedMutation, ToggleUserSuspendedMutationVariables>(ToggleUserSuspendedDocument, options);
      }
export type ToggleUserSuspendedMutationHookResult = ReturnType<typeof useToggleUserSuspendedMutation>;
export type ToggleUserSuspendedMutationResult = Apollo.MutationResult<ToggleUserSuspendedMutation>;
export type ToggleUserSuspendedMutationOptions = Apollo.BaseMutationOptions<ToggleUserSuspendedMutation, ToggleUserSuspendedMutationVariables>;
export const ToggleWorkspaceStatusDocument = gql`
    mutation ToggleWorkspaceStatus($workspaceId: ID!) {
  toggleWorkspaceStatus(workspaceId: $workspaceId) {
    id
    name
    status
  }
}
    `;
export type ToggleWorkspaceStatusMutationFn = Apollo.MutationFunction<ToggleWorkspaceStatusMutation, ToggleWorkspaceStatusMutationVariables>;

/**
 * __useToggleWorkspaceStatusMutation__
 *
 * To run a mutation, you first call `useToggleWorkspaceStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleWorkspaceStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleWorkspaceStatusMutation, { data, loading, error }] = useToggleWorkspaceStatusMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useToggleWorkspaceStatusMutation(baseOptions?: Apollo.MutationHookOptions<ToggleWorkspaceStatusMutation, ToggleWorkspaceStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleWorkspaceStatusMutation, ToggleWorkspaceStatusMutationVariables>(ToggleWorkspaceStatusDocument, options);
      }
export type ToggleWorkspaceStatusMutationHookResult = ReturnType<typeof useToggleWorkspaceStatusMutation>;
export type ToggleWorkspaceStatusMutationResult = Apollo.MutationResult<ToggleWorkspaceStatusMutation>;
export type ToggleWorkspaceStatusMutationOptions = Apollo.BaseMutationOptions<ToggleWorkspaceStatusMutation, ToggleWorkspaceStatusMutationVariables>;
export const UpdateWorkspaceDocument = gql`
    mutation UpdateWorkspace($updateWorkspaceId: ID!, $updateWorkspaceInput: UpdateWorkspaceInput!) {
  updateWorkspace(
    id: $updateWorkspaceId
    updateWorkspaceInput: $updateWorkspaceInput
  ) {
    id
    name
    logoUrl
  }
}
    `;
export type UpdateWorkspaceMutationFn = Apollo.MutationFunction<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>;

/**
 * __useUpdateWorkspaceMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMutation, { data, loading, error }] = useUpdateWorkspaceMutation({
 *   variables: {
 *      updateWorkspaceId: // value for 'updateWorkspaceId'
 *      updateWorkspaceInput: // value for 'updateWorkspaceInput'
 *   },
 * });
 */
export function useUpdateWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>(UpdateWorkspaceDocument, options);
      }
export type UpdateWorkspaceMutationHookResult = ReturnType<typeof useUpdateWorkspaceMutation>;
export type UpdateWorkspaceMutationResult = Apollo.MutationResult<UpdateWorkspaceMutation>;
export type UpdateWorkspaceMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>;
export const UpdatedWorkspaceSettingsDocument = gql`
    mutation UpdatedWorkspaceSettings($updateWorkspaceSettingsInput: UpdateWorkspaceSettingsInput!) {
  updatedWorkspaceSettings(
    updateWorkspaceSettingsInput: $updateWorkspaceSettingsInput
  ) {
    id
    adminContact
    loginPageBackgroundUrl
    themeColor
    indexationMethod
    watermarkForPermissions
    watermarkPresets
    updatedAt
    autoTopicAssignment
  }
}
    `;
export type UpdatedWorkspaceSettingsMutationFn = Apollo.MutationFunction<UpdatedWorkspaceSettingsMutation, UpdatedWorkspaceSettingsMutationVariables>;

/**
 * __useUpdatedWorkspaceSettingsMutation__
 *
 * To run a mutation, you first call `useUpdatedWorkspaceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatedWorkspaceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatedWorkspaceSettingsMutation, { data, loading, error }] = useUpdatedWorkspaceSettingsMutation({
 *   variables: {
 *      updateWorkspaceSettingsInput: // value for 'updateWorkspaceSettingsInput'
 *   },
 * });
 */
export function useUpdatedWorkspaceSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatedWorkspaceSettingsMutation, UpdatedWorkspaceSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatedWorkspaceSettingsMutation, UpdatedWorkspaceSettingsMutationVariables>(UpdatedWorkspaceSettingsDocument, options);
      }
export type UpdatedWorkspaceSettingsMutationHookResult = ReturnType<typeof useUpdatedWorkspaceSettingsMutation>;
export type UpdatedWorkspaceSettingsMutationResult = Apollo.MutationResult<UpdatedWorkspaceSettingsMutation>;
export type UpdatedWorkspaceSettingsMutationOptions = Apollo.BaseMutationOptions<UpdatedWorkspaceSettingsMutation, UpdatedWorkspaceSettingsMutationVariables>;
export const WorkspaceReindexedDocument = gql`
    subscription WorkspaceReindexed($workspaceId: ID!) {
  workspaceReindexed(workspaceId: $workspaceId)
}
    `;

/**
 * __useWorkspaceReindexedSubscription__
 *
 * To run a query within a React component, call `useWorkspaceReindexedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceReindexedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceReindexedSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useWorkspaceReindexedSubscription(baseOptions: Apollo.SubscriptionHookOptions<WorkspaceReindexedSubscription, WorkspaceReindexedSubscriptionVariables> & ({ variables: WorkspaceReindexedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WorkspaceReindexedSubscription, WorkspaceReindexedSubscriptionVariables>(WorkspaceReindexedDocument, options);
      }
export type WorkspaceReindexedSubscriptionHookResult = ReturnType<typeof useWorkspaceReindexedSubscription>;
export type WorkspaceReindexedSubscriptionResult = Apollo.SubscriptionResult<WorkspaceReindexedSubscription>;